var vl = Object.defineProperty;
var wl = (e, t, n) => t in e ? vl(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var x = (e, t, n) => wl(e, typeof t != "symbol" ? t + "" : t, n);
import { e as ri, r as ii, o as no, a as Pt, E as xt, b as Rl, c as si, g as Tl, d as Al, p as li, f as Cl, h as Fl, i as Pl, j as ci, k as Ke, l as _l, m as Ll, n as J, q as _, s as Ol, t as Dl, u as Bl, v as Ml, w as ai, x as Nl, y as $l, z as zl, A as Hl, B as Wl } from "./vocabulary-szTx2vy7.js";
import { C as kp, D as yp, F as Sp, G as Ep, H as Ip, I as vp, J as wp, K as Rp, L as Tp, M as Ap, N as Cp, O as Fp, P as Pp, Q as _p, R as Lp, S as Op, T as Dp, U as Bp, V as Mp, W as Np, X as $p, Y as zp, Z as Hp, _ as Wp, $ as Kp, a0 as jp, a1 as Gp, a2 as Vp, a3 as Up, a4 as Yp, a5 as qp, a6 as Xp, a7 as Jp, a8 as Zp, a9 as Qp, aa as tg, ab as eg, ac as ng, ad as og, ae as rg, af as ig, ag as sg, ah as lg, ai as cg, aj as ag, ak as dg, al as ug, am as fg, an as hg, ao as pg, ap as gg, aq as mg, ar as bg, as as xg, at as kg, au as yg, av as Sg, aw as Eg, ax as Ig, ay as vg, az as wg, aA as Rg, aB as Tg, aC as Ag } from "./vocabulary-szTx2vy7.js";
import { CSS_PX_PER_PT as ln, firstFamily as Kl } from "@messenger/consts";
import { d as jl, s as Gl, q as Xo, e as Vl, n as Ul } from "./normalize-font-stack-XXSwvGPG.js";
import { E as Yl } from "./root-families-DFfTBmN0.js";
const W = () => ({
  disposition: "stripped",
  reason: "arbitrary custom property (--*) stripped at ingest (Tailwind-preflight / Dark-Reader paste)"
}), bt = (e) => ({
  disposition: "stripped",
  reason: `editor-chrome / non-content stripped at ingest: ${e}`
}), Re = () => ({
  disposition: "forbidden",
  reason: "forbidden by the margin floor row (margin:0 reset; longhands forbidden likewise)"
}), ql = {
  "font-family": {
    disposition: "pinned",
    reason: "pin: bundled family resolved through the pinned fallback chain; forbids OS family names"
  },
  color: {
    disposition: "pinned",
    reason: "pin: sRGB-resolved (untagged = sRGB); removes per-display variance"
  },
  "background-color": {
    disposition: "pinned",
    reason: "pin: sRGB-resolved, transparent floor (box fill)"
  },
  "text-transform": {
    disposition: "pinned",
    reason: "pin: baked to literal cased text at resolve; emits text-transform:none"
  },
  "text-decoration": {
    disposition: "pinned",
    reason: "pin: floor none; the only authored axis is the line (underline)"
  },
  "text-underline-offset": {
    disposition: "pinned",
    reason: "accurate_within_engine: paint-only, engine-resolved; not author-settable"
  },
  "-webkit-text-stroke-width": {
    disposition: "pinned",
    reason: "accurate_within_engine: floor 0 (no stroke); paint-only"
  },
  "-webkit-text-stroke-color": {
    disposition: "pinned",
    reason: "pin: currentColor; sRGB-resolved, pairs with the stroke width"
  },
  "-webkit-text-fill-color": {
    disposition: "pinned",
    reason: "pin: currentColor; the glyph fill paired with the stroke outline"
  },
  "letter-spacing": {
    disposition: "pinned",
    reason: "accurate_within_engine: floor normal; deterministic only in the pinned engine"
  },
  "font-variant-ligatures": {
    disposition: "pinned",
    reason: "pin: floor normal; avoids UA / feature-default ambiguity"
  },
  "line-height": {
    disposition: "pinned",
    reason: "pin: explicit unitless multiplier; forbids normal (the vertical leak)"
  },
  "text-align": {
    disposition: "pinned",
    reason: "pin: floor start; physical left/right normalized to logical at ingest"
  },
  "white-space": {
    disposition: "pinned",
    reason: "pin: pre-wrap per block — preserve authored whitespace + segment breaks so the edit surface, preview, and PDF lay out identically; a `normal` floor would collapse \\n and let the editor (pre-wrap, for typed spaces) diverge from print"
  },
  margin: {
    disposition: "pinned",
    reason: "pin: floor 0; forbids non-zero (paragraph spacing owned by the block model)"
  },
  "font-size": {
    disposition: "author_choice",
    reason: "numeric author choice (pt); no floor pin"
  },
  "font-weight": {
    disposition: "author_choice",
    reason: "author choice (tag-based <strong>); FAKE-BOLD decides synthesis, no floor pin"
  },
  "font-style": {
    disposition: "author_choice",
    reason: "author choice (tag-based <em>); oblique <angle> forbidden (font-synthesis:none)"
  },
  "border-style": {
    disposition: "box_scope",
    reason: "box border appearance on editor_text_boxes; box appearance has no floor pin"
  },
  "border-width": {
    disposition: "box_scope",
    reason: "box border width on editor_text_boxes; a length stroke is engine-consistent"
  },
  "border-color": {
    disposition: "box_scope",
    reason: "box border color on editor_text_boxes, sRGB-resolved; no floor pin"
  },
  "border-radius": {
    disposition: "box_scope",
    reason: "box corner radius on editor_text_boxes; no floor pin"
  },
  padding: {
    disposition: "box_scope",
    reason: "box content inset on editor_text_boxes (feeds autosize); no engine-divergent value"
  },
  display: {
    disposition: "consumed",
    reason: "display:none consumed into the model hidden-node state at ingest; CSS display not emitted"
  },
  "--tw-border-spacing-x": W(),
  "--tw-border-spacing-y": W(),
  "--tw-translate-x": W(),
  "--tw-translate-y": W(),
  "--tw-rotate": W(),
  "--tw-skew-x": W(),
  "--tw-skew-y": W(),
  "--tw-scale-x": W(),
  "--tw-scale-y": W(),
  "--tw-scroll-snap-strictness": W(),
  "--tw-ring-offset-width": W(),
  "--tw-ring-offset-color": W(),
  "--tw-ring-color": W(),
  "--tw-ring-offset-shadow": W(),
  "--tw-ring-shadow": W(),
  "--tw-shadow": W(),
  "--tw-shadow-colored": W(),
  "--darkreader-inline-color": W(),
  "--darkreader-inline-bgcolor": W(),
  "-webkit-text-stroke": {
    disposition: "stripped",
    reason: "shorthand normalized to the -webkit-text-stroke-width/-color longhands at ingest"
  },
  background: {
    disposition: "stripped",
    reason: "shorthand; background-color is the emitted longhand; shorthand never stored or emitted"
  },
  "caret-color": bt(
    "the editor text caret; a frozen PDF has no caret"
  ),
  cursor: bt(
    "a pointer affordance; a frozen PDF has no pointer"
  ),
  "scroll-behavior": bt(
    "scrolling has no meaning on a fixed print canvas"
  ),
  "-webkit-tap-highlight-color": bt(
    "a mobile tap-highlight UI affordance"
  ),
  position: bt(
    "positioning is owned by the editor box layout, not author CSS"
  ),
  "box-sizing": bt(
    "the sizing model is owned by the box layout object"
  ),
  transition: bt(
    "motion is irrelevant to a frozen static-PDF render"
  ),
  outline: bt(
    "the editor focus-ring chrome; never emitted to the render surface"
  ),
  height: {
    disposition: "forbidden",
    reason: "avoid: box geometry owned by the layout object"
  },
  width: {
    disposition: "forbidden",
    reason: "avoid: box geometry owned by the layout object"
  },
  "vertical-align": {
    disposition: "forbidden",
    reason: "avoid: interacts with line-height divergently; sub/superscript is font-variant-position"
  },
  "-webkit-font-smoothing": {
    disposition: "forbidden",
    reason: "avoid: non-standard, macOS-only, pixel-only — a false sense of control"
  },
  "margin-top": Re(),
  "margin-right": Re(),
  "margin-bottom": Re(),
  "margin-left": Re(),
  float: {
    disposition: "forbidden",
    reason: "float layout is owned by the editor box model, not author CSS (paste)"
  },
  flex: {
    disposition: "forbidden",
    reason: "flex layout is owned by the editor box model (paste)"
  },
  "list-style": {
    disposition: "forbidden",
    reason: "list markers are produced by the editor document-model generated content, not author CSS"
  },
  "border-collapse": {
    disposition: "forbidden",
    reason: "table backcompat-render path only (no new tables authored)"
  },
  "white-space-collapse": {
    disposition: "forbidden",
    reason: "the white-space pin carries collapse behavior; this CSS Text 4 longhand is not authored"
  },
  "text-decoration-line": {
    disposition: "forbidden",
    reason: "the decoration line is authored via text_decoration; the raw longhand is not stored"
  },
  "padding-inline-start": {
    disposition: "forbidden",
    reason: "logical padding longhand from pasted lists; box padding is the uniform `padding`"
  }
}, Lh = (e) => ql[e], Xl = [
  {
    property: "margin",
    scope: "block",
    value: "0",
    emitted: !0,
    neutralizes: "the UA <p> block-margin default; paragraph spacing is owned by the block model"
  },
  {
    property: "padding",
    scope: "block",
    value: "0",
    emitted: !0,
    neutralizes: "the UA block padding default; the sibling reset of the margin:0 pin"
  },
  {
    property: "text-indent",
    scope: "block",
    value: "0",
    emitted: !0,
    neutralizes: "an inherited text-indent that would cascade into the block",
    note: "text-indent is author_choice (no floor pin); 0 is its un-set default, which a block may override"
  },
  {
    property: "white-space",
    scope: "block",
    value: "pre-wrap",
    emitted: !0,
    neutralizes: "the browser collapsing authored whitespace + segment breaks (\\n) — the lossy default that would let the editing surface (which pins pre-wrap to keep typed spaces) diverge from print. pre-wrap is the single deterministic source that makes editor == preview == PDF: \\n is a hard break and runs of spaces are preserved identically on every surface, while text still wraps at the box width"
  },
  {
    property: "word-break",
    scope: "block",
    value: "normal",
    emitted: !0,
    neutralizes: "the dictionary / auto-phrase UA analysis for the default"
  },
  {
    property: "overflow-wrap",
    scope: "block",
    value: "normal",
    emitted: !0,
    neutralizes: "the trigger + the word-wrap alias drift (Firefox historically word-wrap only)"
  },
  {
    property: "letter-spacing",
    scope: "character",
    value: "0",
    emitted: !0,
    neutralizes: "the spec-vs-reality tracking distribution gap (deterministic only in the pinned engine)",
    note: "the spec floor is `normal`; `0` is the computed equivalent the producer emits"
  },
  {
    property: "word-spacing",
    scope: "character",
    value: "0",
    emitted: !0,
    neutralizes: "the same spec-vs-reality gap as letter-spacing",
    note: "the spec floor is `normal`; `0` is the computed equivalent the producer emits"
  },
  {
    property: "text-decoration",
    scope: "character",
    value: "none",
    emitted: !0,
    neutralizes: "shorthand expansion divergence at the edges",
    note: "the `none` reset is benign — switch to text-decoration-line/-style/-color/-skip-ink when a real underline is authored"
  },
  {
    property: "text-transform",
    scope: "character",
    value: "none",
    emitted: !0,
    neutralizes: "the divergent UA case / word-boundary algorithm; the case is baked at resolve"
  },
  {
    property: "font-kerning",
    scope: "character",
    value: "normal",
    emitted: !0,
    neutralizes: "the UA's `auto` kerning discretion -> deterministic advances and breaks"
  },
  {
    property: "font-variant",
    scope: "character",
    value: "normal",
    emitted: !0,
    neutralizes: "UA / feature-default variant ambiguity",
    note: "the shorthand reset covers the per-axis font-variant-* pins (caps/numeric/position/east-asian/alternates/emoji)"
  },
  {
    property: "font-feature-settings",
    scope: "character",
    value: "normal",
    emitted: !0,
    neutralizes: "the engine's freedom to pick a default feature set",
    note: "`normal` resolves to the HarfBuzz default-on set (kern+liga+calt)"
  },
  {
    property: "font-synthesis",
    scope: "character",
    value: "none",
    emitted: !1,
    neutralizes: "engine-divergent faux bold / oblique / small-caps",
    note: "emitting `none` from the floor alone would kill authored faux bold; the global-level FAKE-BOLD row must carry the override first — emit it at the cascade fold, not from the floor alone"
  },
  {
    property: "font-optical-sizing",
    scope: "character",
    value: "none",
    emitted: !0,
    neutralizes: "the UA `auto` default re-engaging the optical axis on any VF that slips through",
    note: "CSS-initial `auto`; inert after VFs are pre-instantiated to static cuts at ingest (belt-and-suspenders against a VF slipping through)"
  },
  {
    property: "text-size-adjust",
    scope: "character",
    value: "none",
    emitted: !0,
    neutralizes: "a mobile auto-inflating UA rescaling text on the fixed print canvas",
    note: "inert on the desktop print canvas (mobile-only auto-inflation); the -webkit-/-moz-/-ms- aliases ride a later pass if a target engine needs them"
  },
  {
    property: "line-break",
    scope: "block",
    value: "normal",
    emitted: !0,
    neutralizes: "the UA-defined auto / loose / normal / strict rule set",
    note: "CSS-initial `auto`; Latin-neutral for the render corpus"
  },
  {
    property: "hyphens",
    scope: "block",
    value: "manual",
    emitted: !0,
    neutralizes: "per-engine, per-language hyphenation dictionaries",
    note: "`manual` is the CSS-initial — emitting it is a computed no-op that pins the value against an engine whose default differs"
  },
  {
    property: "text-wrap",
    scope: "block",
    value: "wrap",
    emitted: !0,
    neutralizes: "balance line-cap divergence (Chromium 6 vs Firefox 10) and UA-defined pretty",
    note: "`wrap` is the CSS-initial — emitting it is a computed no-op that pins it against an engine defaulting to balance/pretty"
  },
  {
    property: "tab-size",
    scope: "block",
    value: "4",
    emitted: !0,
    neutralizes: "the historically-divergent default (8 vs other) and at-risk <length> tab-size"
  },
  {
    property: "font-size",
    scope: "block",
    value: "0",
    emitted: !0,
    neutralizes: "the HOST context font leaking into every line box via the block STRUT: CSS sizes each line box at least the block's own font-size × line-height, and a block-with-runs emits no font-size of its own, so an inherited host font would set a per-line minimum the runs could not shrink below — and editor vs print would inherit different struts",
    note: "font-size is author_choice (no floor pin); 0 is its un-set default — the text-indent pattern. Runs always carry their own inline font-size, and every block emits its strut INLINE, overriding this class reset: a block with runs takes its tallest run’s font-size and family, so one face and one size set every line box and no line is the union of unlike run boxes, which browser builds size differently; a runless block takes the fold’s"
  }
], di = (e) => Xl.filter((t) => t.scope === e && t.emitted).map((t) => `${t.property}:${t.value}`).join(";") + ";", Jl = () => di("block"), Zl = () => di("character"), ui = "en", Ql = (e, t) => {
  const n = new Intl.Segmenter(t, { granularity: "word" }), o = new Intl.Segmenter(void 0, { granularity: "grapheme" });
  let r = "";
  for (const i of n.segment(e))
    if (i.isWordLike) {
      const [s, ...l] = Array.from(
        o.segment(i.segment),
        (c) => c.segment
      );
      r += (s ?? "").toLocaleUpperCase(t) + l.join("");
    } else
      r += i.segment;
  return r;
}, tc = (e, t, n) => {
  switch (t) {
    case "uppercase":
      return e.toLocaleUpperCase(n);
    case "lowercase":
      return e.toLocaleLowerCase(n);
    case "capitalize":
      return Ql(e, n);
    default:
      return e;
  }
}, ec = [
  "fontFamily",
  "fontSizePt",
  "fontWeight",
  "fontStyle",
  "color"
], nc = [
  "textAlign",
  "lineHeight",
  "fontSizePt",
  "overflowWrap"
], oc = (e, t) => {
  let n = "floor";
  for (const o of e)
    o.delta[t] !== void 0 && (n = o.layer);
  return n;
}, fi = (e, t, n, o, r) => {
  const i = no(t);
  return n.map((s) => ({
    documentId: e.documentId,
    pageId: e.pageId,
    containerId: e.containerId,
    property: s,
    winningLayer: oc(i, s),
    value: r[s],
    floorValue: o[s]
  }));
}, rc = (e, t) => {
  ri(t);
  const n = Pt(
    no(t).map((o) => o.delta)
  );
  return fi(
    e,
    t,
    ec,
    xt,
    n
  );
}, Oh = (e, t, n) => {
  const o = rc(e, t).find(
    (r) => r.property === n
  );
  if (!o)
    throw new Error(`trace: "${n}" is not a character-scope property`);
  return o;
}, Dh = (e, t) => {
  ri(t);
  const n = ii(
    no(t).map((o) => o.delta)
  );
  return fi(
    e,
    t,
    nc,
    Rl,
    n
  );
}, Bh = (e) => e.split(`
`).map((t) => {
  let n = "";
  for (const o of t)
    n += si.has(o) ? " " : o;
  return n.replace(/ {2,}/g, " ").replace(/^ +| +$/g, "");
}).join(`
`), hi = (e) => {
  const t = [];
  e.forEach((l, c) => {
    if (l.kind === "field") {
      t.push({ kind: "token", piece: c });
      return;
    }
    for (const a of l.text)
      t.push({
        kind: "char",
        ch: si.has(a) ? " " : a,
        piece: c
      });
  });
  const n = [];
  let o = !1, r = !0;
  for (const l of t) {
    if (l.kind === "token") {
      n.push(l), o = !1, r = !1;
      continue;
    }
    if (l.ch === `
`) {
      n.push(l), o = !1, r = !0;
      continue;
    }
    if (l.ch === " ") {
      if (o || r) continue;
      o = !0, n.push(l);
      continue;
    }
    o = !1, r = !1, n.push(l);
  }
  const i = [];
  let s = !0;
  for (let l = n.length - 1; l >= 0; l--) {
    const c = n[l];
    c.kind === "char" && c.ch === " " && s || (s = c.kind === "char" && c.ch === `
`, i.push(c));
  }
  return i.reverse(), Tl(e, Al(e, i));
}, cn = (e) => hi(e), Mh = (e) => li(cn(e)), yn = (e) => Math.max(0, Math.min(255, Math.round(e))).toString(16).padStart(2, "0"), ic = (e) => {
  const [t, n, o] = e;
  return `#${yn(t ?? 0)}${yn(n ?? 0)}${yn(o ?? 0)}`;
}, sc = (e, t) => {
  if ("colorId" in e) {
    const n = t.colors[e.colorId];
    if (n === void 0)
      throw new Error(
        `editor-document: color "${e.colorId}" is not in the document refs`
      );
    return Cl(n);
  }
  switch (e.kind) {
    case "transparent":
      return "transparent";
    case "current_color":
      return "currentColor";
    case "system":
      return e.verbatim;
    case "literal":
      return e.components.length >= 3 ? ic(e.components) : e.verbatim;
  }
}, lc = (e) => {
  if (e === "normal") return 400;
  if (e === "bold") return 700;
  const t = typeof e == "number" ? e : Number(e);
  return Number.isFinite(t) ? t : 400;
}, cc = (e) => {
  if (e === "normal" || e === "bold") return e;
  const t = Number(e);
  return Number.isFinite(t) ? String(t) : e;
}, me = (e) => {
  const t = {};
  for (const [n, o] of Object.entries(e))
    o != null && (t[n] = o);
  return t;
}, Te = (e) => e === null ? void 0 : { colorId: e }, ac = (e) => me({
  fontFamily: e.fontFamilyVerbatim ?? void 0,
  fontFamilyId: e.fontFamilyVerbatim === null ? e.fontFamilyId ?? void 0 : void 0,
  fontSize: e.fontSize,
  fontWeight: e.fontWeight === null ? void 0 : cc(e.fontWeight),
  fontStyle: e.fontStyle,
  fontSynthesis: e.fontSynthesis,
  fontKerning: e.fontKerning,
  fontFeatureSettings: e.fontFeatureSettings,
  fontVariantLigatures: e.fontVariantLigatures,
  fontVariantCaps: e.fontVariantCaps,
  fontVariantNumeric: e.fontVariantNumeric,
  fontVariantPosition: e.fontVariantPosition,
  fontVariantEastAsian: e.fontVariantEastAsian,
  fontVariantAlternates: e.fontVariantAlternates,
  fontVariantEmoji: e.fontVariantEmoji,
  letterSpacing: e.letterSpacing,
  wordSpacing: e.wordSpacing,
  color: Te(e.colorId),
  textDecoration: e.textDecoration,
  textDecorationColor: Te(e.textDecorationColorId),
  textCase: e.textCase,
  textStrokeWidth: e.textStrokeWidth,
  textStrokeColor: Te(e.textStrokeColorId),
  textFillColor: Te(e.textFillColorId),
  textRendering: e.textRendering,
  lineBreak: e.lineBreak,
  wordBreak: e.wordBreak,
  overflowWrap: e.overflowWrap,
  hyphens: e.hyphens,
  whiteSpace: e.whiteSpace,
  direction: e.direction,
  unicodeBidi: e.unicodeBidi,
  dirAttribute: e.dirAttribute
}), dc = (e) => me({
  fontSize: e.fontSize,
  lineHeight: e.lineHeight,
  textAlign: e.textAlign,
  textJustify: e.textJustify,
  textWrap: e.textWrap,
  textIndent: e.textIndent,
  tabSize: e.tabSize,
  hangingPunctuation: e.hangingPunctuation,
  lineBreak: e.lineBreak,
  wordBreak: e.wordBreak,
  overflowWrap: e.overflowWrap,
  hyphens: e.hyphens,
  whiteSpace: e.whiteSpace,
  direction: e.direction,
  unicodeBidi: e.unicodeBidi,
  dirAttribute: e.dirAttribute
}), pi = (e, t, n) => {
  const o = e.stylings[t];
  if (o === void 0)
    throw new Error(
      `editor-document: styling "${t}" is not in the document refs`
    );
  if (o.scope !== n)
    throw new Error(
      `editor-document: styling "${t}" is ${o.scope}-scope; a ${n}-scope styling was required`
    );
  return o;
}, wt = (e, t) => {
  if (e !== void 0)
    return "stylingId" in e ? ac(
      pi(t, e.stylingId, "character")
    ) : e;
}, oo = (e, t) => {
  if (e !== void 0)
    return "stylingId" in e ? dc(
      pi(t, e.stylingId, "block")
    ) : e;
}, uc = (e, t) => {
  var n;
  if (e.fontFamilyId !== void 0)
    return (n = t.fontFamilies[e.fontFamilyId]) == null ? void 0 : n.familyName;
  if (e.fontFamily !== void 0)
    return t.familyNameByVerbatim[e.fontFamily] ?? e.fontFamily;
}, Ae = (e, t) => {
  if (e !== void 0 && !("colorId" in e && t.colors[e.colorId] === void 0))
    return sc(e, t);
}, be = (e, t) => e === void 0 ? {} : me({
  fontFamily: uc(e, t),
  fontSizePt: e.fontSize,
  fontWeight: e.fontWeight === void 0 ? void 0 : lc(e.fontWeight),
  fontStyle: e.fontStyle,
  color: Ae(e.color, t),
  textDecoration: e.textDecoration,
  textDecorationColor: Ae(e.textDecorationColor, t),
  letterSpacing: e.letterSpacing,
  textCase: e.textCase,
  textStrokeWidth: e.textStrokeWidth,
  textStrokeColor: Ae(e.textStrokeColor, t),
  textFillColor: Ae(e.textFillColor, t)
}), fc = (e) => e === void 0 ? {} : me({
  textAlign: e.textAlign,
  lineHeight: e.lineHeight,
  fontSizePt: e.fontSize,
  overflowWrap: e.overflowWrap
}), hc = (e) => me({
  background: e.backgroundColor,
  borderWidth: e.borderWidth,
  borderStyle: e.borderStyle,
  borderColor: e.borderColor,
  borderRadius: e.borderRadius,
  opacity: e.opacity,
  verticalAlign: e.verticalAlign,
  textShadow: e.textShadow
}), gi = (e) => e !== void 0 && Object.values(e).some((t) => t !== void 0), ro = (e, t) => {
  const n = e.params, o = { ...n }, r = e.caseServiceId === void 0 && (n == null ? void 0 : n.serviceId) !== void 0;
  return e.caseServiceId !== void 0 ? o.serviceId = e.caseServiceId : delete o.serviceId, { params: o, severed: r };
}, mi = (e, t, n) => t.severed ? "" : Fl(e.fieldKey, n.caseData, t.params), xe = (e, t) => wt(e.styling, t.refs), ke = (e, t) => {
  const { cascade: n } = t, o = e.role === void 0 ? void 0 : n.decorations[e.role];
  return [
    n.global.character,
    ...n.theme ? [n.theme.character] : [],
    ...n.product ? [n.product.character] : [],
    ...n.m3Product ? [n.m3Product.character] : [],
    ...o ? [o.character] : [],
    be(
      wt(e.characterStyling, t.refs),
      t.refs
    )
  ];
}, pc = (e, t) => {
  const { cascade: n } = t, o = e.role === void 0 ? void 0 : n.decorations[e.role];
  return [
    n.global.block,
    ...n.theme ? [n.theme.block] : [],
    ...n.product ? [n.product.block] : [],
    ...n.m3Product ? [n.m3Product.block] : [],
    ...o ? [o.block] : [],
    fc(
      oo(e.blockStyling, t.refs)
    )
  ];
}, ye = (e, t, n) => Pt([
  ...e,
  be(t, n.refs)
]), gc = (e, t, n) => ye(
  ke(e, n),
  xe(t, n),
  n
), an = (e, t, n, o, r) => ({
  text: tc(e, t.textCase, n),
  style: t,
  ...o === void 0 ? {} : { modelRun: o },
  ...r === void 0 ? {} : { emptyField: r }
}), bi = (e, t) => e.kind === "field" && t === "" ? e.fieldKey : void 0, Vt = (e, t) => e.map((n, o) => {
  if (n.kind === "text")
    return { kind: "literal", text: n.characters, carrier: o };
  const r = ro(n);
  return {
    kind: "field",
    fieldKey: n.fieldKey,
    params: r.params,
    resolvedText: mi(n, r, t),
    carrier: o
  };
}), io = (e, t) => {
  const n = t[e.carrier];
  return e.kind === "field" || n.kind === "text" && n.characters === e.text ? n : {
    kind: "text",
    characters: e.text,
    ...n.styling === void 0 ? {} : { styling: n.styling },
    ...n.lang === void 0 ? {} : { lang: n.lang }
  };
}, mc = (e, t) => {
  const n = Vt(e, t), o = cn(n);
  return o === n ? { runs: e, pieces: n } : {
    runs: o.map((i) => io(i, e)),
    pieces: o.map((i, s) => ({ ...i, carrier: s }))
  };
}, bc = (e, t, n, o) => {
  const r = li(t) ?? [], i = new Set(r.map((l) => l.carrier)), s = t.filter(
    (l) => l.kind === "field" && (l.resolvedText ?? "") === "" && !i.has(l.carrier)
  );
  return [...r, ...s].sort((l, c) => l.carrier - c.carrier).map((l) => {
    const c = e.runs[l.carrier], a = ye(
      n,
      xe(c, o),
      o
    ), d = l.kind === "literal" ? l.text : l.resolvedText ?? "";
    return an(
      d,
      a,
      o.locale,
      l.carrier,
      bi(c, d)
    );
  });
}, xc = (e, t, n) => {
  var l;
  const o = e.runs[0];
  if (o === void 0 || o.kind !== "field") return [];
  const r = ci(
    o.fieldKey,
    n.caseData,
    (l = o.params) == null ? void 0 : l.rowType
  );
  if (r.length === 0) return [];
  const i = e.runs.map((c) => xe(c, n)), s = [...i].reverse().find(gi);
  return r.map((c, a) => {
    const d = a < i.length ? i[a] : s, u = ye(t, d, n);
    return an(
      c,
      u,
      n.locale,
      a < i.length ? a : void 0
    );
  });
}, kc = (e, t, n) => e.runs.map((o, r) => {
  const i = ye(
    t,
    xe(o, n),
    n
  ), s = o.kind === "text" ? o.characters : mi(o, ro(o), n);
  return an(s, i, n.locale, r);
}), yc = (e) => {
  let t = null;
  for (const n of e)
    (t === null || n.style.fontSizePt > t.style.fontSizePt) && (t = n);
  return t;
}, Sc = (e, t, n, o) => {
  const r = ii(pc(e, n));
  if (e.runs.length === 0) {
    const s = Pt(t), l = s.fontSizePt;
    return r.fontSizePt === void 0 ? l !== Ke && (r.fontSizePt = l) : l > r.fontSizePt && (r.fontSizePt = l), r.strutFontFamily = s.fontFamily, e.kind === "rule" && (r.color = s.color), r;
  }
  const i = yc(o);
  return i === null || ((r.fontSizePt === void 0 || i.style.fontSizePt > r.fontSizePt) && (r.fontSizePt = i.style.fontSizePt), r.strutFontFamily = i.style.fontFamily), r;
}, Ec = (e, t, n, o) => e.runs.flatMap((r, i) => {
  const s = t.paintedRunText[i];
  if (s == null) return [];
  const l = ye(
    n,
    xe(r, o),
    o
  );
  return [
    an(
      s,
      l,
      o.locale,
      i,
      bi(r, s)
    )
  ];
}), Ic = (e, t, n, o, r) => {
  const i = ke(e, o), s = e.authoredContainerId ?? `${n}:${t}`, l = [], c = (f) => {
    f.forEach((g, b) => {
      if (g.kind !== "field") return;
      ro(g).severed && l.push({
        blockIndex: t,
        runIndex: b,
        fieldKey: g.fieldKey,
        serviceId: g.params.serviceId
      });
    });
  };
  let a = e, d = [];
  switch (e.kind) {
    case "paragraph": {
      if (r !== void 0 && e.runs.length > 0) {
        d = Ec(
          e,
          r,
          i,
          o
        ), c(e.runs);
        break;
      }
      const f = mc(e.runs, o);
      a = f.runs === e.runs ? e : { ...e, runs: f.runs }, d = bc(
        a,
        f.pieces,
        i,
        o
      ), c(a.runs);
      break;
    }
    case "case_detail_table":
      d = xc(e, i, o);
      break;
    case "literal_grid":
      d = kc(e, i, o), c(e.runs);
      break;
  }
  const u = {
    containerId: s,
    kind: a.kind,
    ...a.role === void 0 ? {} : { role: a.role },
    ...a.kind === "literal_grid" && a.descriptor !== void 0 ? {
      grid: structuredClone(
        a.descriptor
      )
    } : {},
    runs: d,
    style: Sc(a, i, o, d),
    ...a.kind === "paragraph" && d.length === 0 ? { fold: Pt(i) } : {}
  };
  return { block: a, resolved: u, severed: l };
}, vc = (e) => {
  if (!(e.paddingTop === void 0 && e.paddingRight === void 0 && e.paddingBottom === void 0 && e.paddingLeft === void 0))
    return {
      top: e.paddingTop ?? 0,
      right: e.paddingRight ?? 0,
      bottom: e.paddingBottom ?? 0,
      left: e.paddingLeft ?? 0
    };
}, wc = (e, t) => {
  const n = {
    boxId: e.boxId,
    rect: { x: e.x, y: e.y, width: e.width, height: e.height },
    blocks: t
  }, o = vc(e);
  o !== void 0 && (n.padding = o), e.overflowWrap !== void 0 && (n.overflowWrap = e.overflowWrap);
  const r = Pl([hc(e)]);
  return Object.keys(r).length > 0 && (n.style = r), n;
}, xi = (e, t) => {
  const { anchor: n, revision: o, box: r, context: i } = e, s = r.blocks.map(
    (a, d) => Ic(a, d, r.boxId, i, t == null ? void 0 : t[d])
  ), l = s.map((a) => a.block), c = l.some((a, d) => a !== r.blocks[d]);
  return {
    anchor: n,
    revision: o,
    context: i,
    box: c ? { ...r, blocks: l } : r,
    resolved: wc(
      r,
      s.map((a) => a.resolved)
    ),
    severedBindings: s.flatMap((a) => a.severed)
  };
}, je = (e) => xi(e), ki = (e, t) => xi(e, t), O = (e) => e === null ? void 0 : e, yi = (e, t) => e === null ? void 0 : wt({ stylingId: e }, t), Rc = (e, t) => e === null ? void 0 : oo({ stylingId: e }, t), Tc = (e, t) => {
  const n = yi(e.characterStylingId, t), o = O(e.lang);
  return e.runKind === "text" ? { kind: "text", characters: e.characters ?? "", styling: n, lang: o } : {
    kind: "field",
    fieldKey: e.fieldKey ?? "",
    caseServiceId: O(e.caseServiceId),
    params: O(e.fieldParams),
    styling: n,
    lang: o
  };
}, Ac = (e, t) => ({
  kind: e.blockKind,
  authoredContainerId: O(e.authoredContainerId),
  role: O(e.role),
  descriptor: O(
    e.blockDescriptor
  ),
  blockStyling: Rc(e.blockStylingId, t),
  characterStyling: yi(e.characterStylingId, t),
  lang: O(e.lang),
  runs: e.runs.map((n) => Tc(n, t))
}), Cc = (e, t) => ({
  boxId: e.boxId,
  x: e.x,
  y: e.y,
  width: e.width,
  height: e.height,
  rotation: e.rotation,
  zIndex: e.zIndex,
  isLocked: e.isLocked,
  isHiddenInEditor: e.isHiddenInEditor,
  isHiddenInPdf: e.isHiddenInPdf,
  hasPastedContent: e.hasPastedContent,
  backgroundColor: O(e.backgroundColor),
  borderWidth: O(e.borderWidth),
  borderStyle: O(
    e.borderStyle
  ),
  borderColor: O(e.borderColor),
  borderRadius: O(e.borderRadius),
  paddingTop: O(e.paddingTop),
  paddingRight: O(e.paddingRight),
  paddingBottom: O(e.paddingBottom),
  paddingLeft: O(e.paddingLeft),
  opacity: O(e.opacity),
  verticalAlign: O(
    e.verticalAlign
  ),
  writingMode: O(
    e.writingMode
  ),
  dropShadow: O(e.dropShadow),
  textShadow: O(e.textShadow),
  sizing: O(e.sizing),
  maxFontSizePt: O(e.maxFontSizePt),
  overflowWrap: O(
    e.overflowWrap
  ),
  blocks: e.blocks.map((n) => Ac(n, t))
}), qt = (e, t) => {
  const n = e.characterStylingId === null ? void 0 : t.stylings[e.characterStylingId], o = e.blockStylingId === null ? void 0 : t.stylings[e.blockStylingId];
  return {
    character: n === void 0 ? {} : Ll(n, t),
    block: o === void 0 ? {} : _l(o)
  };
}, Fc = (e, t) => {
  const n = {};
  for (const o of Object.values(e)) {
    if (o.fontFamilyVerbatim === null || o.fontFamilyId === null)
      continue;
    const r = t.fontFamilies[o.fontFamilyId];
    r !== void 0 && (n[o.fontFamilyVerbatim] = r.familyName);
  }
  return n;
}, Si = (e, t = {}) => {
  const n = {
    stylings: e.stylings,
    colors: e.colors,
    fontFamilies: e.fontFamilies,
    familyNameByVerbatim: Fc(e.stylings, e)
  }, o = {};
  for (const r of e.decorations)
    o[r.role] = qt(r, e);
  return {
    caseData: t.caseData ?? {},
    locale: t.locale ?? ui,
    cascade: {
      global: qt(e.global, e),
      theme: e.theme === null ? null : qt(e.theme, e),
      product: e.product === null ? null : qt(e.product, e),
      m3Product: e.m3Product === null ? null : qt(e.m3Product, e),
      decorations: o
    },
    refs: n
  };
}, Ei = (e, t) => je({
  anchor: e.anchor,
  revision: e.revision,
  box: Cc(e, t.refs),
  context: t
}), Nh = (e, t, n = {}) => Ei(e, Si(t, n)), $h = (e, t = {}) => {
  const n = Si(e, t);
  return e.boxes.map((o) => Ei(o, n));
}, Pc = (e) => ({
  ...e.box,
  expectedRevision: e.revision
}), _c = 1, zh = (e) => {
  var n;
  let t = null;
  for (const o of e.blocks) {
    const r = o.runs.map((a) => a.style.fontSizePt).filter((a) => typeof a == "number" && a > 0), i = o.style.fontSizePt ?? ((n = o.fold) == null ? void 0 : n.fontSizePt) ?? (r.length === 0 ? Ke : 0), s = Math.max(i, ...r);
    if (!(s > 0)) continue;
    const l = typeof o.style.lineHeight == "number" && o.style.lineHeight > 0 ? o.style.lineHeight : 1, c = s * ln * l;
    (t === null || c > t) && (t = c);
  }
  return t === null ? null : t + 2 * _c;
}, so = (e) => {
  let t = 5381;
  for (let n = 0; n < e.length; n++) t = t * 33 ^ e.charCodeAt(n);
  return (t >>> 0).toString(36);
}, Lc = {
  JP: "ja",
  KR: "ko",
  SC: "zh-Hans",
  TC: "zh-Hant"
}, Oc = (e) => {
  const t = [];
  return e.blocks.forEach((n, o) => {
    var i;
    const r = n.runs.map((s, l) => l);
    if (n.kind === "case_detail_table") {
      for (const s of r)
        t.push({ blockIndex: o, runs: [s] });
      return;
    }
    if (n.kind === "literal_grid") {
      let s = 0;
      for (const l of ((i = n.grid) == null ? void 0 : i.rows) ?? [])
        for (const c of l.cells)
          t.push({
            blockIndex: o,
            runs: r.slice(s, s + c.runCount)
          }), s += c.runCount;
      return;
    }
    r.length > 0 && t.push({ blockIndex: o, runs: r });
  }), t;
}, Dc = new Intl.Segmenter(void 0, {
  granularity: "grapheme"
}), Bc = (e) => {
  const t = e.map((s) => s.text).join(""), n = /* @__PURE__ */ new Set([t.length]);
  for (const { index: s } of Dc.segment(t))
    n.add(s);
  const o = [];
  let r = 0, i = 0;
  for (const s of e) {
    i += s.text.length;
    let l = i;
    for (; !n.has(l); ) l -= 1;
    l > r && o.push({ ...s, text: t.slice(r, l) }), r = Math.max(r, l);
  }
  return o;
}, Mc = (e, t) => {
  const n = [];
  if (t.length === 0) n.push({ text: e });
  else {
    let r = 0, i = t[0].form;
    for (const s of t.slice(1))
      s.form !== i && (n.push({ text: e.slice(r, s.start), form: i }), r = s.start, i = s.form);
    n.push({ text: e.slice(r), form: i });
  }
  const o = n.flatMap(
    ({ text: r, form: i }) => Gl(r).map(
      (s) => ({
        text: s.text,
        ...i === void 0 ? {} : { form: i },
        ...s.emoji ? { emoji: !0 } : {}
      })
    )
  );
  return o.length > 1 ? Bc(o) : o.length > 0 ? o : [{ text: e }];
}, Jo = /* @__PURE__ */ new WeakMap(), Ii = (e) => {
  const t = Jo.get(e);
  if (t !== void 0) return t;
  const n = Nc(e);
  return Jo.set(e, n), n;
};
function Nc(e) {
  const t = e.blocks.map(
    (r) => r.runs.map((i) => [{ text: i.text }])
  ), n = Oc(e), o = jl(
    n.map(
      ({ blockIndex: r, runs: i }) => i.map((s) => e.blocks[r].runs[s].text).join("")
    )
  );
  return n.forEach(({ blockIndex: r, runs: i }, s) => {
    const l = o[s] ?? [];
    let c = 0;
    for (const a of i) {
      const d = e.blocks[r].runs[a].text, u = c + d.length, f = l.filter((g) => g.start < u && g.end > c).map((g) => ({
        start: Math.max(g.start, c) - c,
        end: Math.min(g.end, u) - c,
        form: g.form
      }));
      t[r][a] = Mc(d, f), c = u;
    }
  }), t;
}
const dn = "editor-text.resolved", vi = `@layer editor-text.floor,editor-text.structure,${dn};`, Zo = /* @__PURE__ */ new Map(), Ge = (e, t, n) => {
  const o = `${t ?? ""}|${n ? "emoji" : ""}|${e}`, r = Zo.get(o);
  if (r !== void 0) return r;
  const i = e.trim() === "" ? "" : Xo(Vl(e)), s = Ul(i, t), l = n ? `${Xo(Yl)}, ${s}` : s;
  return Zo.set(o, l), l;
}, ae = (e, t) => {
  const n = (e.textDecoration !== void 0 ? `;text-decoration:${J(e.textDecoration)}` : "") + (e.textDecorationColor !== void 0 ? `;text-decoration-color:${J(e.textDecorationColor)}` : "") + (e.textStrokeColor !== void 0 ? `;-webkit-text-stroke-color:${J(e.textStrokeColor)}` : "") + (e.textFillColor !== void 0 ? `;-webkit-text-fill-color:${J(e.textFillColor)}` : ""), o = `font-family:${Ge(e.fontFamily, t == null ? void 0 : t.form, t == null ? void 0 : t.emoji)};font-style:${J(e.fontStyle)};font-weight:${_(e.fontWeight)};color:${J(e.color)}` + n;
  return { name: `editor-text-run-style-${so(o)}`, decls: o };
}, wi = (e) => {
  const t = e.overflowWrap !== void 0 ? `;overflow-wrap:${J(e.overflowWrap)}` : "", n = e.color !== void 0 ? `;color:${J(e.color)}` : "", o = `text-align:${J(e.textAlign)};line-height:${_(e.lineHeight)}${t}${n}`;
  return { name: `editor-text-block-style-${so(o)}`, decls: o };
}, $c = (e) => {
  const t = Ol(e.color);
  if (t === null) return null;
  const n = t.a * Math.min(1, Math.max(0, e.opacity));
  return `${_(e.x)}pt ${_(e.y)}pt ${_(Math.max(0, e.blur))}pt rgba(${t.r},${t.g},${t.b},${_(n)})`;
}, lo = (e) => {
  const t = [];
  if (e.background !== void 0 && t.push(`background:${J(e.background)}`), e.borderWidth !== void 0 && t.push(`border-width:${_(e.borderWidth)}pt`), e.borderStyle !== void 0 && t.push(`border-style:${J(e.borderStyle)}`), e.borderColor !== void 0 && t.push(`border-color:${J(e.borderColor)}`), e.borderRadius !== void 0 && t.push(`border-radius:${_(e.borderRadius)}pt`), e.opacity !== void 0 && t.push(`opacity:${_(e.opacity)}`), e.verticalAlign === "middle" || e.verticalAlign === "bottom") {
    const r = e.verticalAlign === "middle" ? "center" : "flex-end";
    t.push(
      "display:flex",
      "flex-direction:column",
      `justify-content:${r}`,
      `justify-content:safe ${r}`
    );
  }
  const n = e.textShadow === void 0 ? null : $c(e.textShadow);
  if (n !== null && t.push(`text-shadow:${n}`), t.length === 0) return null;
  const o = t.join(";");
  return { name: `editor-text-box-style-${so(o)}`, decls: o };
}, Ri = () => ae(xt), de = "editor-rule", co = {
  name: "editor-rule-line",
  decls: "display:block;height:0;margin:0.5em 0;padding:0;border-style:solid;border-width:1px 0 0;color:inherit;overflow:hidden"
}, Ti = `.${co.name}`, Ve = "editor-case-detail-table", Ue = "editor-literal-grid", Xt = (e, t) => {
  const n = e.get(t.name);
  if (n !== void 0 && n !== t.decls)
    throw new Error(
      `editor resolved-class hash collision: .${t.name} claims two distinct bodies — "${n}" vs "${t.decls}"`
    );
  e.set(t.name, t.decls);
}, ao = (e, t) => {
  if (e.style) {
    const o = lo(e.style);
    o && Xt(t, o);
  }
  const n = Ii(e);
  e.blocks.forEach((o, r) => {
    Xt(t, wi(o.style)), o.kind === "rule" ? Xt(t, co) : o.runs.length === 0 && o.kind === "paragraph" ? Xt(
      t,
      o.fold ? ae(o.fold) : Ri()
    ) : o.runs.forEach((i, s) => {
      for (const l of n[r][s])
        Xt(t, ae(i.style, l));
    });
  });
}, Ai = (e) => [...e.keys()].sort().map((t) => ({ name: t, decls: e.get(t) })), Ci = (e) => {
  if (e.size === 0) return "";
  const t = Ai(e).map(({ name: n, decls: o }) => `.${n}{${o}}`).join("");
  return `@layer ${dn}{${t}}`;
}, zc = (e) => {
  const t = /* @__PURE__ */ new Map();
  for (const n of e.page.boxes) ao(n, t);
  return Ci(t);
}, Hc = (e) => {
  const t = /* @__PURE__ */ new Map();
  return ao(e, t), Ci(t);
}, Fi = (e) => {
  const t = /* @__PURE__ */ new Map();
  return ao(e, t), Ai(t);
}, K = (e) => e.slice(5).replace(
  /-([a-z])/g,
  (t, n) => n.toUpperCase()
), Pi = "editor-text-page", _i = "editor-text-box", Ht = "editor-text-block", uo = "editor-text-run", Li = `.${Pi}`, fo = `.${_i}`, H = `.${Ht}`, B = `.${uo}`, Oi = "data-document-id", Di = "data-page-id", Wc = "data-box-id", Kc = "data-container-id", ho = "data-overflow-wrap", jc = "data-role", Gc = "data-legacy-chrome", Qo = K(
  ho
), at = "data-filler", rt = K(at), Ye = "data-caret-home";
K(
  Ye
);
const po = "data-block", go = "data-run", Se = "data-base-pt", mo = "data-strut-pt", Et = K(
  po
), ct = K(
  go
), It = K(Se), Bi = K(mo), Vc = "data-fit-scale", Uc = "data-overflowing", bo = K(Vc), qe = K(
  Uc
), Ce = {
  top: "data-base-pad-top",
  right: "data-base-pad-right",
  bottom: "data-base-pad-bottom",
  left: "data-base-pad-left"
}, G = {
  top: K(Ce.top),
  right: K(Ce.right),
  bottom: K(Ce.bottom),
  left: K(Ce.left)
}, Yc = "data-ink-escape", tr = K(
  Yc
), kt = "data-kind", Mi = "data-case-detail", un = "data-empty-field", Ni = "⁠", Sn = "data-field-run-selected", oe = "data-rule-selected", Mt = "data-table-selected", St = "data-table-caret", Ne = "--editor-table-caret-color", xo = "data-stop-anchor", qc = K(
  xo
), $n = "data-outlined", $i = "data-emoji-cluster", zi = K(
  $i
), En = "rgba(135, 189, 233, 0.5)", ue = K(kt), er = K(
  Mi
), Tt = K(
  un
), Xc = [
  kt,
  Mi
], Jc = "data-editor-text-sheet", Zc = "data-editor-text-resolved", nr = "editor-table-caret-blink", Hi = () => vi + `@layer editor-text.floor{${H}{${Jl()}}${B}{${Zl()}}}@layer editor-text.structure{${Li}{position:relative;overflow:hidden;}${fo}{position:absolute;box-sizing:border-box;}.${de}{display:flow-root;}.${de}[${oe}]{background-color:${En};}${H}[${Mt}]{background-color:${En};}${H}[${Mt}] ${B}:not([${$n}])::selection{background-color:transparent;}${H}[${St}]{position:relative;}${H}[${St}]::after{content:'';position:absolute;left:0;right:0;height:1px;pointer-events:none;background-color:var(${Ne},currentColor);animation:${nr} 1s step-end infinite;}${H}[${St}="before"]::after{top:0;}${H}[${St}="after"]::after{bottom:0;}@keyframes ${nr}{0%,100%{opacity:1;}50%{opacity:0;}}.${Ve} table{border-collapse:collapse;width:100%;border:1px solid transparent;}.${Ve} td{width:50%;text-align:center;padding:1px;vertical-align:middle;border:1px solid transparent;}.${Ue} table{border-spacing:2px;}.${Ue} td{padding:1px;vertical-align:middle;}[${ho}="break-word"] ${H}{overflow-wrap:break-word;}${B}:not([${$n}])::selection{background-color:${En};}}`, Wi = (e) => `@font-face{${[
  `font-family:'${Dl(e.family)}'`,
  `src:${Bl(e.src)}`,
  `font-weight:${J(`${e.weight ?? "normal"}`)}`,
  `font-style:${J(e.style ?? "normal")}`,
  `font-display:${J(e.display ?? "swap")}`
].join(";")};}`, Qc = (e) => e.map(Wi).join("") + "html,body{margin:0;padding:0;background:#fff;}" + Hi(), ta = (e = []) => e.map(Wi).join("") + Hi(), ea = /* @__PURE__ */ new Set([
  "border",
  "cellpadding",
  "cellspacing",
  "width",
  "height",
  "align",
  "valign"
]), na = (e, t) => {
  const { documentId: n, page: o } = e, r = o.boxes.map((i) => oa(i, n, o.pageId, t)).join("");
  return `<div class="${Pi}" ${Oi}="${ot(n)}" ${Di}="${ot(o.pageId)}" style="width:${_(o.widthPx)}px;height:${_(o.heightPx)}px">` + r + "</div>";
}, Ki = (e, t, n, o) => {
  const r = Ii(e);
  return e.blocks.map((i, s) => ra(i, t, n, o, s, r[s])).join("");
}, oa = (e, t, n, o) => {
  const r = e.rect, i = Ki(e, t, n, o), s = e.padding, l = s ? `;padding:${_(s.top)}px ${_(s.right)}px ${_(s.bottom)}px ${_(s.left)}px` : "", c = e.style ? lo(e.style) : null, a = c ? ` ${c.name}` : "", d = e.overflowWrap === "break-word" ? ` ${ho}="break-word"` : "";
  return `<div class="${_i}${a}" ${Wc}="${ot(e.boxId)}"${d} style="left:${_(r.x)}px;top:${_(r.y)}px;width:${_(r.width)}px;height:${_(r.height)}px${l}">` + i + "</div>";
}, ra = (e, t, n, o, r, i) => {
  var T;
  const s = o === "editor" ? ` ${po}="${r}"` : "", l = e.kind === "rule", c = e.kind === "case_detail_table", a = e.kind === "literal_grid", d = c || a, u = e.runs.length === 0, f = e.style.fontSizePt ?? (u && !d ? Ke : void 0), g = f !== void 0 ? `font-size:${_(f)}pt` : "", b = f !== void 0 ? ` ${mo}="${_(f)}"` : "", p = e.style.strutFontFamily !== void 0 ? `font-family:${Ge(e.style.strutFontFamily)}` : u && !d ? `font-family:${Ge(xt.fontFamily)}` : "", h = wi(e.style), m = [g, p].filter(Boolean).join(";"), k = m ? ` style="${m}"` : "", E = l ? `<hr class="${co.name}">` : c ? sa(e.runs, o, i) : a ? la(e, o, i) : u ? ca(
    e.style.fontSizePt ?? Ke,
    o,
    e.fold
  ) : e.runs.map((Y, L) => ko(Y, o, L, i[L])).join(""), S = e.role !== void 0 ? ` ${jc}="${ot(e.role)}"` : "", y = l ? ` ${de}` : c ? ` ${Ve}` : a ? ` ${Ue}` : "", v = a && ((T = e.grid) == null ? void 0 : T.chrome) !== void 0 ? ` ${Gc}="${ot(e.grid.chrome)}"` : "";
  return `<div class="${Ht}${y} ${h.name}" id="${ot(e.containerId)}" ${Kc}="${ot(e.containerId)}" ${Oi}="${ot(t)}" ${Di}="${ot(n)}"${S}${v}${s}${b}${k}>` + E + "</div>";
}, ia = (e) => {
  const t = (o) => `${Math.round(o / e.fontSizePt * 1e4) / 1e4}em`, n = [`font-size:${_(e.fontSizePt)}pt`];
  return e.letterSpacing !== void 0 && n.push(`letter-spacing:${t(e.letterSpacing)}`), e.textStrokeWidth !== void 0 && n.push(`-webkit-text-stroke-width:${t(e.textStrokeWidth)}`), n.join(";");
}, ko = (e, t, n, o = [{ text: e.text }]) => {
  const r = e.style, i = t === "editor" ? ` ${go}="${e.modelRun ?? n}" ${Se}="${_(r.fontSizePt)}"` : "", s = e.emptyField !== void 0 ? ` ${un}="${ot(e.emptyField)}"` : "", l = r.textStrokeWidth !== void 0 && r.textStrokeWidth > 0 ? ` ${$n} spellcheck="false"` : "", c = ia(r);
  return o.map((a) => {
    const d = ae(r, a), u = a.form !== void 0 ? ` lang="${Lc[a.form]}"` : "", f = a.emoji ? ` ${$i}` : "", g = e.emptyField !== void 0 ? Ni : aa(a.text);
    return `<span class="${uo} ${d.name}"${i}${s}${l}${u}${f} style="${c}">${g}</span>`;
  }).join("");
}, sa = (e, t, n) => {
  const o = [];
  for (let r = 0; r < e.length; r += 2) {
    const i = e.slice(r, r + 2).map((s, l) => `<td>${ko(s, t, r + l, n[r + l])}</td>`).join("");
    o.push(`<tr>${i}</tr>`);
  }
  return `<table><tbody>${o.join("")}</tbody></table>`;
}, In = (e) => {
  if (e === void 0) return "";
  const t = Ml(e);
  return t === "" ? "" : ` style="${t}"`;
}, or = (e, t) => t !== void 0 && Number.isInteger(t) && t >= 2 ? ` ${e}="${_(t)}"` : "", la = (e, t, n) => {
  const o = e.grid ?? { rows: [] }, r = Object.entries(o.tableAttrs ?? {}).filter(([l]) => ea.has(l)).map(([l, c]) => ` ${l}="${ot(c)}"`).join("");
  let i = 0;
  const s = o.rows.map((l) => {
    const c = l.cells.map((a) => {
      const d = e.runs.slice(i, i + a.runCount).map((u, f) => ko(u, t, i + f, n[i + f])).join("");
      return i += a.runCount, `<td${or("colspan", a.colspan)}${or("rowspan", a.rowspan)}${In(a.css)}>${d}</td>`;
    }).join("");
    return `<tr${In(l.css)}>${c}</tr>`;
  }).join("");
  return `<table${r}${In(o.tableCss)}><tbody>${s}</tbody></table>`;
}, ca = (e, t, n) => {
  const o = n ? ae(n) : Ri(), r = t === "editor" ? ` ${Se}="${_(e)}"` : "";
  return `<span class="${uo} ${o.name}" ${at}${r} style="font-size:${_(e)}pt"><br></span>`;
}, aa = (e) => e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), ot = (e) => e.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;"), da = (e, t) => ({
  css: Qc(t.fonts) + zc(e),
  html: na(e, t.mode ?? "preview")
}), Hh = (e, t = {}) => {
  const n = t.rect === void 0 ? e.resolved : { ...e.resolved, rect: t.rect }, o = {
    documentId: t.documentId ?? n.boxId,
    page: {
      pageId: "page",
      widthPx: n.rect.x + n.rect.width,
      heightPx: n.rect.y + n.rect.height,
      boxes: [n]
    }
  };
  return {
    ...da(o, {
      fonts: t.fonts ?? [],
      mode: t.mode ?? "preview"
    }),
    resolvedCss: Hc(n),
    resolvedClasses: Fi(n)
  };
}, Wh = (e, t) => {
  switch (e) {
    case "character":
      return t === "whole-box" ? { layer: "block", scope: "block" } : { layer: "character", scope: "run" };
    case "block":
      return { layer: "block", scope: "block" };
    case "box":
      return { layer: "box", scope: "block" };
  }
}, zn = [
  "backgroundColor",
  "borderWidth",
  "borderStyle",
  "borderColor",
  "borderRadius",
  "opacity",
  "verticalAlign",
  "textShadow"
], yo = (e) => {
  const t = {};
  for (const [n, o] of Object.entries(e))
    o !== void 0 && (t[n] = o);
  return t;
}, Z = (e, t) => {
  const n = yo(t), o = { ...e ?? {}, ...n };
  return n.fontFamily !== void 0 && delete o.fontFamilyId, n.fontFamilyId !== void 0 && delete o.fontFamily, o;
}, ji = (e, t) => {
  const n = yo(t), o = { ...e ?? {}, ...n };
  return o.textAlign === "justify" ? o.textJustify === void 0 && (o.textJustify = "inter-word") : delete o.textJustify, o;
}, ua = (e, t) => {
  const n = { ...e, ...yo(t) };
  for (const o of zn)
    n[o] === null && delete n[o];
  return n;
}, C = (e) => e === "rule" || e === "case_detail_table" || e === "literal_grid", Hn = (e) => e.blocks.every(
  (t) => t.kind === "paragraph" && t.runs.every((n) => n.kind === "text" && n.characters === "")
), fa = "New Text Box", ha = (e) => e.replace(/\s+/g, " ").trim(), Kh = (e) => {
  const t = [];
  for (const n of e.blocks) {
    if (n.kind !== "paragraph") return !1;
    for (const o of n.runs) {
      if (o.kind !== "text") return !1;
      t.push(o.characters);
    }
  }
  return ha(t.join("")) === fa;
}, pa = new Intl.Segmenter(void 0, {
  granularity: "grapheme"
}), ga = 256, Jt = /* @__PURE__ */ new Map(), $ = (e) => {
  const t = Jt.get(e);
  if (t !== void 0) return t;
  const n = [];
  for (const { segment: o } of pa.segment(e)) n.push(o);
  if (Jt.size >= ga) {
    const o = Jt.keys().next().value;
    o !== void 0 && Jt.delete(o);
  }
  return Jt.set(e, n), n;
}, w = (e) => e === "case_detail_table" || e === "literal_grid", N = (e) => e !== void 0 && w(e.kind), nt = (e) => e !== void 0 && !C(e.kind), V = (e, t) => e.blockIndex < t.blockIndex || e.blockIndex === t.blockIndex && e.offset <= t.offset ? [e, t] : [t, e], P = (e, t) => e.blockIndex !== t.blockIndex ? e.blockIndex - t.blockIndex : e.offset - t.offset, _t = (e, t, n) => {
  const [o, r] = V(e, t);
  return P(o, { blockIndex: n, offset: 0 }) <= 0 && P(r, { blockIndex: n, offset: 1 }) >= 0;
}, Zt = (e) => e === void 0 || !C(e.kind), Gi = (e, t) => e === void 0 ? t.every((n) => n.kind === "rule") : e.kind === "rule" && (t[0] === void 0 || t[0].kind === "rule"), ma = (e, t, n, o) => {
  if (P(t, n) <= 0 || P(n, o) === 0) return t;
  if (P(t, o) < 0) return n;
  const r = e.blocks[n.blockIndex], i = e.blocks[o.blockIndex], s = Gi(
    e.blocks[n.blockIndex - 1],
    e.blocks.slice(o.blockIndex + 1)
  );
  if (n.blockIndex === o.blockIndex)
    return r !== void 0 && w(r.kind) ? t.blockIndex === o.blockIndex ? n : {
      blockIndex: t.blockIndex - (s ? 0 : 1),
      offset: t.offset
    } : t.blockIndex === o.blockIndex ? {
      blockIndex: n.blockIndex,
      offset: n.offset + (t.offset - o.offset)
    } : t;
  const l = Zt(r) || r !== void 0 && w(r.kind) && n.offset > 0 || (r == null ? void 0 : r.kind) === "rule" && (i == null ? void 0 : i.kind) === "rule", c = Zt(i) && Zt(r), a = Zt(i) && !c || i !== void 0 && w(i.kind) && o.offset === 0;
  if (t.blockIndex > o.blockIndex) {
    const u = o.blockIndex - n.blockIndex + 1, f = (l ? 1 : 0) + (a ? 1 : 0), g = f === 0 && s ? 1 : f;
    return {
      blockIndex: t.blockIndex - (u - g),
      offset: t.offset
    };
  }
  if (c)
    return {
      blockIndex: n.blockIndex,
      offset: n.offset + (t.offset - o.offset)
    };
  if (!a) return n;
  const d = n.blockIndex + (l ? 1 : 0);
  return Zt(i) ? { blockIndex: d, offset: t.offset - o.offset } : { blockIndex: d, offset: t.offset };
}, D = (e) => e.anchor.blockIndex === e.focus.blockIndex && e.anchor.offset === e.focus.offset, U = (e) => e.kind === "field" ? 1 : $(e.characters).length, A = (e) => w(e.kind) ? 1 : C(e.kind) ? 0 : e.runs.reduce((t, n) => t + U(n), 0), ba = (e, t) => {
  var r;
  if (((r = e.blocks[t]) == null ? void 0 : r.kind) !== "rule") return null;
  const n = { blockIndex: t, offset: 0 };
  if (e.blocks[t + 1] !== void 0)
    return {
      kind: "within-box",
      boxId: e.boxId,
      anchor: { blockIndex: t + 1, offset: 0 },
      focus: n
    };
  const o = e.blocks[t - 1];
  return o === void 0 ? null : {
    kind: "within-box",
    boxId: e.boxId,
    anchor: {
      blockIndex: t - 1,
      offset: A(o)
    },
    focus: n
  };
}, Vi = (e, t, n, o) => {
  const r = t === n.blockIndex ? n.offset : 0;
  return (t === o.blockIndex ? o.offset : A(e)) > r;
}, xa = (e, t) => {
  if (D(t)) return null;
  const [n, o] = V(t.anchor, t.focus);
  let r = null;
  for (let i = n.blockIndex; i <= o.blockIndex; i++) {
    const s = e.blocks[i];
    if (s === void 0) return null;
    if (s.kind === "rule") {
      if (r !== null) return null;
      r = i;
      continue;
    }
    if (w(s.kind)) {
      if (_t(n, o, i)) return null;
      continue;
    }
    if (Vi(s, i, n, o)) return null;
  }
  return r;
}, So = (e, t) => {
  const n = e.blocks[t];
  return n === void 0 || !w(n.kind) ? null : {
    kind: "within-box",
    boxId: e.boxId,
    anchor: { blockIndex: t, offset: 0 },
    focus: { blockIndex: t, offset: 1 }
  };
}, et = (e, t) => {
  if (t.offset !== 0 || t.blockIndex < 1) return t;
  const n = e.blocks[t.blockIndex], o = e.blocks[t.blockIndex - 1];
  return n !== void 0 && w(n.kind) && o !== void 0 && w(o.kind) ? { blockIndex: t.blockIndex - 1, offset: 1 } : t;
}, Xe = (e, t) => {
  const n = et(e, t.anchor), o = et(e, t.focus);
  return n === t.anchor && o === t.focus ? t : { ...t, anchor: n, focus: o };
}, Wt = (e, t) => {
  const n = et(e, t), o = e.blocks[n.blockIndex];
  return o === void 0 || !w(o.kind) ? null : {
    blockIndex: n.blockIndex,
    side: n.offset === 0 ? "before" : "after"
  };
}, Ui = (e, t) => {
  if (D(t)) return [];
  const [n, o] = V(t.anchor, t.focus), r = [];
  for (let i = n.blockIndex; i <= o.blockIndex; i++) {
    const s = e.blocks[i];
    s !== void 0 && w(s.kind) && _t(n, o, i) && r.push(i);
  }
  return r;
}, Yt = (e, t) => {
  if (D(t)) return null;
  const [n, o] = V(t.anchor, t.focus);
  let r = null;
  for (let i = n.blockIndex; i <= o.blockIndex; i++) {
    const s = e.blocks[i];
    if (s === void 0 || s.kind === "rule") return null;
    if (w(s.kind)) {
      if (!_t(n, o, i)) continue;
      if (r !== null) return null;
      r = i;
      continue;
    }
    if (Vi(s, i, n, o)) return null;
  }
  return r;
}, Yi = (e, t) => {
  if (!e) return null;
  let n = 0;
  for (let o = 0; o < e.runs.length; o++) {
    const r = U(e.runs[o]);
    if (t <= n + r)
      return { runIndex: o, offsetInRun: t - n };
    n += r;
  }
  return null;
}, yt = (e, t) => {
  if (!e) return 0;
  let n = 0;
  for (let o = 0; o < t && o < e.runs.length; o++)
    n += U(e.runs[o]);
  return n;
}, ka = (e, t, n) => {
  if (!e || t >= n) return [];
  const o = [];
  let r = 0;
  for (let i = 0; i < e.runs.length; i++) {
    const s = r + U(e.runs[i]);
    t < s && n > r && o.push(i), r = s;
  }
  return o;
}, ya = (e, t) => {
  const [n, o] = V(t.anchor, t.focus), r = [];
  for (let i = n.blockIndex; i <= o.blockIndex; i++) {
    const s = e.blocks[i];
    if (!s) continue;
    if (w(s.kind)) {
      _t(n, o, i) && s.runs.forEach(
        (a, d) => r.push({ blockIndex: i, runIndex: d })
      );
      continue;
    }
    const l = i === n.blockIndex ? n.offset : 0, c = i === o.blockIndex ? o.offset : A(s);
    for (const a of ka(s, l, c))
      r.push({ blockIndex: i, runIndex: a });
  }
  return r;
}, rr = (e, t) => t.blockIndex < 0 || t.blockIndex >= e.blocks.length || !Number.isInteger(t.offset) || t.offset < 0 ? !1 : t.offset <= A(e.blocks[t.blockIndex]), jh = (e, t) => rr(e, t.anchor) && rr(e, t.focus), Sa = (e) => {
  const t = [];
  let n = 0;
  for (const o of e.runs) {
    const r = U(o);
    o.kind === "field" && t.push({ start: n, end: n + r }), n += r;
  }
  return t;
}, Gh = (e, t, n) => {
  const o = Math.min(t, n), r = Math.max(t, n);
  return Sa(e).some(
    (i) => o > i.start && o < i.end || r > i.start && r < i.end
  );
}, ir = (e) => ({
  modelLength: e,
  projectedLength: e,
  stopPaints: Array.from({ length: e }, () => !0),
  paintedRunText: [],
  toProjected: (t) => Math.max(0, Math.min(t, e)),
  toModel: (t) => Math.max(0, Math.min(t, e))
}), Ea = (e, t, n) => {
  if (C(e.kind))
    return ir(A(e));
  if (e.runs.length === 0) return ir(0);
  const o = Vt(e.runs, t), r = ai(o, n), i = Nl(r), s = [];
  let l = 0;
  const c = (h, m) => {
    for (let k = h; k < m; k++) if (r.keep[k]) return !0;
    return !1;
  };
  for (const h of o) {
    const m = h.kind === "literal" ? h.text : h.resolvedText ?? "", k = [...m].length;
    if (h.kind === "field") {
      s.push(
        m === "" || !i && c(l, l + k)
      ), l += k;
      continue;
    }
    for (const E of $(m)) {
      const S = [...E].length;
      s.push(!i && c(l, l + S)), l += S;
    }
  }
  const a = o.map(() => null);
  if (!i) {
    const h = /* @__PURE__ */ new Map();
    r.chars.forEach((m, k) => {
      r.keep[k] && h.set(m.piece, (h.get(m.piece) ?? "") + m.ch);
    });
    for (const [m, k] of h)
      k !== "" && (a[m] = k);
  }
  o.forEach((h, m) => {
    h.kind === "field" && (h.resolvedText ?? "") === "" && (a[m] = "");
  });
  const d = s.length, u = new Array(d + 1);
  let f = 0;
  for (let h = 0; h <= d; h++)
    u[h] = f, h < d && s[h] && f++;
  const g = f, b = new Array(g + 1).fill(-1), p = new Array(g + 1).fill(0);
  for (let h = 0; h <= d; h++) {
    const m = u[h];
    b[m] === -1 && (b[m] = h), p[m] = h;
  }
  return {
    modelLength: d,
    projectedLength: g,
    stopPaints: s,
    paintedRunText: a,
    toProjected: (h) => u[Math.max(0, Math.min(h, d))],
    toModel: (h, m) => {
      const k = Math.max(0, Math.min(h, g));
      return m === "left" ? b[k] : p[k];
    }
  };
}, qi = (e, t, n = {}) => ({
  blocks: e.blocks.map(
    (o) => Ea(o, t, n)
  )
}), Ia = (e, t) => Pt(ke(e, t)), va = (e, t = {}) => {
  const n = qi(
    e.box,
    e.context,
    t
  );
  return {
    document: ki(e, n.blocks),
    index: n
  };
}, Vh = !1, Uh = ["shrink", "fill"], wa = (e, t) => (e === "fill" || e == null || e === "shrink" || e === "natural" || e === "solid" || t == null || t(e), "shrink"), Ra = [
  "sizing",
  "maxFontSizePt"
], Ee = 8, sr = 10, Ta = 1 / 512, Eo = 1, Aa = 0.01, le = (e, t) => Math.min(999, Math.max(1, Math.floor(e * t * 10 + 1e-6) / 10)), Io = 1, Ut = ln, vo = (e) => {
  const t = e.filter((n) => Number.isFinite(n) && n > 0);
  return t.length === 0 ? null : Math.min(...t);
}, Ca = (e) => {
  const t = e.filter((n) => Number.isFinite(n) && n > 0);
  return t.length === 0 ? null : Math.max(...t);
}, Fa = {
  mode: "shrink",
  maxFontSizePt: null
}, Pa = (e) => ({
  mode: wa(e.sizing),
  maxFontSizePt: typeof e.maxFontSizePt == "number" && Number.isFinite(e.maxFontSizePt) && e.maxFontSizePt > 0 ? e.maxFontSizePt : null
}), _a = (e, t) => Ra.every(
  (o) => e[o] === t[o]
) ? e : { ...e, sizing: t.sizing, maxFontSizePt: t.maxFontSizePt }, Wn = (e) => {
  const t = vo(e);
  return t === null ? 1 : Math.min(1, Ee / t);
}, Xi = (e, t) => {
  const n = vo(t);
  return n === null || !(e > 0) ? 1 : e / (n * Ut);
}, La = (e) => {
  const t = vo(e);
  return t === null ? 0 : Ee / t;
}, Ji = (e, t) => {
  if (e.mode !== "fill" || e.maxFontSizePt === null) return 1 / 0;
  const n = Ca(t);
  return n === null ? 1 / 0 : e.maxFontSizePt / n;
}, lr = ({
  sizing: e,
  frameHeightPx: t,
  basesPt: n
}) => {
  const o = Xi(t, n);
  return e.mode === "shrink" ? Math.min(o, 1) : Math.min(o, Ji(e, n));
}, Oa = (e) => e > sr ? e / (e - sr) : 1 / 0, cr = (e) => Number.isFinite(e) && e > 0 && Math.abs(e - 1) >= Aa, At = (e, t) => {
  const n = e.blocks[t];
  if (n === void 0)
    throw new Error(`apply: no block at index ${t}`);
  return n;
}, fe = (e, t, n) => {
  const o = e.runs[n];
  if (o === void 0)
    throw new Error(`apply: no run at index ${n} in block ${t}`);
  return o;
}, pt = (e, t, n) => (At(e, t), {
  ...e,
  blocks: e.blocks.map(
    (o, r) => r === t ? n(o) : o
  )
}), ar = (e, t, n, o) => pt(e, t, (r) => (fe(r, t, n), {
  ...r,
  runs: r.runs.map((i, s) => s === n ? o(i) : i)
})), wo = (e, t) => {
  if (e !== void 0 && "stylingId" in e)
    throw new Error(
      `apply: ${t} carries a styling reference; the document format inlines stylings`
    );
  return e;
}, Da = (e, t) => {
  if (e !== void 0 && "stylingId" in e)
    throw new Error(
      `apply: ${t} carries a styling reference; the document format inlines stylings`
    );
  return e;
}, Ie = (e, t) => {
  const { styling: n, ...o } = e;
  return t === void 0 ? o : { ...o, styling: t };
}, Kn = (e, t) => {
  const { characterStyling: n, ...o } = e;
  return t === void 0 ? o : { ...o, characterStyling: t };
}, Zi = (e, t) => {
  const { blockStyling: n, ...o } = e;
  return t === void 0 ? o : { ...o, blockStyling: t };
}, Qi = (e, t, n, o) => Ie(
  e,
  Z(
    wo(
      e.styling,
      `run ${n} of block ${t}`
    ),
    o
  )
), dr = (e, t, n) => Kn(
  e,
  Z(
    wo(e.characterStyling, `block ${t}`),
    n
  )
), Ba = (e, t, n) => Zi(
  e,
  ji(
    Da(e.blockStyling, `block ${t}`),
    n
  )
), ts = (e, t, n, o) => {
  const { runIndex: r, start: i, end: s } = n, l = fe(e, t, r);
  if (l.kind !== "text")
    throw new Error(
      "apply: cannot sub-run split a field run (it is one caret stop)"
    );
  const c = $(l.characters), a = wo(
    l.styling,
    `run ${r} of block ${t}`
  ), d = (f, g, b) => Ie(
    { ...l, characters: c.slice(f, g).join("") },
    b ? Z(a, o) : a
  ), u = [];
  return i > 0 && u.push(d(0, i, !1)), u.push(d(i, s, !0)), s < c.length && u.push(d(s, c.length, !1)), {
    ...e,
    runs: [
      ...e.runs.slice(0, r),
      ...u,
      ...e.runs.slice(r + 1)
    ]
  };
}, es = (e, t, n) => {
  const { runIndex: o, start: r, end: i, runLength: s } = t, l = (r > 0 ? 1 : 0) + 1 + (i < s ? 1 : 0), c = e.runs.slice(o, o + l), a = c[0];
  if (a === void 0 || a.kind !== "text")
    throw new Error(`apply: no split run at index ${o} to merge`);
  const d = c.map((f) => f.kind === "text" ? f.characters : "").join(""), u = Ie({ ...a, characters: d }, n);
  return {
    ...e,
    runs: [
      ...e.runs.slice(0, o),
      u,
      ...e.runs.slice(o + l)
    ]
  };
}, Ro = (e) => e.start === 0 && e.end === e.runLength, ur = (e, t, n, o) => {
  let r = e;
  for (let i = n.length - 1; i >= 0; i--) {
    const s = n[i];
    Ro(s) ? (fe(r, t, s.runIndex), r = {
      ...r,
      runs: r.runs.map(
        (l, c) => c === s.runIndex ? Qi(l, t, s.runIndex, o) : l
      )
    }) : r = ts(r, t, s, o);
  }
  return r;
}, fr = (e, t, n) => {
  let o = e;
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    Ro(i) ? o = {
      ...o,
      runs: o.runs.map(
        (s, l) => l === i.runIndex ? Ie(s, n[r]) : s
      )
    } : o = es(o, i, n[r]);
  }
  return o;
}, hr = (e, t) => t.map((n) => {
  var o;
  return (o = e.runs[n.runIndex]) == null ? void 0 : o.styling;
}), Ma = (e, t, n) => {
  switch (n.selection) {
    case "whole-box": {
      const o = e.blocks.map((r) => r.characterStyling);
      return {
        box: {
          ...e,
          blocks: e.blocks.map(
            (r, i) => dr(r, i, t)
          )
        },
        undo: (r) => ({
          ...r,
          blocks: r.blocks.map(
            (i, s) => Kn(i, o[s])
          )
        })
      };
    }
    case "run": {
      const { blockIndex: o, runIndex: r } = n, i = fe(
        At(e, o),
        o,
        r
      ).styling;
      return {
        box: ar(
          e,
          o,
          r,
          (s) => Qi(s, o, r, t)
        ),
        undo: (s) => ar(s, o, r, (l) => Ie(l, i))
      };
    }
    case "sub-run": {
      const { blockIndex: o, runIndex: r } = n, i = fe(
        At(e, o),
        o,
        r
      ).styling;
      return {
        box: pt(
          e,
          o,
          (s) => ts(s, o, n, t)
        ),
        undo: (s) => pt(
          s,
          o,
          (l) => es(l, n, i)
        )
      };
    }
    case "cross-run": {
      const { blockIndex: o, pieces: r } = n, i = hr(At(e, o), r);
      return {
        box: pt(
          e,
          o,
          (s) => ur(s, o, r, t)
        ),
        undo: (s) => pt(
          s,
          o,
          (l) => fr(l, r, i)
        )
      };
    }
    case "cross-block": {
      const o = n.blocks.map(
        (s) => hr(At(e, s.blockIndex), s.pieces)
      ), r = n.blocks.map(
        (s) => s.pieces.length === 0 ? At(e, s.blockIndex).characterStyling : void 0
      );
      let i = e;
      for (const { blockIndex: s, pieces: l } of n.blocks)
        i = pt(
          i,
          s,
          (c) => l.length === 0 ? dr(c, s, t) : ur(c, s, l, t)
        );
      return {
        box: i,
        undo: (s) => {
          let l = s;
          return n.blocks.forEach(({ blockIndex: c, pieces: a }, d) => {
            l = pt(
              l,
              c,
              (u) => a.length === 0 ? Kn(u, r[d]) : fr(u, a, o[d])
            );
          }), l;
        }
      };
    }
  }
}, Na = (e, t, n) => {
  const o = n.selection === "whole-box" ? e.blocks.map((s, l) => l) : n.selection === "cross-block" ? n.blocks.map((s) => s.blockIndex) : [n.blockIndex], r = o.map(
    (s) => At(e, s).blockStyling
  );
  let i = e;
  for (const s of o)
    i = pt(
      i,
      s,
      (l) => Ba(l, s, t)
    );
  return {
    box: i,
    undo: (s) => {
      let l = s;
      return o.forEach((c, a) => {
        l = pt(
          l,
          c,
          (d) => Zi(d, r[a])
        );
      }), l;
    }
  };
}, $a = (e, t) => {
  const n = {};
  for (const o of zn)
    n[o] = e[o];
  return {
    box: ua(e, t),
    undo: (o) => {
      const r = { ...o };
      for (const i of zn) {
        const s = n[i];
        s === void 0 ? delete r[i] : r[i] = s;
      }
      return r;
    }
  };
}, fn = (e, t, n) => {
  const o = t.kind === "set-box-style" ? $a(e, t.delta) : t.kind === "set-character-style" ? Ma(e, t.delta, n) : Na(e, t.delta, n);
  return {
    box: o.box,
    undo: o.undo,
    redo: (r) => fn(r, t, n).box
  };
}, vn = (e, t, n) => fn(e, t, n).box, za = (e) => Math.round(e * 10) / 10, Ha = (e) => Math.min(
  999,
  Math.max(Ee, za(e))
), Wa = (e) => Math.round(e * 100) / 100, pr = (e) => Math.min(100, Math.max(-100, Wa(e))), Ka = (e) => Math.round(e * 100) / 100, Yh = (e) => Math.min(100, Math.max(0, Ka(e))), gr = (e, t) => Ro(t) ? { selection: "run", blockIndex: e, runIndex: t.runIndex } : {
  selection: "sub-run",
  blockIndex: e,
  runIndex: t.runIndex,
  start: t.start,
  end: t.end,
  runLength: t.runLength
}, ns = (e, t, n) => {
  switch (t.selection) {
    case "run":
    case "sub-run": {
      const { blockIndex: o, runIndex: r } = t;
      return vn(e, n(o, r), t);
    }
    case "cross-run": {
      let o = e;
      for (const r of [...t.pieces].sort(
        (i, s) => s.runIndex - i.runIndex
      ))
        o = vn(
          o,
          n(t.blockIndex, r.runIndex),
          gr(t.blockIndex, r)
        );
      return o;
    }
    case "cross-block": {
      let o = e;
      for (const r of t.blocks)
        for (const i of [...r.pieces].sort(
          (s, l) => l.runIndex - s.runIndex
        ))
          o = vn(
            o,
            n(r.blockIndex, i.runIndex),
            gr(r.blockIndex, i)
          );
      return o;
    }
    case "whole-box":
      throw new Error(
        "a per-run style plan needs a selection-derived target — resolve a spanning selection, not whole-box"
      );
  }
}, ja = (e, t, n) => ns(e, t, (o, r) => ({
  kind: "set-character-style",
  delta: { fontSize: n(o, r) }
})), Ga = (e, t, n) => ns(e, t, (o, r) => ({
  kind: "set-character-style",
  delta: { letterSpacing: n(o, r) }
})), Va = (e) => {
  switch (e.selection) {
    case "whole-box":
      return "whole-box";
    case "cross-run":
      return `cross-run:${e.blockIndex}:${e.pieces.map((t) => `${t.runIndex}.${t.start}.${t.end}`).join("|")}`;
    case "cross-block":
      return `cross-block:${e.blocks.map(
        (t) => `${t.blockIndex}[${t.pieces.map((n) => `${n.runIndex}.${n.start}.${n.end}`).join("|")}]`
      ).join(";")}`;
    default:
      return `run:${e.blockIndex}:${e.runIndex}`;
  }
}, os = (e, t) => `style:${Object.keys(e.delta).sort().join(",")}:${Va(t)}`, qh = (e, t, n) => {
  const o = fn(e, t, n);
  return {
    undo: o.undo,
    redo: o.redo,
    coalesceKey: os(t, n)
  };
}, Ua = (e) => ({ undo: e.undo, redo: e.redo, coalesceKey: e.coalesceKey }), rs = (e, t) => ({
  undo: (n) => e.undo(t.undo(n)),
  redo: (n) => t.redo(e.redo(n)),
  coalesceKey: t.coalesceKey,
  selectionBefore: e.selectionBefore,
  selectionAfter: t.selectionAfter
}), ht = (e, t = "first-key") => {
  if (e.cursor < 2 || e.cursor !== e.steps.length) return e;
  const n = e.steps[e.steps.length - 2], o = e.steps[e.steps.length - 1], r = rs(n, o), i = t === "first-key" ? { ...r, coalesceKey: n.coalesceKey } : r;
  return {
    steps: [...e.steps.slice(0, -2), i],
    cursor: e.cursor - 1
  };
}, Ya = { steps: [], cursor: 0 }, Xh = () => ({ steps: [], cursor: 0 }), qa = (e, t) => ({ steps: [...e.steps.slice(0, e.cursor), t], cursor: e.cursor + 1 }), Xa = (e) => {
  if (!(e.cursor === 0 || e.cursor !== e.steps.length))
    return e.steps[e.cursor - 1].coalesceKey;
}, Ct = (e, t) => {
  const n = t.coalesceKey;
  if (n !== void 0 && n === Xa(e)) {
    const o = rs(e.steps[e.cursor - 1], t);
    return {
      steps: [...e.steps.slice(0, e.cursor - 1), o],
      cursor: e.cursor
    };
  }
  return qa(e, t);
}, Qt = (e) => {
  if (e.cursor === 0) return e;
  const t = e.steps[e.cursor - 1];
  if (t.coalesceKey === void 0) return e;
  const n = { ...t, coalesceKey: void 0 };
  return {
    ...e,
    steps: [
      ...e.steps.slice(0, e.cursor - 1),
      n,
      ...e.steps.slice(e.cursor)
    ]
  };
}, is = (e, t) => ({
  ...e,
  selectionBefore: t.selectionBefore,
  selectionAfter: t.selectionAfter
}), te = (e, t, n, o, r) => {
  const i = fn(e, t, n), s = is(
    {
      undo: i.undo,
      redo: i.redo,
      coalesceKey: os(t, n)
    },
    r
  );
  return { box: i.box, stack: Ct(o, s) };
}, ee = (e, t, n) => {
  const o = is(Ua(e), n);
  return { box: e.box, stack: Ct(t, o) };
}, Ja = (e, t) => {
  if (e.cursor === 0) return { box: t, stack: e };
  const n = e.steps[e.cursor - 1];
  return {
    box: n.undo(t),
    stack: { ...e, cursor: e.cursor - 1 },
    selection: n.selectionBefore
  };
}, Za = (e, t) => {
  if (e.cursor >= e.steps.length) return { box: t, stack: e };
  const n = e.steps[e.cursor];
  return {
    box: n.redo(t),
    stack: { ...e, cursor: e.cursor + 1 },
    selection: n.selectionAfter
  };
}, dt = (e, t) => {
  if (e !== void 0 && "stylingId" in e)
    throw new Error(
      `content-edit: ${t} carries a styling reference; the document format inlines stylings`
    );
  return e;
}, tt = (e, t, n) => ({
  ...e,
  blocks: e.blocks.map(
    (o, r) => r === t ? { ...o, runs: n } : o
  )
}), ss = (e, t, n) => {
  const o = $(e);
  return o.slice(0, t).join("") + n + o.slice(t).join("");
}, Qa = (e, t, n) => {
  const o = $(e);
  return o.slice(0, t).join("") + o.slice(t + n).join("");
}, ut = (e, t) => ({ ...e, characters: t }), td = (e) => {
  if (e.kind === "rule") return e.runs.length > 0;
  if (e.kind === "case_detail_table") {
    if (e.runs.length === 0) return !0;
    const t = e.runs[0];
    if (t.kind !== "field") return !0;
    const n = t.fieldKey;
    return !e.runs.every(
      (o, r) => {
        var i;
        return o.kind === "field" && o.fieldKey === n && ((i = o.params) == null ? void 0 : i.cellIndex) === r;
      }
    );
  }
  return e.kind === "literal_grid" ? e.descriptor === void 0 ? !0 : e.descriptor.rows.reduce(
    (o, r) => r.cells.reduce((i, s) => i + s.runCount, o),
    0
  ) !== e.runs.length : !1;
}, hn = (e, t) => {
  const n = e.blocks[t];
  if (!n || !td(n)) return e;
  const { descriptor: o, ...r } = n, i = { ...r, kind: "paragraph" };
  return {
    ...e,
    blocks: e.blocks.map((s, l) => l === t ? i : s)
  };
}, To = (e, t, n, o) => {
  const r = e.blocks[t];
  return !r || r.kind === n ? e : {
    ...e,
    blocks: e.blocks.map(
      (i, s) => s === t ? { ...i, kind: n, ...o !== void 0 ? { descriptor: o } : {} } : i
    )
  };
}, pn = (e, t) => {
  const n = e.runs[t - 1] ?? e.runs[t];
  return (n == null ? void 0 : n.styling) === void 0 ? void 0 : { ...n.styling };
}, gn = (e) => {
  const t = e.runs[0];
  return (t == null ? void 0 : t.styling) === void 0 ? void 0 : { ...t.styling };
}, ls = (e) => e.characterStyling === void 0 ? void 0 : { ...e.characterStyling }, Nt = (e, t, n) => {
  if (t.length !== 0) return { ...e, runs: t };
  const o = dt(
    n == null ? void 0 : n.styling,
    "the removed run"
  );
  return o === void 0 ? { ...e, runs: t } : {
    ...e,
    runs: t,
    characterStyling: Z(
      dt(e.characterStyling, "the emptied block"),
      o
    )
  };
}, Kt = (e, t) => t === void 0 || !gi(t) ? e : Z(
  dt(e, "the field run"),
  t
), cs = (e, t, n) => {
  const o = new Set(
    e.blocks.flatMap(
      (i) => i.authoredContainerId === void 0 ? [] : [i.authoredContainerId]
    )
  ), r = [];
  for (let i = 1; r.length < n; i += 1) {
    const s = `${t}.${i}`;
    o.has(s) || (o.add(s), r.push(s));
  }
  return r;
}, Lt = (e, t) => cs(e, t, 1)[0], Ao = (e, t) => {
  const n = [], o = [];
  let r = 0;
  for (const i of e.runs) {
    const s = U(i), l = r, c = r + s;
    if (c <= t)
      n.push(i);
    else if (l >= t)
      o.push(i);
    else if (i.kind === "text") {
      const a = $(i.characters), d = t - l, u = a.slice(0, d).join(""), f = a.slice(d).join("");
      u && n.push(ut(i, u)), f && o.push(ut(i, f));
    } else
      n.push(i);
    r = c;
  }
  return { left: n, right: o };
}, ed = (e, t) => JSON.stringify(e) === JSON.stringify(t), Co = (e, t) => {
  if (t === void 0) return e.characterStyling;
  const n = dt(
    e.characterStyling,
    "the split block"
  ), o = {};
  for (const [r, i] of Object.entries(t))
    i !== void 0 && (ed(n == null ? void 0 : n[r], i) || (o[r] = i));
  return Object.keys(o).length === 0 ? e.characterStyling : Z(n, o);
}, as = (e, t) => Co(
  e,
  t ?? dt(
    gn(e),
    "the first cell"
  )
), Fo = (e, t, n, o, r) => ({
  kind: "paragraph",
  authoredContainerId: Lt(e, `${e.boxId}:b${n}`),
  ...t.blockStyling === void 0 ? {} : { blockStyling: { ...t.blockStyling } },
  ...o === void 0 ? {} : { characterStyling: o },
  runs: r
}), Po = (e, t, n, o) => {
  const r = e.blocks[t.blockIndex];
  if (!r || !w(r.kind))
    throw new Error(
      `openEditorLineAtTableStop: no table at index ${t.blockIndex}`
    );
  const i = t.offset === 0 ? t.blockIndex : t.blockIndex + 1, s = Fo(
    e,
    r,
    i,
    n.characterStyling,
    n.runs
  );
  return {
    box: {
      ...e,
      blocks: [...e.blocks.slice(0, i), s, ...e.blocks.slice(i)]
    },
    undo: (l) => ({ ...l, blocks: l.blocks.filter((c, a) => a !== i) }),
    redo: o.redo,
    coalesceKey: o.coalesceKey,
    caretAfter: { blockIndex: i, offset: o.caretOffset }
  };
}, ds = (e, t) => Fo(e, t, 0, as(t, void 0), []), ce = (e, t, n) => {
  const o = e.blocks[t.blockIndex];
  if (!o)
    throw new Error(`splitEditorBlock: no block at index ${t.blockIndex}`);
  if (w(o.kind))
    return Po(
      e,
      t,
      {
        characterStyling: as(o, n),
        runs: []
      },
      {
        redo: (b) => ce(b, t, n).box,
        coalesceKey: "split-block",
        caretOffset: 0
      }
    );
  const r = o, { left: i, right: s } = Ao(o, t.offset), l = { ...o, runs: i }, c = s.length === 0 ? Co(o, n) : o.characterStyling, a = {
    kind: "paragraph",
    authoredContainerId: Lt(
      e,
      o.authoredContainerId ?? `${e.boxId}:b${t.blockIndex}`
    ),
    ...o.blockStyling === void 0 ? {} : { blockStyling: o.blockStyling },
    ...c === void 0 ? {} : { characterStyling: c },
    runs: s
  }, d = t.blockIndex;
  return {
    box: hn(
      {
        ...e,
        blocks: [
          ...e.blocks.slice(0, d),
          l,
          a,
          ...e.blocks.slice(d + 1)
        ]
      },
      d
    ),
    undo: (b) => ({
      ...b,
      blocks: [...b.blocks.slice(0, d), r, ...b.blocks.slice(d + 2)]
    }),
    redo: (b) => ce(b, t, n).box,
    coalesceKey: "split-block",
    caretAfter: { blockIndex: d + 1, offset: 0 }
  };
}, nd = (e, t, n, o) => {
  const r = Math.min(t, n), i = Math.max(t, n);
  if (!e.blocks[r] || !e.blocks[i])
    throw new Error(`setEditorParagraphRole: no blocks at ${r}..${i}`);
  const s = e.blocks.slice(r, i + 1).map((a, d) => ({
    index: r + d,
    containerId: a.authoredContainerId
  })), l = e.blocks, c = (a) => {
    const d = new Set(
      s.map(
        ({ index: u, containerId: f }) => f === void 0 ? u < a.blocks.length ? u : -1 : a.blocks.findIndex(
          (g) => g.authoredContainerId === f
        )
      )
    );
    return {
      ...a,
      blocks: a.blocks.map((u, f) => {
        if (!d.has(f)) return u;
        const g = { ...u };
        return o === void 0 ? delete g.role : g.role = o, g;
      })
    };
  };
  return {
    box: c(e),
    undo: (a) => ({ ...a, blocks: l }),
    redo: c,
    coalesceKey: "set-paragraph-role"
  };
}, us = (e) => e.length > 0 && e[e.length - 1].kind === "rule" && e.every((t) => C(t.kind)), fs = (e, t) => {
  if (e.length < 2) return !1;
  const n = e[e.length - 1];
  return n.kind !== "paragraph" || n.runs.length > 0 ? !1 : t !== null && n.authoredContainerId === t || us(e.slice(0, -1));
}, od = (e) => {
  const t = e.blocks.length, n = {
    kind: "paragraph",
    authoredContainerId: Lt(e, `${e.boxId}:home`),
    runs: []
  };
  return { box: { ...e, blocks: [...e.blocks, n] }, undo: (s) => ({
    ...s,
    blocks: s.blocks.filter((l, c) => c !== t)
  }), redo: (s) => ({
    ...s,
    blocks: [...s.blocks.slice(0, t), n, ...s.blocks.slice(t)]
  }), coalesceKey: "ensure-caretable" };
}, rd = (e, t = null) => {
  if (!fs(e.blocks, t)) return null;
  const n = e.blocks.length - 1, o = e.blocks.slice(0, n), r = e.blocks[n];
  return { box: { ...e, blocks: o }, undo: (c) => ({
    ...c,
    blocks: [...c.blocks, r]
  }), redo: (c) => ({
    ...c,
    blocks: c.blocks.filter((a, d) => d !== n)
  }), coalesceKey: "ensure-caretable" };
}, hs = (e, t, n, o) => {
  const r = e.blocks[t.blockIndex];
  if (!r)
    throw new Error(
      `insertEditorAtomicBlockAt: no block at index ${t.blockIndex}`
    );
  const i = t.blockIndex, s = () => ({
    ...r.blockStyling === void 0 ? {} : { blockStyling: { ...r.blockStyling } },
    ...r.characterStyling === void 0 ? {} : { characterStyling: { ...r.characterStyling } }
  });
  let l;
  if (w(r.kind))
    l = t.offset === 0 ? [n, r] : [r, n];
  else if (C(r.kind))
    l = [r, n];
  else if (r.runs.length === 0)
    l = [n];
  else {
    const { left: g, right: b } = Ao(r, t.offset);
    g.length === 0 ? l = [n, r] : b.length === 0 ? l = [r, n] : l = [
      { ...r, runs: g },
      n,
      {
        kind: "paragraph",
        authoredContainerId: Lt(
          e,
          r.authoredContainerId ?? `${e.boxId}:b${i}`
        ),
        ...s(),
        runs: b
      }
    ];
  }
  const c = l.indexOf(n), a = c < l.length - 1 ? l[c + 1] : e.blocks[i + 1];
  if (n.kind === "rule" && (a === void 0 || C(a.kind))) {
    const g = C(r.kind) ? r.characterStyling : Co(r, o.inheritStyle);
    l = [
      ...l.slice(0, c + 1),
      Fo(e, r, e.blocks.length, g, []),
      ...l.slice(c + 1)
    ];
  }
  const d = {
    ...e,
    blocks: [...e.blocks.slice(0, i), ...l, ...e.blocks.slice(i + 1)]
  }, u = (g) => ({
    ...g,
    blocks: [
      ...g.blocks.slice(0, i),
      r,
      ...g.blocks.slice(i + l.length)
    ]
  }), f = w(n.kind) ? { blockIndex: i + c, offset: 1 } : { blockIndex: i + c + 1, offset: 0 };
  return {
    box: d,
    undo: u,
    redo: o.redo,
    coalesceKey: o.coalesceKey,
    caretAfter: f
  };
}, id = (e, t) => {
  if (C(e.kind) || e.runs.length === 0)
    return;
  let n = 0, o;
  for (const r of e.runs) {
    const i = U(r), s = dt(
      r.styling,
      "insertEditorRule"
    );
    if (t <= n + i) return s ?? o;
    n += i, o = s ?? o;
  }
  return o;
}, ps = (e, t) => {
  const n = e.blocks[t.blockIndex];
  if (!n)
    throw new Error(`insertEditorRule: no block at index ${t.blockIndex}`);
  const o = id(n, t.offset), r = dt(
    n.characterStyling,
    "insertEditorRule"
  ), i = (o == null ? void 0 : o.fontSize) ?? (r == null ? void 0 : r.fontSize), s = (o == null ? void 0 : o.color) ?? (r == null ? void 0 : r.color), l = {
    ...r ?? {},
    ...i === void 0 ? {} : { fontSize: i },
    ...s === void 0 ? {} : { color: s }
  }, c = {
    kind: "rule",
    authoredContainerId: Lt(e, `${e.boxId}:rule`),
    ...n.blockStyling === void 0 ? {} : { blockStyling: { ...n.blockStyling } },
    ...Object.keys(l).length === 0 ? {} : { characterStyling: l },
    runs: []
  };
  return hs(e, t, c, {
    coalesceKey: "insert-rule",
    redo: (a) => ps(a, t).box,
    inheritStyle: o
  });
}, sd = (e, t, n, o) => {
  const r = Math.max(0, Math.min(t, n)), i = Math.min(e.blocks.length - 1, Math.max(t, n));
  let s = !1;
  const l = e.blocks.map((c, a) => {
    if (a < r || a > i || c.kind !== "rule") return c;
    const d = dt(
      c.characterStyling,
      "sizeEditorRuleLeading"
    ), u = o(a);
    return (d == null ? void 0 : d.fontSize) === u ? c : (s = !0, {
      ...c,
      characterStyling: { ...d ?? {}, fontSize: u }
    });
  });
  return s ? { ...e, blocks: l } : e;
}, mn = (e, t) => {
  let n = 0;
  for (let r = 0; r < e.runs.length; r++) {
    const i = e.runs[r], s = U(i);
    if (i.kind === "text" && t >= n && t <= n + s)
      return { kind: "in-run", runIndex: r, charInRun: t - n };
    n += s;
  }
  let o = 0;
  for (let r = 0; r < e.runs.length; r++) {
    if (t <= o) return { kind: "new-run", atIndex: r };
    o += U(e.runs[r]);
  }
  return { kind: "new-run", atIndex: e.runs.length };
}, $e = (e, t, n) => {
  const o = e.blocks[t.blockIndex];
  if (!o)
    throw new Error(`insertEditorText: no block at index ${t.blockIndex}`);
  const r = (p) => $e(p, t, n).box, i = "insert-text";
  if (w(o.kind)) {
    const p = gn(o);
    return Po(
      e,
      t,
      {
        characterStyling: ls(o),
        runs: [
          {
            kind: "text",
            characters: n,
            ...p === void 0 ? {} : { styling: p }
          }
        ]
      },
      { redo: r, coalesceKey: i, caretOffset: $(n).length }
    );
  }
  const s = mn(o, t.offset), l = (p) => ({
    blockIndex: t.blockIndex,
    offset: t.offset + A(p.blocks[t.blockIndex]) - A(o)
  });
  if (s.kind === "in-run") {
    const p = o.runs[s.runIndex];
    if (p.kind !== "text")
      throw new Error("insertEditorText: target run is not text");
    const h = p.characters, m = ut(
      p,
      ss(h, s.charInRun, n)
    ), k = tt(
      e,
      t.blockIndex,
      o.runs.map((S, y) => y === s.runIndex ? m : S)
    );
    return {
      box: k,
      undo: (S) => {
        const y = S.blocks[t.blockIndex].runs, v = y[s.runIndex];
        if (v.kind !== "text") return S;
        const T = ut(v, h);
        return tt(
          S,
          t.blockIndex,
          y.map((Y, L) => L === s.runIndex ? T : Y)
        );
      },
      redo: r,
      coalesceKey: i,
      caretAfter: l(k)
    };
  }
  const c = pn(o, s.atIndex), a = {
    kind: "text",
    characters: n,
    ...c === void 0 ? {} : { styling: c }
  }, d = [
    ...o.runs.slice(0, s.atIndex),
    a,
    ...o.runs.slice(s.atIndex)
  ], u = o.kind, f = o.descriptor, g = hn(
    tt(e, t.blockIndex, d),
    t.blockIndex
  );
  return {
    box: g,
    undo: (p) => {
      const h = tt(
        p,
        t.blockIndex,
        p.blocks[t.blockIndex].runs.filter((m, k) => k !== s.atIndex)
      );
      return To(
        h,
        t.blockIndex,
        u,
        f
      );
    },
    redo: r,
    coalesceKey: i,
    caretAfter: l(g)
  };
}, ze = (e, t, n) => {
  const o = t == null ? void 0 : t.serviceId;
  return {
    kind: "field",
    fieldKey: e,
    ...o === void 0 || o === "" ? {} : { caseServiceId: o },
    ...t === void 0 ? {} : { params: { ...t } },
    ...n === void 0 ? {} : { styling: n }
  };
}, gs = (e, t, n, o, r) => {
  const i = e.blocks[t.blockIndex];
  if (!i)
    throw new Error(`insertEditorField: no block at index ${t.blockIndex}`);
  const s = (h) => gs(h, t, n, o, r).box, l = "insert-field";
  if (w(i.kind))
    return Po(
      e,
      t,
      {
        characterStyling: ls(i),
        runs: [
          ze(
            n,
            o,
            Kt(gn(i), r)
          )
        ]
      },
      { redo: s, coalesceKey: l, caretOffset: 1 }
    );
  const c = mn(i, t.offset), a = i.runs, d = i.kind, u = i.descriptor, f = (h) => {
    const m = tt(h, t.blockIndex, a);
    return To(
      m,
      t.blockIndex,
      d,
      u
    );
  }, g = (h) => ({
    box: h,
    caretAfter: { blockIndex: t.blockIndex, offset: t.offset + 1 }
  });
  if (c.kind === "in-run") {
    const h = i.runs[c.runIndex];
    if (h.kind !== "text")
      throw new Error("insertEditorField: target run is not text");
    const m = $(h.characters), k = m.slice(0, c.charInRun).join(""), E = m.slice(c.charInRun).join(""), S = ze(
      n,
      o,
      Kt(h.styling, r)
    ), y = [];
    k && y.push(ut(h, k)), y.push(S), E && y.push(ut(h, E));
    const v = [
      ...i.runs.slice(0, c.runIndex),
      ...y,
      ...i.runs.slice(c.runIndex + 1)
    ];
    return { ...g(tt(e, t.blockIndex, v)), undo: f, redo: s, coalesceKey: l };
  }
  const b = [
    ...i.runs.slice(0, c.atIndex),
    ze(
      n,
      o,
      Kt(
        pn(i, c.atIndex),
        r
      )
    ),
    ...i.runs.slice(c.atIndex)
  ];
  return { ...g(
    hn(
      tt(e, t.blockIndex, b),
      t.blockIndex
    )
  ), undo: f, redo: s, coalesceKey: l };
}, ms = (e, t, n, o, r, i) => {
  const s = e.blocks[t.blockIndex];
  if (!s)
    throw new Error(
      `insertEditorCaseDetailTable: no block at index ${t.blockIndex}`
    );
  const l = mn(s, t.offset), c = l.kind === "in-run" ? dt(
    s.runs[l.runIndex].styling,
    "insertEditorCaseDetailTable"
  ) : pn(s, l.atIndex), a = Kt(c, r), d = {
    kind: "case_detail_table",
    authoredContainerId: Lt(e, `${e.boxId}:table`),
    ...s.blockStyling === void 0 ? {} : { blockStyling: { ...s.blockStyling } },
    ...s.characterStyling === void 0 ? {} : { characterStyling: { ...s.characterStyling } },
    runs: Array.from(
      { length: Math.max(1, o) },
      (u, f) => ({
        kind: "field",
        fieldKey: n,
        params: { ...i, cellIndex: f },
        ...a === void 0 ? {} : { styling: { ...a } }
      })
    )
  };
  return hs(e, t, d, {
    coalesceKey: "insert-case-detail-table",
    redo: (u) => ms(u, t, n, o, r, i).box,
    inheritStyle: dt(
      c,
      "insertEditorCaseDetailTable"
    )
  });
}, ld = (e, t) => {
  const n = t === void 0 ? void 0 : { ...t };
  return e.kind === "field" ? [ze(e.fieldKey, void 0, n)] : e.text === "" ? [] : [
    {
      kind: "text",
      characters: e.text,
      ...n === void 0 ? {} : { styling: n }
    }
  ];
}, cd = /* @__PURE__ */ new Set([
  "heading",
  "subheading",
  "deceased_name"
]), mr = (e) => {
  if (e.role === void 0 || !cd.has(e.role))
    return e;
  const { role: t, ...n } = e;
  return n;
}, bs = (e, t, n, o) => {
  const r = e.blocks[t.blockIndex];
  if (!r)
    throw new Error(
      `insertEditorFieldParagraphs: no block at index ${t.blockIndex}`
    );
  if (n.length === 0)
    throw new Error("insertEditorFieldParagraphs: no paragraphs to insert");
  const i = t.blockIndex, s = C(r.kind), l = w(r.kind), c = mn(r, t.offset), a = Kt(
    l ? gn(r) : s ? void 0 : c.kind === "in-run" ? r.runs[c.runIndex].styling : pn(r, c.atIndex),
    o
  ), d = n.map(
    (R) => R.flatMap((z) => ld(z, a))
  ), { left: u, right: f } = s ? { left: r.runs, right: [] } : Ao(r, t.offset), g = !s && A(r) === 0, b = !g && u.length > 0 && f.length > 0, p = cs(
    e,
    r.authoredContainerId ?? `${e.boxId}:b${i}`,
    d.length - (g ? 1 : 0) + (b ? 1 : 0)
  ), h = (R, z) => ({
    kind: "paragraph",
    authoredContainerId: z,
    ...r.role === void 0 ? {} : { role: r.role },
    ...r.blockStyling === void 0 ? {} : { blockStyling: { ...r.blockStyling } },
    ...r.characterStyling === void 0 ? {} : { characterStyling: { ...r.characterStyling } },
    ...r.lang === void 0 ? {} : { lang: r.lang },
    runs: R
  }), m = (R, z) => mr(h(R, z)), k = g ? [
    { ...mr(r), runs: d[0] },
    ...d.slice(1).map((R, z) => m(R, p[z]))
  ] : d.map((R, z) => m(R, p[z])), E = s ? l && t.offset === 0 : u.length === 0, S = g ? k : b ? [
    { ...r, runs: u },
    ...k,
    h(f, p[d.length])
  ] : E ? [...k, r] : [r, ...k], y = k[k.length - 1], v = {
    blockIndex: i + S.indexOf(y),
    offset: A(y)
  };
  return {
    box: {
      ...e,
      blocks: [...e.blocks.slice(0, i), ...S, ...e.blocks.slice(i + 1)]
    },
    undo: (R) => ({
      ...R,
      blocks: [
        ...R.blocks.slice(0, i),
        r,
        ...R.blocks.slice(i + S.length)
      ]
    }),
    redo: (R) => bs(R, t, n, o).box,
    coalesceKey: "insert-field-paragraphs",
    caretAfter: v
  };
}, xs = (e, t, n, o) => {
  var i;
  let r = 0;
  for (let s = 0; s <= t; s++) {
    const l = ((i = e.blocks[s]) == null ? void 0 : i.runs) ?? [], c = s === t ? n : l.length;
    for (let a = 0; a < c; a++) {
      const d = l[a];
      d.kind === "field" && d.fieldKey === o && (r += 1);
    }
  }
  return r;
}, ks = (e, t, n) => {
  let o = 0;
  for (let r = 0; r < e.blocks.length; r++) {
    const i = e.blocks[r].runs;
    for (let s = 0; s < i.length; s++) {
      const l = i[s];
      if (l.kind === "field" && l.fieldKey === t) {
        if (o === n) return { blockIndex: r, runIndex: s };
        o += 1;
      }
    }
  }
  return null;
}, ys = (e, t, n, o = 0, r) => {
  const i = e.blocks[o], s = i == null ? void 0 : i.runs[t];
  if (!s || s.kind !== "field")
    throw new Error(
      `setEditorFieldParameters: run ${t} in block ${o} is not a field`
    );
  const l = s.fieldKey, c = xs(e, o, t, l), a = i.runs, d = Kt(s.styling, r), u = {
    ...s,
    params: { ...n },
    ...d === void 0 ? {} : { styling: d }
  }, f = i.runs.map((p, h) => h === t ? u : p), g = (p) => {
    const h = ks(p, l, c);
    return h === null ? p : ys(p, h.runIndex, n, h.blockIndex, r).box;
  }, b = (p) => tt(p, o, a);
  return {
    box: tt(e, o, f),
    undo: b,
    redo: g,
    coalesceKey: "set-field-params"
  };
}, Ss = (e) => !$l(e), ad = (e, t, n) => {
  const o = /* @__PURE__ */ new Map();
  if (C(e.kind)) return o;
  const r = cn(
    Vt(e.runs, n)
  ), i = ai(r), s = i.walks.find(
    (d) => r[d.piece].carrier === t
  );
  if (s === void 0) return o;
  const l = [];
  let c = -1, a = 0;
  for (const d of i.chars)
    d.piece !== c && (c = d.piece, a = 0), l.push(a), Ss(d.ch) && (a += 1);
  for (const d of s.abandoned) {
    const u = r[i.chars[d].piece].carrier, f = o.get(u) ?? /* @__PURE__ */ new Set();
    f.add(l[d]), o.set(u, f);
  }
  return o;
}, dd = (e, t) => {
  let n = "", o = 0;
  for (const r of e) {
    if (!Ss(r)) {
      n += r;
      continue;
    }
    t.has(o) || (n += r), o += 1;
  }
  return n;
}, ud = (e, t, n, o, r = 0) => {
  const i = e.blocks[r], s = i == null ? void 0 : i.runs[t];
  if (!s || s.kind !== "field")
    throw new Error(
      `convertEditorFieldToText: run ${t} in block ${r} is not a field`
    );
  const l = s.fieldKey, c = xs(e, r, t, l), a = i.runs, d = i.kind, u = i.descriptor, f = (p, h) => {
    const m = p.blocks[h.blockIndex], k = m == null ? void 0 : m.runs[h.runIndex];
    if (!k || k.kind !== "field") return p;
    const E = {
      kind: "text",
      characters: n,
      ...k.styling === void 0 ? {} : { styling: k.styling },
      ...k.lang === void 0 ? {} : { lang: k.lang }
    }, S = ad(m, h.runIndex, o);
    return hn(
      tt(
        p,
        h.blockIndex,
        m.runs.map((y, v) => {
          if (v === h.runIndex) return E;
          const T = S.get(v);
          return T === void 0 || y.kind !== "text" ? y : ut(y, dd(y.characters, T));
        })
      ),
      h.blockIndex
    );
  }, g = (p) => {
    const h = ks(p, l, c);
    return h === null ? p : f(p, h);
  }, b = (p) => {
    const h = tt(p, r, a);
    return To(
      h,
      r,
      d,
      u
    );
  };
  return {
    box: f(e, { blockIndex: r, runIndex: t }),
    undo: b,
    redo: g,
    coalesceKey: "convert-field-to-text"
  };
}, fd = (e, t) => {
  if (t <= 0) return { kind: "none" };
  const n = t - 1;
  let o = 0;
  for (let r = 0; r < e.runs.length; r++) {
    const i = e.runs[r], s = U(i);
    if (n >= o && n < o + s) {
      if (i.kind === "field") return { kind: "field", runIndex: r };
      const l = n - o;
      return {
        kind: "char",
        runIndex: r,
        charInRun: l,
        cluster: $(i.characters)[l]
      };
    }
    o += s;
  }
  return { kind: "none" };
}, br = (e, t) => {
  const { characterStyling: n, ...o } = e;
  return t === void 0 ? o : { ...o, characterStyling: t };
}, jt = (e) => e !== void 0 && nt(e) && A(e) === 0, _o = (e, t, n) => ({
  box: e,
  undo: (o) => o,
  redo: (o) => o,
  coalesceKey: n,
  caretAfter: t
}), Es = (e, t) => {
  const n = e.blocks[t], o = e.blocks[t - 1];
  if (nt(n)) return { blockIndex: t, offset: 0 };
  if (o !== void 0 && nt(o))
    return { blockIndex: t - 1, offset: A(o) };
  if (N(o)) return { blockIndex: t - 1, offset: 1 };
  if (N(n)) return { blockIndex: t, offset: 0 };
  const r = e.blocks.slice(t);
  return Gi(o, r) ? null : {
    blockIndex: t + r.findIndex((i) => i.kind !== "rule"),
    offset: 0
  };
}, Is = (e, t, n) => {
  const o = e.blocks[t], r = {
    ...e,
    blocks: e.blocks.filter((s, l) => l !== t)
  }, i = n.caretAfter ?? Es(r, t);
  return i === null ? {
    box: {
      ...e,
      blocks: e.blocks.map(
        (s, l) => l === t ? ds(e, o) : s
      )
    },
    undo: (s) => ({
      ...s,
      blocks: s.blocks.map((l, c) => c === t ? o : l)
    }),
    redo: n.redo,
    coalesceKey: n.coalesceKey,
    caretAfter: { blockIndex: t, offset: 0 }
  } : {
    box: r,
    undo: (s) => ({
      ...s,
      blocks: [...s.blocks.slice(0, t), o, ...s.blocks.slice(t)]
    }),
    redo: n.redo,
    coalesceKey: n.coalesceKey,
    caretAfter: i
  };
}, vs = (e, t, n) => {
  const o = e.blocks[t], r = e.blocks[t + 1], i = {
    ...o,
    runs: [...o.runs, ...r.runs]
  };
  return {
    box: {
      ...e,
      blocks: [
        ...e.blocks.slice(0, t),
        i,
        ...e.blocks.slice(t + 2)
      ]
    },
    undo: (s) => ({
      ...s,
      blocks: [
        ...s.blocks.slice(0, t),
        o,
        r,
        ...s.blocks.slice(t + 1)
      ]
    }),
    redo: n.redo,
    coalesceKey: n.coalesceKey,
    caretAfter: n.caretAfter
  };
}, he = (e, t) => {
  const n = e.blocks[t.blockIndex];
  if (!n)
    throw new Error(`deleteEditorBackward: no block at index ${t.blockIndex}`);
  const o = (h) => he(h, t).box, r = "delete-backward", i = t.blockIndex, s = e.blocks[i - 1], l = (h, m) => Is(e, h, { redo: o, coalesceKey: r, caretAfter: m }), c = (h) => _o(e, h, r);
  if (w(n.kind))
    return t.offset > 0 ? l(i) : s === void 0 ? c(t) : w(s.kind) ? l(i - 1) : s.kind === "rule" || jt(s) ? l(i - 1, { blockIndex: i - 1, offset: 0 }) : c({ blockIndex: i - 1, offset: A(s) });
  if (t.offset <= 0)
    return (s == null ? void 0 : s.kind) === "rule" ? l(i - 1, { blockIndex: i - 1, offset: 0 }) : n.kind === "rule" ? s === void 0 ? c(t) : w(s.kind) ? l(i - 1) : l(i, {
      blockIndex: i - 1,
      offset: A(s)
    }) : N(s) ? jt(n) ? l(i, { blockIndex: i - 1, offset: 1 }) : c({ blockIndex: i - 1, offset: 1 }) : jt(n) && N(e.blocks[i + 1]) ? l(i, { blockIndex: i, offset: 0 }) : s === void 0 ? c(t) : vs(e, i - 1, {
      redo: o,
      coalesceKey: r,
      caretAfter: { blockIndex: i - 1, offset: A(s) }
    });
  const a = fd(n, t.offset);
  if (a.kind === "none") return c(t);
  const d = { blockIndex: i, offset: t.offset - 1 };
  if (a.kind === "char") {
    const h = n.runs[a.runIndex];
    if (h.kind !== "text")
      throw new Error("deleteEditorBackward: target run is not text");
    const m = Qa(h.characters, a.charInRun, 1);
    if (m === "") {
      const y = n.runs.filter((L, R) => R !== a.runIndex), v = n.characterStyling;
      return { box: {
        ...e,
        blocks: e.blocks.map(
          (L, R) => R === t.blockIndex ? Nt(L, y, h) : L
        )
      }, undo: (L) => ({
        ...L,
        blocks: L.blocks.map(
          (R, z) => z === t.blockIndex ? br(
            {
              ...R,
              runs: [
                ...R.runs.slice(0, a.runIndex),
                h,
                ...R.runs.slice(a.runIndex)
              ]
            },
            v
          ) : R
        )
      }), redo: o, coalesceKey: r, caretAfter: d };
    }
    const k = ut(h, m);
    return { box: tt(
      e,
      t.blockIndex,
      n.runs.map((y, v) => v === a.runIndex ? k : y)
    ), undo: (y) => {
      const v = y.blocks[t.blockIndex].runs, T = v[a.runIndex];
      if (T.kind !== "text") return y;
      const Y = ut(
        T,
        ss(T.characters, a.charInRun, a.cluster)
      );
      return tt(
        y,
        t.blockIndex,
        v.map((L, R) => R === a.runIndex ? Y : L)
      );
    }, redo: o, coalesceKey: r, caretAfter: d };
  }
  const u = n.runs[a.runIndex], f = n.runs.filter((h, m) => m !== a.runIndex), g = n.characterStyling;
  return { box: {
    ...e,
    blocks: e.blocks.map(
      (h, m) => m === t.blockIndex ? Nt(h, f, u) : h
    )
  }, undo: (h) => ({
    ...h,
    blocks: h.blocks.map(
      (m, k) => k === t.blockIndex ? br(
        {
          ...m,
          runs: [
            ...m.runs.slice(0, a.runIndex),
            u,
            ...m.runs.slice(a.runIndex)
          ]
        },
        g
      ) : m
    )
  }), redo: o, coalesceKey: r, caretAfter: d };
}, Je = (e, t) => {
  const n = e.blocks[t.blockIndex];
  if (!n)
    throw new Error(`deleteEditorForward: no block at index ${t.blockIndex}`);
  const o = (a) => Je(a, t).box, r = "delete-forward", i = t.blockIndex, s = e.blocks[i + 1], l = (a, d) => Is(e, a, { redo: o, coalesceKey: r, caretAfter: d }), c = (a) => _o(e, a, r);
  return w(n.kind) ? t.offset === 0 ? l(i) : s === void 0 ? c(t) : w(s.kind) ? l(i + 1) : s.kind === "rule" || jt(s) ? l(i + 1, { blockIndex: i, offset: 1 }) : c({ blockIndex: i + 1, offset: 0 }) : n.kind === "rule" ? s === void 0 ? c(t) : l(i, { blockIndex: i, offset: 0 }) : t.offset < A(n) ? { ...he(e, {
    blockIndex: i,
    offset: t.offset + 1
  }), redo: o, coalesceKey: r, caretAfter: t } : (s == null ? void 0 : s.kind) === "rule" ? l(i + 1, t) : jt(n) && N(e.blocks[i - 1]) ? l(i, { blockIndex: i - 1, offset: 1 }) : s === void 0 ? c(t) : w(s.kind) ? jt(n) ? l(i, { blockIndex: i, offset: 0 }) : c({ blockIndex: i + 1, offset: 0 }) : vs(e, i, { redo: o, coalesceKey: r, caretAfter: t });
}, wn = (e, t, n) => {
  const o = [];
  let r = 0;
  for (const i of e.runs) {
    const s = r, l = r + U(i);
    if (r = l, l <= t || s >= n) {
      o.push(i);
      continue;
    }
    if (i.kind === "field") continue;
    const c = $(i.characters), a = c.slice(0, Math.max(0, t - s)).join("") + c.slice(Math.min(c.length, n - s)).join("");
    a && o.push(ut(i, a));
  }
  return o;
}, hd = (e, t, n, o) => {
  if (t.blockIndex === o.blockIndex)
    return nt(e) ? [
      Nt(
        e,
        wn(e, t.offset, o.offset),
        e.runs[0]
      )
    ] : [];
  const r = nt(e) ? wn(e, t.offset, Number.POSITIVE_INFINITY) : null, i = nt(n) ? wn(n, 0, o.offset) : null;
  if (r !== null && i !== null)
    return [Nt(e, [...r, ...i], e.runs[0])];
  const s = [];
  return r !== null ? s.push(Nt(e, r, e.runs[0])) : (N(e) && t.offset > 0 || e.kind === "rule" && n.kind === "rule") && s.push(e), i !== null ? s.push(Nt(n, i, n.runs[0])) : N(n) && o.offset === 0 && s.push(n), s;
}, pd = (e, t, n, o, r) => {
  if (N(t) && n.offset > 0)
    return r.blockIndex > n.blockIndex && nt(o) ? { blockIndex: n.blockIndex + 1, offset: 0 } : n;
  if (nt(t) || t.kind === "rule" && o.kind === "rule")
    return n;
  const i = e.blocks[n.blockIndex];
  return t.kind === "rule" && (nt(i) || N(i)) ? { blockIndex: n.blockIndex, offset: 0 } : Es(e, n.blockIndex);
}, Lo = (e, t, n) => {
  const [o, r] = V(t, n), i = (h) => Lo(h, t, n).box, s = "delete-range";
  if (P(o, r) === 0)
    return _o(e, o, s);
  const l = e.blocks[o.blockIndex], c = e.blocks[r.blockIndex];
  if (!l || !c)
    throw new Error(
      `deleteEditorRange: no block at index ${l ? r.blockIndex : o.blockIndex}`
    );
  const a = (h) => ({
    ...e,
    blocks: [
      ...e.blocks.slice(0, o.blockIndex),
      ...h,
      ...e.blocks.slice(r.blockIndex + 1)
    ]
  }), d = hd(l, o, c, r), u = pd(a(d), l, o, c, r), f = u === null ? [ds(e, l)] : d, g = a(f), b = e.blocks.slice(o.blockIndex, r.blockIndex + 1);
  return {
    box: g,
    undo: (h) => ({
      ...h,
      blocks: [
        ...h.blocks.slice(0, o.blockIndex),
        ...b,
        ...h.blocks.slice(o.blockIndex + f.length)
      ]
    }),
    redo: i,
    coalesceKey: s,
    caretAfter: u ?? { blockIndex: o.blockIndex, offset: 0 }
  };
}, Ft = (e) => ({
  ok: !0,
  target: e
}), lt = (e) => ({
  ok: !1,
  reason: e
}), Oo = (e, t, n) => {
  const o = [];
  let r = 0;
  for (let i = 0; i < e.runs.length; i++) {
    const s = U(e.runs[i]), l = Math.max(t, r), c = Math.min(n, r + s);
    l < c && o.push({
      runIndex: i,
      start: l - r,
      end: c - r,
      runLength: s
    }), r += s;
  }
  return o;
}, Do = (e) => Oo(e, 0, Number.POSITIVE_INFINITY), gd = (e, t) => {
  if (t.kind !== "within-box") return null;
  const { anchor: n, focus: o } = t;
  if (n.blockIndex !== o.blockIndex) return null;
  const r = e.blocks[n.blockIndex];
  if (!r) return null;
  const i = Math.min(n.offset, o.offset), s = Math.max(n.offset, o.offset);
  if (s <= i) return null;
  const l = w(r.kind) ? _t(n, o, n.blockIndex) ? Do(r) : [] : Oo(r, i, s);
  return l.length > 0 ? { blockIndex: n.blockIndex, pieces: l } : null;
}, md = (e) => {
  let t = 0;
  for (const n of e.runs) {
    if (n.kind !== "field") break;
    t += U(n);
  }
  return t;
}, bd = (e) => {
  let t = 0;
  for (let n = e.runs.length - 1; n >= 0 && e.runs[n].kind === "field"; n--)
    t += U(e.runs[n]);
  return t;
}, xd = (e, t) => {
  const n = md(e);
  return n > 0 && t > 0 && t <= n ? 0 : t;
}, kd = (e, t) => {
  const n = bd(e), o = A(e);
  return n > 0 && t < o && t >= o - n ? o : t;
}, yd = (e, t) => {
  if (t.kind !== "within-box") return null;
  const { anchor: n, focus: o } = t;
  if (n.blockIndex === o.blockIndex) return null;
  const [r, i] = n.blockIndex < o.blockIndex ? [n, o] : [o, n], s = [];
  for (let l = r.blockIndex; l <= i.blockIndex; l++) {
    const c = e.blocks[l];
    if (!c) return null;
    if (w(c.kind)) {
      const f = _t(r, i, l) ? Do(c) : [];
      f.length > 0 && s.push({ blockIndex: l, pieces: f });
      continue;
    }
    if (C(c.kind)) {
      s.push({ blockIndex: l, pieces: [] });
      continue;
    }
    let a = l === r.blockIndex ? r.offset : 0, d = l === i.blockIndex ? i.offset : A(c);
    l === r.blockIndex && (a = xd(c, a)), l === i.blockIndex && (d = kd(c, d));
    const u = Oo(c, a, d);
    u.length > 0 && s.push({ blockIndex: l, pieces: u });
  }
  return s;
}, ws = (e, t) => {
  const n = e.blocks[t], o = n === void 0 ? [] : Do(n);
  return o.length > 0 ? Ft({ selection: "cross-block", blocks: [{ blockIndex: t, pieces: o }] }) : lt("the selected table holds no cell to style");
}, Fe = (e, t, n) => {
  if (e.fieldModal)
    return lt("field styling goes through the field modal, not the bridge");
  switch (e.mode) {
    case "edit-single-textbox":
      return Ft({ selection: "whole-box" });
    case "edit-inside-single-textbox": {
      if (!n || n.kind !== "within-box")
        return lt(
          "inside-box styling needs an in-text (within-box) selection"
        );
      const o = Yt(t, n);
      if (o !== null) return ws(t, o);
      if (n.anchor.blockIndex !== n.focus.blockIndex) {
        const l = yd(t, n);
        return l === null || l.length === 0 ? lt("selection spans blocks but covers no text to style") : Ft({ selection: "cross-block", blocks: l });
      }
      const r = gd(t, n);
      if (r === null)
        return lt("selection is a caret or out of range — nothing to style");
      const { blockIndex: i, pieces: s } = r;
      if (s.length === 1) {
        const l = s[0];
        return l.start === 0 && l.end === l.runLength ? Ft({ selection: "run", blockIndex: i, runIndex: l.runIndex }) : Ft({
          selection: "sub-run",
          blockIndex: i,
          runIndex: l.runIndex,
          start: l.start,
          end: l.end,
          runLength: l.runLength
        });
      }
      return Ft({ selection: "cross-run", blockIndex: i, pieces: s });
    }
  }
}, Sd = (e, t, n) => {
  if (w(e.kind)) return null;
  const o = Math.min(t, n), r = Math.max(t, n);
  let i = 0;
  for (let s = 0; s < e.runs.length; s++) {
    const l = U(e.runs[s]), c = i, a = i + l;
    if (e.runs[s].kind === "field") {
      const d = o === r && o === c, u = o < r && o <= c && r >= a;
      if (d || u) return s;
    }
    i = a;
  }
  return null;
}, Jh = (e, t, n) => {
  if (!e.fieldModal) return lt("the field modal is not open");
  if (!n || n.kind !== "within-box")
    return lt("field styling needs a within-box selection on the field");
  const o = Yt(t, n);
  if (o !== null) return ws(t, o);
  const { anchor: r, focus: i } = n;
  if (r.blockIndex !== i.blockIndex)
    return lt("a field selection stays within one block");
  const s = t.blocks[r.blockIndex];
  if (!s) return lt("selection block is out of range");
  const l = Sd(s, r.offset, i.offset);
  return l === null ? lt("the caret is not on a dynamic field") : Ft({ selection: "run", blockIndex: r.blockIndex, runIndex: l });
}, I = (e, t, n) => ({
  kind: "edit-action",
  action: e,
  modeScope: t,
  supported: n
}), Dt = (e) => ({
  kind: "rejected",
  reason: e
}), xr = { kind: "composition" }, jn = {
  insertText: I("insert-text", "inside-box-only", !0),
  insertReplacementText: I("replace-text", "inside-box-only", !1),
  insertLineBreak: I("insert-hard-break", "inside-box-only", !0),
  insertParagraph: I("split-block", "inside-box-only", !0),
  insertHorizontalRule: I(
    "insert-horizontal-rule",
    "inside-box-only",
    !1
  ),
  insertOrderedList: Dt("lists are not supported yet"),
  insertUnorderedList: Dt("lists are not supported yet"),
  insertFromYank: I("insert-text", "inside-box-only", !0),
  insertFromPaste: I("paste", "inside-box-only", !1),
  insertFromPasteAsQuotation: I("paste", "inside-box-only", !1),
  insertFromDrop: Dt("drag-and-drop text moves are not supported yet"),
  insertTranspose: I("transpose", "inside-box-only", !1),
  insertCompositionText: xr,
  insertFromComposition: xr,
  insertLink: Dt("link insertion is not supported yet"),
  deleteContentBackward: I("delete-text", "mode-conditional", !0),
  deleteContentForward: I("delete-text", "mode-conditional", !0),
  deleteContent: I("delete-text", "mode-conditional", !0),
  deleteWordBackward: I("delete-text", "inside-box-only", !0),
  deleteWordForward: I("delete-text", "inside-box-only", !0),
  deleteSoftLineBackward: I("delete-text", "inside-box-only", !0),
  deleteSoftLineForward: I("delete-text", "inside-box-only", !0),
  deleteEntireSoftLine: I("delete-text", "inside-box-only", !1),
  deleteHardLineBackward: I("delete-text", "inside-box-only", !1),
  deleteHardLineForward: I("delete-text", "inside-box-only", !1),
  deleteByCut: I("delete-text", "mode-conditional", !0),
  deleteByDrag: Dt("drag-and-drop text moves are not supported yet"),
  historyUndo: I("undo", "any-mode", !0),
  historyRedo: I("redo", "any-mode", !0),
  formatBold: I("apply-mark", "inside-box-only", !0),
  formatItalic: I("apply-mark", "inside-box-only", !0),
  formatUnderline: I("apply-mark", "inside-box-only", !0),
  formatStrikeThrough: I("apply-mark", "inside-box-only", !0),
  formatStrikethrough: I("apply-mark", "inside-box-only", !0),
  formatSuperscript: I("apply-mark", "inside-box-only", !1),
  formatSubscript: I("apply-mark", "inside-box-only", !1),
  formatJustifyFull: I("set-block-property", "inside-box-only", !0),
  formatJustifyCenter: I(
    "set-block-property",
    "inside-box-only",
    !0
  ),
  formatJustifyRight: I("set-block-property", "inside-box-only", !0),
  formatJustifyLeft: I("set-block-property", "inside-box-only", !0),
  formatIndent: I("set-block-property", "inside-box-only", !1),
  formatOutdent: I("set-block-property", "inside-box-only", !1),
  formatRemove: I("clear-formatting", "inside-box-only", !1),
  formatSetBlockTextDirection: I(
    "set-block-direction",
    "inside-box-only",
    !1
  ),
  formatSetInlineTextDirection: I(
    "apply-mark",
    "inside-box-only",
    !1
  ),
  formatBackColor: Dt("text background colour is not supported"),
  formatFontColor: I("apply-mark", "inside-box-only", !0),
  formatFontName: I("apply-mark", "inside-box-only", !0)
}, Rn = (e) => jn[e] ?? { kind: "unhandled" }, Zh = Object.keys(
  jn
).filter((e) => {
  const t = jn[e];
  return t.kind === "edit-action" && t.supported;
}), Ed = /\s/, Id = /\s$/, kr = (e, t, n) => {
  const o = [];
  for (const c of e.runs)
    if (c.kind === "text")
      for (const a of $(c.characters))
        o.push(a);
    else o.push(null);
  const r = o.length, i = (c) => {
    const a = c >= 0 && c < r ? o[c] : void 0;
    return a != null && !Ed.test(a);
  };
  let s = t, l = t;
  if (i(t)) {
    for (; s > 0 && i(s - 1); ) s--;
    for (; l < r && i(l); ) l++;
  } else if (i(t - 1))
    for (; s > 0 && i(s - 1); ) s--;
  else
    return null;
  return l <= s ? null : { start: s, end: l };
}, vd = (e, t) => Id.test(e), wd = (e, t) => e.kind === "text" ? { kind: "literal", text: e.characters, carrier: t } : { kind: "field", fieldKey: e.fieldKey, carrier: t }, Rs = (e, t) => e.length === t.runs.length && e.every((n, o) => n === t.runs[o]), Rd = (e) => {
  if (C(e.kind) || e.runs.length === 0)
    return e;
  const t = e.runs.map(wd), n = hi(t);
  if (n === t) return e;
  const o = n.map((r) => io(r, e.runs));
  return Rs(o, e) ? e : { ...e, runs: o };
}, yr = (e, t) => {
  if (C(e.kind)) return e;
  const n = [...e.runs], o = () => t === "lead" ? 0 : n.length - 1;
  let r = !1;
  for (; n.length > 0; ) {
    const i = n[o()];
    if (i.kind !== "text") break;
    const s = t === "lead" ? i.characters.replace(/^\n+/, "") : i.characters.replace(/\n+$/, "");
    if (s === i.characters) break;
    if (r = !0, s === "") n.splice(o(), 1);
    else {
      n[o()] = { ...i, characters: s };
      break;
    }
  }
  return r ? { ...e, runs: n } : e;
}, Qh = (e) => {
  const t = e.blocks.map(Rd);
  return t.length > 0 && (t[0] = yr(t[0], "lead")), t.length > 0 && (t[t.length - 1] = yr(t[t.length - 1], "trail")), t.length === e.blocks.length && t.every((o, r) => o === e.blocks[r]) ? e : { ...e, blocks: t };
}, Td = (e, t) => {
  let n = !1;
  const o = e.blocks.map((r) => {
    if (C(r.kind) || r.runs.length === 0 || !r.runs.some((c) => c.kind === "field")) return r;
    const i = Vt(r.runs, t), s = cn(i);
    if (s === i) return r;
    const l = s.map(
      (c) => io(c, r.runs)
    );
    return Rs(l, r) ? r : (n = !0, { ...r, runs: l });
  });
  return n ? { ...e, blocks: o } : e;
}, Sr = (e) => {
  const t = [];
  for (const n of e.runs)
    if (n.kind === "field") t.push(null);
    else
      for (const o of $(n.characters))
        t.push(o);
  return t;
}, Ad = (e, t, n) => {
  if (!e || !t || e === t) return n;
  const o = Sr(e), r = Sr(t);
  let i = 0, s = 0, l = 0;
  for (; i < o.length || s < r.length; ) {
    if (i < o.length && s < r.length && o[i] === r[s]) {
      i++, s++;
      continue;
    }
    if (s < r.length && r[s] === " ") {
      i < n && l++, s++;
      continue;
    }
    if (i < o.length && o[i] === " ") {
      i < n && l--, i++;
      continue;
    }
    return Math.max(0, Math.min(n, r.length));
  }
  return Math.max(0, Math.min(n + l, r.length));
}, tp = (e) => e.dragging ? "drag" : e.editing ? "editing" : e.selected ? "selected" : "at-rest", Cd = (e) => e === "editing", ep = (e, t, n) => !Cd(e) || n === null || !Number.isFinite(n) ? t : Math.max(t, n), Fd = ({
  growth: e,
  framePx: t,
  textHeightPx: n
}) => e && n !== null && Number.isFinite(n) ? Math.max(t, n) : t, re = (e, t, n, o) => {
  if (!Number.isFinite(e) || !Number.isFinite(n) || !Number.isFinite(t) || !Number.isFinite(o) || e === n)
    return { perPx: 0, interceptPx: 0 };
  const r = (o - t) / (n - e);
  return { perPx: r, interceptPx: t - r * e };
}, $t = {
  perPx: 0,
  interceptPx: -1
}, Ze = (e, t, n) => {
  if (!(Number.isFinite(t) && t > 0)) return 0;
  const o = Number.isFinite(n) && n > 0 ? n : 1, r = e.perPx * t * o + e.interceptPx + 1;
  return r > 1e-9 ? Math.ceil(r - 1e-9) / o : 0;
}, Pd = (e) => {
  if (!(Number.isFinite(e.basePt) && e.basePt > 0) || !Number.isFinite(e.ascentEm) || !Number.isFinite(e.descentEm)) return 0;
  const t = Number.isFinite(e.lineHeightEm) && e.lineHeightEm > 0 ? e.lineHeightEm : 1, n = e.ascentEm + e.descentEm - t;
  return n > 0 ? n * e.basePt * Ut : 0;
}, _d = (e, t) => {
  if (!(Number.isFinite(t) && t > 0)) return { top: 0, bottom: 0 };
  let n = 0, o = 0, r = 0;
  for (const s of e) {
    if (s.raster && Number.isFinite(s.basePt) && s.basePt > 0) {
      const l = s.basePt * Ut * t;
      o = Math.max(
        o,
        Ze(s.raster.top, l, s.raster.dpr)
      ), r = Math.max(
        r,
        Ze(s.raster.bottom, l, s.raster.dpr)
      );
      continue;
    }
    n = Math.max(n, Pd(s));
  }
  const i = n * t / 2;
  return {
    top: Math.max(i, o),
    bottom: Math.max(i, r)
  };
}, Ld = (e, t) => {
  if (!(Number.isFinite(t) && t > 0)) return { left: 0, right: 0 };
  let n = 0, o = 0, r = 0, i = 0;
  for (const s of e) {
    if (!(Number.isFinite(s.basePt) && s.basePt > 0)) continue;
    if (s.raster) {
      const d = s.basePt * Ut * t;
      r = Math.max(
        r,
        Ze(s.raster.left, d, s.raster.dpr)
      ), i = Math.max(
        i,
        Ze(s.raster.right, d, s.raster.dpr)
      );
      continue;
    }
    const l = s.basePt * Ut, c = s.leftOverhangEm ?? 0;
    Number.isFinite(c) && c > 0 && (n = Math.max(n, c * l));
    const a = s.rightOverhangEm ?? 0;
    Number.isFinite(a) && a > 0 && (o = Math.max(o, a * l));
  }
  return {
    left: Math.max(n * t, r),
    right: Math.max(o * t, i)
  };
}, Er = (e, t) => e === null ? t : t === null ? e : {
  top: Math.min(e.top, t.top),
  left: Math.min(e.left, t.left),
  bottom: Math.max(e.bottom, t.bottom),
  right: Math.max(e.right, t.right)
}, ie = (e, t, n) => {
  if (!(Number.isFinite(e.basePt) && e.basePt > 0)) return 0;
  const o = e.basePt * Ut * n;
  if (e.raster) {
    const i = e.raster[t], s = Number.isFinite(e.raster.dpr) && e.raster.dpr > 0 ? e.raster.dpr : 1;
    return i.perPx * o + i.interceptPx / s;
  }
  if (t === "top" || t === "bottom") {
    if (!Number.isFinite(e.ascentEm) || !Number.isFinite(e.descentEm)) return 0;
    const i = Number.isFinite(e.lineHeightEm) && e.lineHeightEm > 0 ? e.lineHeightEm : 1;
    return (e.ascentEm + e.descentEm - i) / 2 * o;
  }
  const r = t === "left" ? e.leftOverhangEm : e.rightOverhangEm;
  return Number.isFinite(r) && r > 0 ? r * o : 0;
}, Od = (e, t, n) => {
  if (!(Number.isFinite(t) && t > 0)) return null;
  const o = e.filter(
    (i) => !i.filler && Number.isFinite(i.basePt) && i.basePt > 0
  );
  if (o.length === 0) return null;
  const r = (i) => Math.max(
    ...o.map((s) => ie(s, i, t))
  );
  return {
    top: n.paddingTop - r("top"),
    left: n.paddingLeft - r("left"),
    bottom: n.scrollHeight - n.paddingBottom + r("bottom"),
    right: n.scrollWidth - n.paddingRight + r("right")
  };
}, Ts = (e) => e > 0 ? Math.min(
  32,
  Math.max(1, Math.ceil(Math.log2(e / Ta)))
) : 1, Dd = (e, t = {}) => {
  const n = t.minScale ?? 0.4, o = Math.max(t.ceiling ?? 1, n), r = t.minGrow ?? 1, i = (a) => a > 1 && a < r ? { scale: 1, overflowing: !1 } : { scale: a, overflowing: !1 };
  if (e(o)) return i(o);
  if (!e(n)) return { scale: n, overflowing: !0 };
  let s = n, l = o;
  o > 1 && n <= 1 && (e(1) ? s = 1 : l = 1);
  const c = t.iterations ?? Ts(l - s);
  for (let a = 0; a < c; a++) {
    const d = (s + l) / 2;
    e(d) ? s = d : l = d;
  }
  return i(s);
}, Bd = (e, t = {}) => {
  const n = Math.min(1, t.minScale ?? 0.4);
  if (e(1)) return 1;
  if (!e(n)) return n;
  let o = n, r = 1;
  const i = t.iterations ?? Ts(r - o);
  for (let s = 0; s < i; s++) {
    const l = (o + r) / 2;
    e(l) ? o = l : r = l;
  }
  return o;
}, Pe = 5e-3, Md = (e) => e.filter((t) => Number.isFinite(t) && t > 0), As = (e) => {
  const t = Md(e.authoredBasesPt), n = t.length ? Math.min(...t) : 0, o = t.length ? Math.max(...t) : 0, r = Number.isFinite(e.scale) && e.scale > 0 ? e.scale : 1, i = o * r, s = r <= e.minScale + Pe, l = r >= e.ceilingScale - Pe, c = e.overflowing ? "overflowed" : r > 1 + Pe ? "grown" : r < 1 - Pe ? "shrunk" : "authored", a = e.longWord && e.bindingAxis !== "height" && c !== "grown", d = `${e.minSizePt} pt minimum`, u = (() => {
    switch (c) {
      case "overflowed":
        return a ? `A long word is at the ${d} and still overflows — enlarge the box or turn on word‑wrap.` : `Text is at the ${d} and still overflows — enlarge the box.`;
      case "shrunk":
        return a ? "Long line — shrinking to fit. Press ⏎ for a new line, or turn on word‑wrap." : "Shrunk to fit the box.";
      case "grown":
        return "Scaled up to fill the box.";
      case "authored":
        return "Fits at its set size.";
    }
  })();
  return {
    scale: r,
    state: c,
    overflowing: e.overflowing,
    bindingAxis: e.bindingAxis,
    longWord: a,
    authoredMinPt: n,
    authoredMaxPt: o,
    renderedPt: i,
    minSizePt: e.minSizePt,
    minScale: e.minScale,
    ceilingScale: e.ceilingScale,
    atMinScale: s,
    atCeiling: l,
    summary: u
  };
}, Cs = (e, t) => Math.floor(e * t + 1e-6) / t, pe = (e) => le(e, 1), Fs = (e) => Math.min(100, Math.max(-100, Cs(e, 1e4))), Ps = (e) => Math.min(100, Math.max(0, Cs(e, 1e4))), Nd = (e, t) => {
  const n = pe(e.fontSizePt * t), o = n / e.fontSizePt, r = { fontSize: n };
  return e.letterSpacing !== void 0 && e.letterSpacing !== 0 && (r.letterSpacing = Fs(
    e.letterSpacing * o
  )), e.textStrokeWidth !== void 0 && e.textStrokeWidth > 0 && (r.textStrokeWidth = Ps(
    e.textStrokeWidth * o
  )), r;
}, Ir = (e, t) => {
  if (!Number.isFinite(t) || t <= 0 || Math.abs(t - 1) < 1e-3)
    return e;
  const n = { ...e }, o = e.fontSize !== void 0 ? pe(e.fontSize * t) / e.fontSize : t;
  return e.fontSize !== void 0 && (n.fontSize = pe(e.fontSize * t)), e.letterSpacing !== void 0 && e.letterSpacing !== 0 && (n.letterSpacing = Fs(
    e.letterSpacing * o
  )), e.textStrokeWidth !== void 0 && e.textStrokeWidth > 0 && (n.textStrokeWidth = Ps(
    e.textStrokeWidth * o
  )), n;
}, Tn = (e, t) => Object.entries(t).every(([n, o]) => (e == null ? void 0 : e[n]) === o), $d = (e, t, n) => {
  let o = !1;
  const r = e.runs.map((l) => {
    const c = wt(l.styling, t.refs), a = Nd(
      gc(e, l, t),
      n
    );
    return Tn(c, a) ? l : (o = !0, { ...l, styling: Z(c, a) });
  });
  let i = o ? { ...e, runs: r } : e;
  if (e.runs.length === 0) {
    const l = Pt(
      ke(e, t)
    ), c = wt(
      e.characterStyling,
      t.refs
    ), a = { fontSize: pe(l.fontSizePt * n) };
    Tn(c, a) || (i = {
      ...i,
      characterStyling: Z(c, a)
    });
  }
  const s = oo(e.blockStyling, t.refs);
  if ((s == null ? void 0 : s.fontSize) !== void 0) {
    const l = { fontSize: pe(s.fontSize * n) };
    Tn(s, l) || (i = { ...i, blockStyling: ji(s, l) });
  }
  return i;
}, _s = (e, t, n) => {
  if (!Number.isFinite(n) || n <= 0 || Math.abs(n - 1) < 1e-3)
    return e;
  const o = e.blocks.map((r) => $d(r, t, n));
  return o.every((r, i) => r === e.blocks[i]) ? e : { ...e, blocks: o };
}, np = (e, t) => {
  const n = _s(
    e.box,
    e.context,
    t
  );
  return n === e.box ? e : je({
    anchor: e.anchor,
    revision: e.revision,
    box: n,
    context: e.context
  });
}, X = { kind: "native" }, zd = /* @__PURE__ */ new Set([
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown"
]), He = (e) => ({
  blockIndex: e.blockIndex,
  offset: e.side === "before" ? 0 : 1
}), Bt = (e, t) => ({
  kind: "caret",
  to: et(e, t)
}), Hd = (e, t) => {
  const n = So(e, t);
  return n === null ? null : Xe(e, n);
}, Qe = (e, t, n) => {
  var r;
  let o = t + n;
  for (; ((r = e.blocks[o]) == null ? void 0 : r.kind) === "rule"; ) o += n;
  return o;
}, Wd = (e, t) => {
  const n = Qe(e, t, -1), o = e.blocks[n];
  return o === void 0 ? { blockIndex: t, offset: 0 } : N(o) ? { blockIndex: n, offset: 1 } : { blockIndex: n, offset: A(o) };
}, Kd = (e, t) => {
  const n = Qe(e, t, 1), o = e.blocks[n];
  return o === void 0 ? { blockIndex: t, offset: 1 } : N(o) ? { blockIndex: n, offset: n === t + 1 ? 1 : 0 } : { blockIndex: n, offset: 0 };
}, vr = (e, t, n, o) => {
  const r = t.blockIndex;
  return nt(e.blocks[r]) ? n === "ArrowDown" && N(e.blocks[r + 1]) ? {
    kind: "line",
    direction: "forward",
    within: r,
    stop: { blockIndex: r + 1, offset: o ? 1 : 0 },
    extend: o
  } : n === "ArrowUp" && N(e.blocks[r - 1]) ? {
    kind: "line",
    direction: "backward",
    within: r,
    stop: et(e, {
      blockIndex: r - 1,
      offset: o ? 0 : 1
    }),
    extend: o
  } : null : null;
}, jd = (e, t, n, o, r) => {
  const { key: i } = n, s = i === "ArrowLeft" || i === "ArrowUp";
  if (n.shiftKey) {
    if (r !== null) {
      const u = P(t.focus, t.anchor) > 0;
      return s === u ? Bt(e, t.anchor) : X;
    }
    if (o === null)
      return vr(e, t.focus, i, !0) ?? X;
    const d = o.blockIndex;
    return !s && o.side === "before" ? {
      kind: "select",
      anchor: He(o),
      focus: { blockIndex: d, offset: 1 }
    } : s && o.side === "after" ? {
      kind: "select",
      anchor: He(o),
      focus: et(e, { blockIndex: d, offset: 0 })
    } : !s && N(e.blocks[d + 1]) ? {
      kind: "select",
      anchor: He(o),
      focus: { blockIndex: d + 1, offset: 1 }
    } : X;
  }
  if (r !== null)
    return Bt(e, { blockIndex: r, offset: s ? 0 : 1 });
  if (o !== null) {
    const d = o.blockIndex;
    return o.side === "before" ? Bt(
      e,
      s ? Wd(e, d) : { blockIndex: d, offset: 1 }
    ) : Bt(
      e,
      s ? { blockIndex: d, offset: 0 } : Kd(e, d)
    );
  }
  if (!D(t)) return X;
  const l = t.focus, c = e.blocks[l.blockIndex];
  if (c === void 0 || !nt(c)) return X;
  const a = l.blockIndex;
  if (i === "ArrowRight" && l.offset >= A(c)) {
    const d = Qe(e, a, 1);
    return N(e.blocks[d]) ? Bt(e, { blockIndex: d, offset: 0 }) : X;
  }
  if (i === "ArrowLeft" && l.offset === 0) {
    const d = Qe(e, a, -1);
    return N(e.blocks[d]) ? Bt(e, { blockIndex: d, offset: 1 }) : X;
  }
  return vr(e, l, i, !1) ?? X;
}, Gd = (e, t, n) => n ? t.side === "after" ? t.blockIndex : null : t.side === "before" ? t.blockIndex : N(e.blocks[t.blockIndex + 1]) ? t.blockIndex + 1 : null, Vd = (e, t, n, o, r) => {
  if (!D(t))
    return r ? {
      kind: "edit",
      edit: Lo(e, t.anchor, t.focus),
      selectionBefore: t
    } : X;
  if (o !== null) {
    const d = He(o), u = Gd(e, o, n);
    return {
      kind: "edit",
      edit: n ? he(e, d) : Je(e, d),
      selectionBefore: (u === null ? null : Hd(e, u)) ?? t
    };
  }
  const i = t.focus, s = e.blocks[i.blockIndex];
  if (s === void 0 || !nt(s)) return X;
  const l = A(s), c = e.blocks[i.blockIndex - 1], a = e.blocks[i.blockIndex + 1];
  return n && i.offset === 0 && (N(c) || l === 0 && N(a)) ? {
    kind: "edit",
    edit: he(e, i),
    selectionBefore: t
  } : !n && i.offset >= l && (N(a) || l === 0 && N(c)) ? {
    kind: "edit",
    edit: Je(e, i),
    selectionBefore: t
  } : X;
}, wr = (e, t) => {
  const n = Yt(e, t);
  return n === null ? null : { blockIndex: n, offset: 1 };
}, Ud = (e, t, n) => {
  const o = Xe(e, t), r = D(o), i = Yt(e, o), s = r ? Wt(e, o.focus) : null, [l, c] = V(o.anchor, o.focus), a = !r && (Wt(e, l) !== null || Wt(e, c) !== null), { key: d } = n, u = n.metaKey || n.altGraph !== !0 && (n.ctrlKey || n.altKey && n.macOS !== !0);
  return zd.has(d) ? u || n.altKey ? X : jd(e, o, n, s, i) : d === "Backspace" || d === "Delete" ? Vd(
    e,
    o,
    d === "Backspace",
    s,
    i !== null || a
  ) : s !== null || i !== null || a ? d === "Enter" ? u || n.altKey ? X : { kind: "split" } : d === "Process" || d === "Dead" ? (s !== null || i !== null) && !u ? { kind: "compose" } : X : !u && $(d).length === 1 ? { kind: "text", text: d } : X : X;
}, tn = (e) => {
  var t;
  return (t = e == null ? void 0 : e.dataset) == null ? void 0 : t[ct];
}, Bo = (e) => {
  const t = tn(e), n = [];
  if (t === void 0) return n;
  for (let o = e.previousElementSibling; o && tn(o) === t; o = o.previousElementSibling)
    n.unshift(o);
  return n;
}, Ls = (e) => {
  const t = tn(e);
  return t !== void 0 && tn(e.nextElementSibling) === t;
}, Rr = (e) => {
  var t;
  return e != null && e.nodeType === 1 && ((t = e.dataset) == null ? void 0 : t[qc]) !== void 0;
}, Yd = (e, t) => {
  const n = e[t];
  if (!C(n.kind)) return !1;
  const o = e[t + 1];
  return o === void 0 ? w(n.kind) : C(o.kind);
}, Tr = (e) => {
  const t = e.createElement("div");
  return t.setAttribute(xo, ""), t.style.height = "0px", t.style.overflow = "hidden", t.appendChild(e.createElement("br")), t;
}, qd = (e, t) => {
  const n = e[0], o = n === void 0 ? null : t(0);
  n !== void 0 && w(n.kind) && o && o.before(Tr(o.ownerDocument)), e.forEach((r, i) => {
    if (!Yd(e, i)) return;
    const s = t(i);
    s && s.after(Tr(s.ownerDocument));
  });
}, Ar = (e) => {
  e.querySelectorAll(`[${xo}]`).forEach(
    (t) => t.remove()
  );
}, Cr = (e, t) => ({
  blockIndex: e,
  offset: P(t, { blockIndex: e, offset: 0 }) <= 0 ? 1 : 0
}), en = (e, t) => {
  const n = e.getBoundingClientRect(), o = e.offsetWidth > 0 ? n.width / e.offsetWidth : 1;
  return Array.from(t).filter((r) => r.width > 0.5 && r.height > 0.5).map((r) => ({
    top: (r.top - n.top) / o,
    left: (r.left - n.left) / o,
    width: r.width / o,
    height: r.height / o
  }));
}, An = (e) => Bo(e).reduce(
  (t, n) => t + $(n.textContent || "").length,
  0
), Xd = (e, t) => {
  var o;
  let n = t;
  for (const [r, i] of e.entries()) {
    const s = $(i.textContent || ""), l = r === e.length - 1, c = ((o = i.dataset) == null ? void 0 : o[zi]) !== void 0;
    if (l || n < s.length || n === s.length && !c) {
      const a = i.firstChild;
      return a ? {
        node: a,
        offset: s.slice(0, n).join("").length
      } : { node: i, offset: 0 };
    }
    n -= s.length;
  }
  return { node: e[e.length - 1], offset: 0 };
};
class Jd {
  constructor(t, n, o) {
    x(this, "el");
    x(this, "model");
    x(this, "index");
    this.el = t, this.model = n, this.index = o;
  }
  blockProjection(t) {
    var s;
    const n = (s = this.index) == null ? void 0 : s.call(this).blocks[t];
    if (n) return n;
    const o = this.model().blocks[t], r = o ? A(o) : 0, i = (l) => Math.max(0, Math.min(l, r));
    return {
      modelLength: r,
      projectedLength: r,
      stopPaints: Array.from({ length: r }, () => !0),
      paintedRunText: [],
      toProjected: i,
      toModel: i
    };
  }
  /**
   * The spans a run paints, in order: one per part, since an emoji cluster
   * or a change of CJK form paints in a span of its own. Their texts join to
   * the run's painted text.
   */
  runSpans(t, n) {
    return Array.from(t.children).filter(
      (o) => {
        var r;
        return ((r = o.dataset) == null ? void 0 : r[ct]) === String(n);
      }
    );
  }
  blockElement(t) {
    return this.el.querySelector(
      `${H}[${po}="${t}"]`
    );
  }
  blockAncestorOf(t) {
    var o;
    let n = t;
    for (; n && n !== this.el; ) {
      if (n.nodeType === 1 && ((o = n.classList) != null && o.contains(Ht)))
        return n;
      n = n.parentNode;
    }
    return null;
  }
  /**
   * The block index of the table whose block holds a node, the block itself
   * or anything inside it, else null. A table has no caret stop inside it:
   * its stops are the host-level points beside its block.
   */
  tableBlockIndexOf(t) {
    const n = t ? this.blockAncestorOf(t) : null;
    if (!n) return null;
    const o = Number(n.dataset[Et]), r = Number.isInteger(o) ? this.model().blocks[o] : void 0;
    return r !== void 0 && w(r.kind) ? o : null;
  }
  toPoint(t) {
    if (!Number.isInteger(t.offset) || t.offset < 0) return null;
    const n = this.blockElement(t.blockIndex);
    if (!n) return null;
    const o = this.model().blocks[t.blockIndex];
    if (o !== void 0 && w(o.kind)) {
      const a = Array.prototype.indexOf.call(this.el.childNodes, n);
      return a < 0 || t.offset > 1 ? null : { node: this.el, offset: a + t.offset };
    }
    if (o !== void 0 && C(o.kind))
      return t.offset === 0 ? { node: n, offset: 0 } : null;
    const r = this.blockProjection(t.blockIndex);
    if (t.offset > r.modelLength) return null;
    const i = (o == null ? void 0 : o.runs) ?? [];
    if (i.length === 0)
      return t.offset !== 0 ? null : { node: n.querySelector(`[${at}]`) ?? n, offset: 0 };
    const s = r.toProjected(t.offset);
    let l = 0, c = 0;
    for (const [a, d] of i.entries()) {
      const u = r.toProjected(l + U(d));
      if (u > c && s <= u) {
        const f = this.runSpans(n, a);
        if (f.length === 0) return null;
        const g = s - c;
        if (f[0].dataset[ue] === "field") {
          const b = g === 0 ? f[0] : f[f.length - 1], p = Array.prototype.indexOf.call(n.children, b);
          return { node: n, offset: g === 0 ? p : p + 1 };
        }
        return Xd(f, g);
      }
      l += U(d), c = u;
    }
    return null;
  }
  toPosition(t, n) {
    var g, b, p;
    if (!t) return null;
    const o = this.blockAncestorOf(t);
    if (!o) {
      const h = this.stopAnchorOf(t);
      return t !== this.el && h === null ? null : this.hostPointPosition(
        h === null ? n : Array.prototype.indexOf.call(this.el.childNodes, h)
      );
    }
    const r = Number(o.dataset[Et]);
    if (!Number.isInteger(r)) return null;
    const i = this.model().blocks[r];
    if (i !== void 0 && C(i.kind))
      return { blockIndex: r, offset: 0 };
    const s = this.blockProjection(r), l = (h) => s.toModel(h, h >= s.projectedLength ? "right" : "left"), c = t.nodeType === 3 ? t.parentElement : t;
    if (t === o || c && ((g = c.classList) != null && g.contains(Ht))) {
      const h = o.children;
      if (n >= h.length)
        return { blockIndex: r, offset: l(s.projectedLength) };
      const m = h[Math.max(0, n)], k = Number((b = m.dataset) == null ? void 0 : b[ct]), E = ((p = i == null ? void 0 : i.runs[k]) == null ? void 0 : p.kind) === "field" ? Math.min(An(m), 1) : An(m), S = Number.isInteger(k) && i !== void 0 ? s.toProjected(yt(i, k)) + E : 0;
      return { blockIndex: r, offset: l(S) };
    }
    if (c != null && c.closest(`[${at}]`) && o.contains(c))
      return { blockIndex: r, offset: 0 };
    if (!c || !o.contains(c) || c.dataset[ct] === void 0 || i === void 0)
      return null;
    const a = Number(c.dataset[ct]), d = s.toProjected(yt(i, a)), u = An(c);
    if (c.dataset[ue] === "field")
      return {
        blockIndex: r,
        offset: l(
          d + (n > 0 || u > 0 ? 1 : 0)
        )
      };
    const f = (c.textContent || "").slice(0, n);
    return {
      blockIndex: r,
      offset: l(
        d + u + $(f).length
      )
    };
  }
  /**
   * The position a point between the host's blocks reads as. The point
   * after a table, past any stop anchor, is the table's stop after, the one
   * position for the gap between two adjacent tables. Any other point reads
   * as the start of the block at it, which for a table is its stop before,
   * or of the last block past the end.
   */
  hostPointPosition(t) {
    var a;
    const n = this.el.querySelectorAll(H);
    if (n.length === 0) return { blockIndex: 0, offset: 0 };
    const o = this.el.childNodes;
    let r = t - 1;
    for (; r >= 0 && Rr(o[r]); ) r -= 1;
    const i = this.tableBlockIndexOf(r >= 0 ? o[r] : null);
    if (i !== null) return { blockIndex: i, offset: 1 };
    let s = 0;
    for (let d = 0; d < t && d < o.length; d++)
      (a = o[d].classList) != null && a.contains(
        Ht
      ) && (s += 1);
    const l = n[Math.min(s, n.length - 1)], c = Number(l.dataset[Et]);
    return { blockIndex: Number.isInteger(c) ? c : 0, offset: 0 };
  }
  /** The stop anchor a node is or sits in, else null. */
  stopAnchorOf(t) {
    for (let n = t; n && n !== this.el; n = n.parentNode)
      if (Rr(n)) return n;
    return null;
  }
  readPosition() {
    var n;
    const t = (n = this.el.ownerDocument.defaultView) == null ? void 0 : n.getSelection();
    return !t || t.rangeCount === 0 ? null : this.toPosition(t.focusNode, t.focusOffset);
  }
  /**
   * The browser's selection as the model reads it. A range end inside a
   * table reads as the stop that covers the table, and a range with both
   * ends inside one table as that table selected. A collapsed caret inside a
   * table reads as the table's stop before, as readPosition does;
   * tableBlockIndexOf tells the host it is inside.
   */
  readSelection() {
    var l;
    const t = (l = this.el.ownerDocument.defaultView) == null ? void 0 : l.getSelection();
    if (!t || t.rangeCount === 0) return null;
    const n = this.toPosition(t.anchorNode, t.anchorOffset), o = this.toPosition(t.focusNode, t.focusOffset);
    if (n === null || o === null) return null;
    const r = t.anchorNode === t.focusNode && t.anchorOffset === t.focusOffset, i = r ? null : this.tableBlockIndexOf(t.anchorNode), s = r ? null : this.tableBlockIndexOf(t.focusNode);
    return i !== null && i === s ? So(this.model(), i) : {
      kind: "within-box",
      boxId: this.model().boxId,
      anchor: i === null ? n : Cr(i, o),
      focus: s === null ? o : Cr(s, n)
    };
  }
  placeCaret(t) {
    var s;
    const n = this.toPoint(t);
    if (!n) return !1;
    const o = this.el.ownerDocument, r = o.createRange();
    r.setStart(n.node, n.offset), r.collapse(!0);
    const i = (s = o.defaultView) == null ? void 0 : s.getSelection();
    return i ? (i.removeAllRanges(), i.addRange(r), !0) : !1;
  }
  placeRange(t, n) {
    var l;
    const o = this.toPoint(t), r = this.toPoint(n);
    if (!o || !r) return !1;
    const i = this.el.ownerDocument, s = (l = i.defaultView) == null ? void 0 : l.getSelection();
    if (!s) return !1;
    if (typeof s.setBaseAndExtent == "function")
      s.setBaseAndExtent(o.node, o.offset, r.node, r.offset);
    else {
      const c = i.createRange(), [a, d] = V(t, n), u = this.toPoint(a), f = this.toPoint(d);
      if (!u || !f) return !1;
      c.setStart(u.node, u.offset), c.setEnd(f.node, f.offset), s.removeAllRanges(), s.addRange(c);
    }
    return !0;
  }
  /**
   * The band a range paints, as rects in the box's own layout pixels. A
   * table the range covers is one rect, its block's box, and the range is
   * measured around it: measured across the table, it would add every
   * cell's text over the block's box and paint the names twice.
   */
  rangeRects(t, n) {
    const [o, r] = V(t, n), i = this.model().blocks, s = [];
    let l = o;
    for (let a = o.blockIndex; a <= r.blockIndex; a++) {
      const d = i[a];
      if (d === void 0 || !w(d.kind) || !_t(o, r, a))
        continue;
      const u = this.blockElement(a), f = this.domRangeRects(l, { blockIndex: a, offset: 0 });
      if (!u || f === null) return [];
      s.push(
        ...f,
        ...en(this.el, [u.getBoundingClientRect()])
      ), l = { blockIndex: a, offset: 1 };
    }
    const c = this.domRangeRects(l, r);
    return c === null ? [] : [...s, ...c];
  }
  domRangeRects(t, n) {
    const o = this.toPoint(t), r = this.toPoint(n);
    if (!o || !r) return null;
    const i = this.el.ownerDocument.createRange();
    try {
      i.setStart(o.node, o.offset), i.setEnd(r.node, r.offset);
    } catch {
      return null;
    }
    return en(this.el, i.getClientRects());
  }
  /**
   * The caret position at a client point. On a table it is the table's stop
   * on the point's half, as tableAtClientPoint gives it.
   */
  fromClientPoint(t, n) {
    var r;
    const o = this.hitPoint(t, n);
    return o === null ? null : ((r = this.tableHit(o.node, n)) == null ? void 0 : r.stop) ?? this.toPosition(o.node, o.offset);
  }
  /**
   * The table under a client point, and its stop on the point's half of the
   * table's block, measured on the block's client box. Null when the point
   * is on no table.
   */
  tableAtClientPoint(t, n) {
    const o = this.hitPoint(t, n);
    return o === null ? null : this.tableHit(o.node, n);
  }
  tableHit(t, n) {
    const o = this.tableBlockIndexOf(t), r = o === null ? null : this.blockElement(o);
    if (o === null || !r) return null;
    const i = r.getBoundingClientRect(), s = n >= i.top + i.height / 2;
    return {
      tableIndex: o,
      stop: { blockIndex: o, offset: s ? 1 : 0 }
    };
  }
  /** The DOM point the browser's hit test gives a client point, in the box. */
  hitPoint(t, n) {
    const o = this.el.ownerDocument;
    let r = null, i = 0;
    if (typeof o.caretPositionFromPoint == "function") {
      const s = o.caretPositionFromPoint(t, n);
      s && (r = s.offsetNode, i = s.offset);
    }
    if (!r && typeof o.caretRangeFromPoint == "function") {
      const s = o.caretRangeFromPoint(t, n);
      s && (r = s.startContainer, i = s.startOffset);
    }
    return !r || !this.el.contains(r) ? null : { node: r, offset: i };
  }
}
const Zd = (e, t, n, o) => {
  if (!(Number.isFinite(o) && o > 0)) return null;
  const r = e.ownerDocument;
  if (!(r != null && r.defaultView)) return null;
  let i;
  try {
    i = e.getBoundingClientRect();
  } catch {
    return null;
  }
  const s = e.offsetWidth;
  if (!(i.width > 0) || !(s > 0)) return null;
  const l = i.width / s;
  if (!(Number.isFinite(l) && l > 0)) return null;
  let c = 1 / 0, a = 1 / 0, d = -1 / 0, u = -1 / 0, f = !1;
  return t.forEach((g, b) => {
    const p = n[b];
    if (!p || !(Number.isFinite(g.basePt) && g.basePt > 0) || g.el.dataset[Tt] !== void 0 || g.el.dataset[rt] !== void 0) return;
    let h;
    try {
      const y = r.createRange();
      y.selectNodeContents(g.el), h = y.getClientRects();
    } catch {
      return;
    }
    if (!h || h.length === 0) return;
    const m = Math.max(0, ie(p, "top", o)), k = Math.max(0, ie(p, "bottom", o)), E = Math.max(0, ie(p, "left", o)), S = Math.max(0, ie(p, "right", o));
    for (const y of Array.from(h)) {
      if (!(y.width > 0) || !(y.height > 0)) continue;
      const v = (y.top - i.top) / l - m, T = (y.bottom - i.top) / l + k, Y = (y.left - i.left) / l - E, L = (y.right - i.left) / l + S;
      v < c && (c = v), Y < a && (a = Y), T > d && (d = T), L > u && (u = L), f = !0;
    }
  }), f ? { top: c, left: a, bottom: d, right: u } : null;
}, Gn = /* @__PURE__ */ new WeakMap(), Mo = /* @__PURE__ */ new WeakMap(), No = /* @__PURE__ */ new WeakSet(), Qd = (e, t) => {
  Gn.set(e, [...Gn.get(e) ?? [], t]), Mo.set(t, e);
}, tu = (e) => {
  No.add(Mo.get(e) ?? e);
}, $o = (e) => {
  const t = Mo.get(e) ?? e;
  return [t, ...Gn.get(t) ?? []];
}, Vn = (e, t) => e.some((n) => n.status === t), zo = (e) => e.status === "loading" && !Vn($o(e), "loaded"), Os = (e) => zo(e) && !No.has($o(e)[0]), Ds = (e) => {
  const t = $o(e);
  return Vn(t, "loaded") ? !1 : No.has(t[0]) ? !0 : e.status === "error" && !Vn(t, "loading");
}, bn = (e) => e.trim().replace(/^["']|["']$/g, ""), it = (e) => bn(e).toLowerCase(), Bs = (e) => e.split(",").map(bn).filter(Boolean), eu = [[0, 1114111]], Ho = (e) => {
  const t = e.split(",").map((n) => n.trim().replace(/^u\+/i, "")).filter(Boolean).map((n) => {
    if (n.includes("-")) {
      const [r, i] = n.split("-");
      return [Number.parseInt(r, 16), Number.parseInt(i, 16)];
    }
    if (n.includes("?"))
      return [
        Number.parseInt(n.replace(/\?/g, "0"), 16),
        Number.parseInt(n.replace(/\?/g, "f"), 16)
      ];
    const o = Number.parseInt(n, 16);
    return [o, o];
  }).filter(([n, o]) => Number.isFinite(n) && Number.isFinite(o));
  return t.length > 0 ? t : eu;
}, nu = (e) => !e.some(([t, n]) => t <= 0 && n >= 1114111), Wo = (e, t) => {
  for (const n of t) {
    const o = n.codePointAt(0) ?? 0;
    if (e.some(([r, i]) => o >= r && o <= i)) return !0;
  }
  return !1;
}, ou = (e) => {
  const t = /* @__PURE__ */ new Map();
  for (const n of e) {
    const o = it(n.family), r = t.get(o) ?? [];
    r.push(Ho(n.unicodeRange || "")), t.set(o, r);
  }
  return t;
}, ru = (e, t, n) => {
  for (const o of Bs(t)) {
    const r = e.get(it(o));
    if (r && r.some((i) => Wo(i, n)))
      return o;
  }
  return null;
}, iu = 1e3, Ms = /* @__PURE__ */ new Set([
  "serif",
  "sans-serif",
  "monospace",
  "cursive",
  "fantasy",
  "system-ui",
  "ui-serif",
  "ui-sans-serif",
  "ui-monospace",
  "ui-rounded",
  "emoji",
  "math",
  "fangsong"
]), Ns = " ", Ko = /* @__PURE__ */ new WeakMap(), Cn = (e, t) => {
  const n = /* @__PURE__ */ new Map();
  for (const i of e) {
    const s = it(i.family), l = n.get(s) ?? [];
    l.push({ face: i, ranges: Ho(i.unicodeRange || "") }), n.set(s, l);
  }
  const o = new Map(t == null ? void 0 : t.misses);
  for (const i of n.keys()) o.delete(i);
  const r = { size: e.size, byFamily: n, misses: o };
  return Ko.set(e, r), r;
}, Fn = (e, t, n) => (e.misses.set(t, n), []), $s = (e, t, n = performance.now()) => {
  const o = it(t);
  let r = Ko.get(e);
  const i = r === void 0 || r.size !== e.size;
  (r === void 0 || i) && (r = Cn(e, r));
  const s = r.byFamily.get(o);
  if (s !== void 0)
    return i || s.every(({ face: c }) => e.has(c)) ? s : (r = Cn(e, r), r.byFamily.get(o) ?? Fn(r, o, n));
  if (i) return Fn(r, o, n);
  const l = r.misses.get(o);
  return l !== void 0 && n - l < iu ? [] : (r = Cn(e, r), r.byFamily.get(o) ?? Fn(r, o, n));
}, zs = (e) => {
  const t = Ko.get(e);
  t !== void 0 && (t.size = -1);
}, su = (e, t) => {
  e.add(t), zs(e);
}, lu = (e, t) => {
  e.delete(t), zs(e);
}, Hs = (e, t, n, o) => {
  const r = /* @__PURE__ */ new Set();
  for (const [i, s] of t) {
    if (Ms.has(it(i))) continue;
    const l = s.length > 0 ? s : Ns;
    for (const { face: c, ranges: a } of $s(e, i, o))
      n(c) && Wo(a, l) && r.add(c);
  }
  return [...r];
}, Ws = (e, t, n = performance.now()) => Hs(e, t, Os, n), cu = (e, t, n = performance.now()) => Hs(e, t, zo, n), au = (e, t, n, o, r = performance.now()) => {
  const i = ru(t, n, o);
  return i === null ? !0 : Ws(e, /* @__PURE__ */ new Map([[i, o]]), r).length === 0;
}, We = /* @__PURE__ */ new WeakMap(), op = (e, t) => (We.set(e, t), () => {
  We.get(e) === t && We.delete(e);
}), jo = (e, t, n = performance.now()) => {
  const o = We.get(e), r = /* @__PURE__ */ new Set();
  for (const { families: i, text: s, weight: l = 400, style: c = "normal" } of t) {
    const a = Array.from(i).filter(
      (d) => !Ms.has(it(d))
    ).map((d) => ({
      family: d,
      faces: $s(e, d, n)
    })).filter(({ faces: d }) => d.length > 0);
    for (const d of new Set(s + Ns)) {
      const u = d.codePointAt(0);
      let f = !1;
      for (const { family: g, faces: b } of a) {
        const p = b.filter(
          ({ ranges: k }) => Wo(k, d)
        ), h = o == null ? void 0 : o.familyTakes(g, l, c, u);
        if (h === !1 || p.length === 0) continue;
        const m = p.some(
          ({ ranges: k }) => nu(k)
        );
        if (h === !0 || m) {
          for (const { face: k } of p) r.add(k);
          break;
        }
        if (!f) {
          for (const { face: k } of p) r.add(k);
          f = !0;
        }
      }
    }
  }
  return [...r];
}, Ks = (e, t, n = performance.now()) => jo(e, t, n).filter(Ds), du = (e, t, n = performance.now()) => jo(e, t, n).filter(zo), uu = (e, t, n = performance.now()) => jo(e, t, n).filter(Os), fu = (e) => {
  const { data: t, width: n, height: o } = e;
  if (!(n > 0) || !(o > 0)) return null;
  const r = (a) => {
    const d = a * n * 4 + 3;
    for (let u = 0; u < n; u++) if (t[d + u * 4] !== 0) return !0;
    return !1;
  };
  let i = -1;
  for (let a = 0; a < o; a++)
    if (r(a)) {
      i = a;
      break;
    }
  if (i < 0) return null;
  let s = i;
  for (let a = o - 1; a > i; a--)
    if (r(a)) {
      s = a;
      break;
    }
  let l = n, c = -1;
  for (let a = i; a <= s; a++) {
    const d = a * n * 4 + 3;
    for (let u = 0; u < l; u++)
      if (t[d + u * 4] !== 0) {
        l = u;
        break;
      }
    for (let u = n - 1; u > c; u--)
      if (t[d + u * 4] !== 0) {
        c = u;
        break;
      }
  }
  return { minX: l, minY: i, maxX: c, maxY: s };
}, js = (e) => {
  const t = e;
  return !!t && typeof t.measureText == "function" && typeof t.fillText == "function" && typeof t.getImageData == "function";
}, hu = (e) => {
  try {
    if (typeof e.OffscreenCanvas != "function") return null;
    const t = new e.OffscreenCanvas(1, 1), n = t.getContext("2d", { willReadFrequently: !0 });
    return js(n) ? { canvas: t, ctx: n } : null;
  } catch {
    return null;
  }
}, pu = (e, t) => {
  try {
    if (typeof t.CanvasRenderingContext2D != "function") return null;
    const n = e.createElement("canvas"), o = n.getContext("2d", { willReadFrequently: !0 });
    return js(o) ? { canvas: n, ctx: o } : null;
  } catch {
    return null;
  }
}, Fr = /* @__PURE__ */ new WeakMap(), Gs = (e) => {
  const t = Fr.get(e);
  if (t) return t;
  const n = e.defaultView;
  if (!n) return null;
  const o = n, r = hu(o) ?? pu(e, o);
  return r && Fr.set(e, r), r;
}, Un = /* @__PURE__ */ new WeakMap(), Yn = /* @__PURE__ */ new WeakMap(), Pr = /* @__PURE__ */ new WeakSet(), gu = (e) => {
  var t, n;
  (t = Un.get(e)) == null || t.clear(), (n = Yn.get(e)) == null || n.clear();
}, Vs = (e) => {
  var n;
  if (Pr.has(e)) return;
  Pr.add(e);
  const t = e.fonts;
  try {
    (n = t == null ? void 0 : t.addEventListener) == null || n.call(
      t,
      "loadingdone",
      () => gu(e)
    );
  } catch {
    return;
  }
}, Us = (e, t, n) => {
  const o = e.fonts;
  if (!o || typeof o.has != "function" || o.status === "loaded") return !0;
  const r = new Map(
    Bs(t).map((i) => [i, n])
  );
  return cu(o, r).length === 0;
}, mu = (e) => {
  let t = Un.get(e);
  return t || (t = /* @__PURE__ */ new Map(), Un.set(e, t)), Vs(e), t;
}, bu = (e) => {
  let t = Yn.get(e);
  return t || (t = /* @__PURE__ */ new Map(), Yn.set(e, t)), Vs(e), t;
}, xu = 8, ku = 4, yu = 2048, _r = 8192, Su = 1 << 23, se = (e) => Number.isFinite(e), Eu = (e, t, n, o, r) => {
  const { canvas: i, ctx: s } = e;
  for (let l = xu; l <= yu; l *= ku) {
    const c = Math.max(1, Math.ceil(n.left + n.right)), a = c + 2 * l, d = Math.max(1, Math.ceil(n.up + n.down)) + 2 * l;
    if (a > _r || d > _r || a * d > Su) return null;
    i.width = a, i.height = d, s.font = t, s.textBaseline = "alphabetic", s.textAlign = "left";
    const u = l + Math.ceil(Math.max(0, n.left)), f = l + Math.ceil(Math.max(0, n.up));
    r(s, u, f, c);
    let g;
    try {
      g = s.getImageData(0, 0, a, d);
    } catch {
      return null;
    }
    const b = fu(g);
    if (!b) return { ink: !1 };
    const p = b.minY === 0 || b.maxY === d - 1, h = b.minX === 0 || b.maxX === a - 1;
    if (!(p || h))
      return {
        ink: !0,
        up: f - b.minY,
        down: b.maxY + 1 - f,
        left: u - b.minX,
        right: b.maxX + 1 - u
      };
  }
  return null;
}, Iu = (e, t, n) => {
  e.ctx.font = t;
  const o = e.ctx.measureText(n);
  return !se(o.actualBoundingBoxLeft) || !se(o.actualBoundingBoxRight) || !se(o.actualBoundingBoxAscent) || !se(o.actualBoundingBoxDescent) ? null : Eu(
    e,
    t,
    {
      left: Math.max(0, o.actualBoundingBoxLeft),
      right: Math.max(1, o.actualBoundingBoxRight),
      up: o.actualBoundingBoxAscent,
      down: o.actualBoundingBoxDescent
    },
    !0,
    (r, i, s) => r.fillText(n, i, s)
  );
}, Gt = [64, 256], Ys = (e) => Math.round(e * 512) / 512, qn = (e, t, n, o) => {
  if (n === "" || !(Number.isFinite(o) && o > 0))
    return null;
  const r = Ys(o), i = `${r}|${t.style}|${t.weight}|${t.family}|${n}`, s = mu(e), l = s.get(i);
  if (l !== void 0) return l;
  const c = $(n), a = Gs(e);
  if (!a) return null;
  const d = `${t.style} ${t.weight} ${r}px ${t.family}`;
  a.ctx.font = d;
  let u = 0, f = 0, g = !1, b = 0, p = 0, h = !1, m = !1;
  for (const E of new Set(c)) {
    const S = Xn(e, t, E, r);
    if (S === null) return null;
    if (!S.ink) continue;
    g = !0, S.up > u && (u = S.up), S.down > f && (f = S.down), h = !0, S.left > b && (b = S.left), a.ctx.font = d;
    const y = a.ctx.measureText(E).width;
    if (!se(y)) continue;
    const v = S.right - y;
    m = !0, v > p && (p = v);
  }
  const k = {
    inkAscent: u,
    inkDescent: f,
    leftOverhang: h ? b : 0,
    rightOverhang: m ? p : 0,
    verticalInk: g,
    leftEdgeInk: h,
    rightEdgeInk: m
  };
  return Us(e, t.family, n) && s.set(i, k), k;
}, vu = (e, t, n) => {
  const o = qn(
    e,
    t,
    n,
    Gt[0]
  );
  if (!o) return null;
  const r = qn(
    e,
    t,
    n,
    Gt[1]
  );
  return r ? { refPx: Gt, at: [o, r] } : null;
}, Xn = (e, t, n, o) => {
  if (n === "" || !(Number.isFinite(o) && o > 0))
    return null;
  const r = Ys(o), i = `${r}|${t.style}|${t.weight}|${t.family}|${n}`, s = bu(e), l = s.get(i);
  if (l !== void 0) return l;
  const c = Gs(e);
  if (!c) return null;
  const a = `${t.style} ${t.weight} ${r}px ${t.family}`, d = Iu(c, a, n);
  if (d === null) return null;
  const u = d.ink ? {
    ink: !0,
    up: d.up,
    down: d.down,
    left: d.left,
    right: d.right
  } : { ink: !1, up: 0, down: 0, left: 0, right: 0 };
  return Us(e, t.family, n) && s.set(i, u), u;
}, qs = (e, t, n) => {
  const o = Xn(
    e,
    t,
    n,
    Gt[0]
  );
  if (!o) return null;
  const r = Xn(
    e,
    t,
    n,
    Gt[1]
  );
  return r ? { refPx: Gt, at: [o, r] } : null;
}, wu = (e) => {
  const t = [];
  let n = 0;
  const o = (r) => {
    if (r.nodeType === 3) {
      const i = r;
      t.push({ node: i, start: n, end: n + i.length }), n += i.length;
      return;
    }
    for (let i = 0; i < r.childNodes.length; i++) o(r.childNodes[i]);
  };
  return o(e), t;
}, Ru = (e, t) => {
  for (const o of e)
    if (t >= o.start && t < o.end)
      return { node: o.node, offset: t - o.start };
  const n = e[e.length - 1];
  return n && t === n.end ? { node: n.node, offset: n.node.length } : null;
}, Tu = (e, t) => {
  for (const n of e)
    if (t > n.start && t <= n.end)
      return { node: n.node, offset: t - n.start };
  return null;
}, Xs = (e, t, n, o) => {
  const r = Ru(t, n), i = Tu(t, o);
  if (!r || !i) return null;
  let s;
  try {
    const u = e.createRange();
    u.setStart(r.node, r.offset), u.setEnd(i.node, i.offset), s = u.getClientRects();
  } catch {
    return null;
  }
  let l = 1 / 0, c = 1 / 0, a = -1 / 0, d = -1 / 0;
  for (const u of Array.from(s ?? []))
    !(u.width > 0) || !(u.height > 0) || (u.left < l && (l = u.left), u.top < c && (c = u.top), u.right > a && (a = u.right), u.bottom > d && (d = u.bottom));
  return l === 1 / 0 ? null : { left: l, top: c, right: a, bottom: d };
}, Js = (e, t, n) => ({
  up: _e(e, (o) => o.up, t, n),
  down: _e(e, (o) => o.down, t, n),
  left: _e(e, (o) => o.left, t, n),
  right: _e(e, (o) => o.right, t, n)
}), Au = (e, t) => {
  const n = e.ownerDocument, o = n == null ? void 0 : n.defaultView;
  if (!o || typeof o.CanvasRenderingContext2D != "function") return null;
  let r = null;
  try {
    r = n.createElement("canvas").getContext("2d");
  } catch {
    return null;
  }
  if (!r || typeof r.measureText != "function") return null;
  let i;
  try {
    i = e.getBoundingClientRect();
  } catch {
    return null;
  }
  const s = e.offsetWidth;
  if (!(i.width > 0) || !(s > 0)) return null;
  const l = i.width / s;
  if (!(Number.isFinite(l) && l > 0)) return null;
  const c = Io;
  let a = 1 / 0, d = 1 / 0, u = -1 / 0, f = -1 / 0;
  const g = [];
  let b = !1;
  for (const p of t) {
    if (b) break;
    if (p.el.dataset[Tt] !== void 0 || p.el.dataset[rt] !== void 0) continue;
    const h = p.el.textContent ?? "";
    if (h === "") continue;
    const m = o.getComputedStyle(p.el), k = Number.parseFloat(m.fontSize);
    if (!(k > 0)) {
      b = !0;
      break;
    }
    r.font = `${m.fontStyle} ${m.fontWeight} ${m.fontSize} ${m.fontFamily}`;
    const E = r.measureText(h), S = E.fontBoundingBoxAscent, y = E.fontBoundingBoxDescent;
    if (!Number.isFinite(S) || !Number.isFinite(y)) {
      b = !0;
      break;
    }
    const v = S - y, T = {
      style: m.fontStyle,
      weight: m.fontWeight,
      family: m.fontFamily
    }, Y = wu(p.el);
    let L = 0;
    for (const R of $(h)) {
      const z = L;
      if (L += R.length, R.trim() === "") continue;
      const j = Xs(n, Y, z, L);
      if (!j) {
        b = !0;
        break;
      }
      const { left: ft, top: q, bottom: F } = j, mt = (ft - i.left) / l, M = (q - i.top) / l, st = (F - q) / l, Ot = qs(n, T, R);
      if (!Ot) {
        b = !0;
        break;
      }
      if (!Ot.at[0].ink && !Ot.at[1].ink) continue;
      const {
        up: yl,
        down: Sl,
        left: El,
        right: Il
      } = Js(Ot, k, c), qo = M + (st + v) / 2, Q = {
        char: R,
        top: qo - yl,
        bottom: qo + Sl,
        left: mt - El,
        right: mt + Il
      };
      !(Q.right > Q.left) || !(Q.bottom > Q.top) || (g.push(Q), Q.top < a && (a = Q.top), Q.left < d && (d = Q.left), Q.bottom > u && (u = Q.bottom), Q.right > f && (f = Q.right));
    }
  }
  return b || g.length === 0 ? null : { rect: { top: a, left: d, bottom: u, right: f }, clusters: g };
}, _e = (e, t, n, o) => {
  const r = re(
    e.refPx[0],
    t(e.at[0]),
    e.refPx[1],
    t(e.at[1])
  );
  return r.perPx * n + r.interceptPx / o;
}, Cu = (e) => {
  const t = Array.from(
    e.querySelectorAll(Ti)
  );
  if (t.length === 0) return null;
  let n;
  try {
    n = e.getBoundingClientRect();
  } catch {
    return null;
  }
  const o = e.offsetWidth;
  if (!(n.width > 0) || !(o > 0)) return null;
  const r = n.width / o;
  if (!(Number.isFinite(r) && r > 0)) return null;
  let i = 1 / 0, s = 1 / 0, l = -1 / 0, c = -1 / 0;
  for (const a of t) {
    let d;
    try {
      d = a.getBoundingClientRect();
    } catch {
      continue;
    }
    !(d.width > 0) || !(d.height > 0) || (i = Math.min(i, (d.top - n.top) / r), s = Math.min(s, (d.left - n.left) / r), l = Math.max(l, (d.bottom - n.top) / r), c = Math.max(c, (d.right - n.left) / r));
  }
  return i === 1 / 0 ? null : { top: i, left: s, bottom: l, right: c };
}, Zs = (e) => {
  const t = e.defaultView;
  if (!t || typeof t.CanvasRenderingContext2D != "function") return null;
  let n = null;
  try {
    n = e.createElement("canvas").getContext("2d");
  } catch {
    return null;
  }
  return !n || typeof n.measureText != "function" ? null : n;
}, Fu = "Hlfkgjpqy", Go = (e) => e.dataset[rt] !== void 0, Lr = (e) => Go(e) ? Fu : e.textContent ?? "", Pu = (e) => {
  const t = e.find((s) => Lr(s.el) !== "");
  if (!t) return [];
  const n = t.el.ownerDocument, o = n.defaultView;
  if (!o) return [];
  const r = Zs(n);
  if (!r) return [];
  const i = [];
  for (const { el: s, basePt: l } of e) {
    const c = Lr(s);
    if (c === "" || !(Number.isFinite(l) && l > 0)) continue;
    const a = o.getComputedStyle(s), d = Number.parseFloat(a.fontSize);
    if (!(d > 0)) continue;
    r.font = `${a.fontStyle} ${a.fontWeight} ${a.fontSize} ${a.fontFamily}`;
    const u = r.measureText(c), f = u.fontBoundingBoxAscent, g = u.fontBoundingBoxDescent;
    if (!Number.isFinite(f) || !Number.isFinite(g)) continue;
    const b = f / d, p = g / d, h = Qs(s, a, d), m = vu(
      n,
      { style: a.fontStyle, weight: a.fontWeight, family: a.fontFamily },
      c
    ), k = m ? _u(m, b, p, h) : void 0, E = Go(s);
    i.push({
      basePt: l,
      ascentEm: b,
      descentEm: p,
      lineHeightEm: h,
      ...E ? { filler: !0 } : Lu(r, c, d),
      ...k ? {
        raster: E ? {
          ...k,
          left: $t,
          right: $t
        } : k
      } : {}
    });
  }
  return i;
}, _u = (e, t, n, o) => {
  const [r, i] = e.refPx, [s, l] = e.at, c = (o + t - n) / 2, a = (o - t + n) / 2, d = s.verticalInk || l.verticalInk;
  return {
    dpr: Io,
    top: d ? re(
      r,
      s.inkAscent - c * r,
      i,
      l.inkAscent - c * i
    ) : $t,
    bottom: d ? re(
      r,
      s.inkDescent - a * r,
      i,
      l.inkDescent - a * i
    ) : $t,
    left: s.leftEdgeInk || l.leftEdgeInk ? re(r, s.leftOverhang, i, l.leftOverhang) : $t,
    right: s.rightEdgeInk || l.rightEdgeInk ? re(r, s.rightOverhang, i, l.rightOverhang) : $t
  };
}, Lu = (e, t, n) => {
  let o = 0, r = 0;
  for (const i of new Set($(t))) {
    if (i === "") continue;
    const s = e.measureText(i), l = s.actualBoundingBoxLeft;
    Number.isFinite(l) && l > o && (o = l);
    const c = s.actualBoundingBoxRight, a = s.width;
    if (Number.isFinite(c) && Number.isFinite(a)) {
      const d = c - a;
      d > r && (r = d);
    }
  }
  return {
    leftOverhangEm: o > 0 ? o / n : 0,
    rightOverhangEm: r > 0 ? r / n : 0
  };
}, Qs = (e, t, n) => {
  const o = e.closest(H), r = o ? Number.parseFloat(o.style.lineHeight) : NaN;
  if (Number.isFinite(r) && r > 0) return r;
  const i = Number.parseFloat(t.lineHeight);
  return Number.isFinite(i) && i > 0 ? i / n : 1;
}, Ou = (e) => {
  const t = [];
  for (const { el: n } of e) {
    const r = n.dataset[Tt] !== void 0 || Go(n) ? "" : n.textContent ?? "";
    if (r === "") continue;
    const i = n.ownerDocument, s = i.defaultView;
    if (!s) continue;
    const l = s.getComputedStyle(n), c = Number.parseFloat(l.fontSize);
    if (!(c > 0)) continue;
    const a = Zs(i);
    if (!a) continue;
    a.font = `${l.fontStyle} ${l.fontWeight} ${l.fontSize} ${l.fontFamily}`;
    const d = a.measureText(r);
    !Number.isFinite(d.fontBoundingBoxAscent) || !Number.isFinite(d.fontBoundingBoxDescent) || t.push({
      text: r,
      font: {
        style: l.fontStyle,
        weight: l.fontWeight,
        family: l.fontFamily
      },
      fontSizePx: c,
      ascentEm: d.fontBoundingBoxAscent / c,
      descentEm: d.fontBoundingBoxDescent / c,
      lineHeightEm: Qs(n, l, c)
    });
  }
  return t;
}, Le = 1e-6, Du = (e, t, n, o) => {
  const r = e.defaultView, i = r == null ? void 0 : r.devicePixelRatio, s = Number.isFinite(i) && i > 0 ? i : 1, l = { top: 0, bottom: 0, left: 0, right: 0 };
  let c = 1 / 0, a = 1 / 0, d = -1 / 0, u = -1 / 0, f = 0;
  for (const b of t) {
    const p = qn(
      e,
      b.font,
      b.text,
      b.fontSizePx * s
    );
    if (!p) return null;
    f++;
    const h = (b.lineHeightEm + b.ascentEm - b.descentEm) / 2, m = (b.lineHeightEm - b.ascentEm + b.descentEm) / 2, k = p.inkAscent / s - h * b.fontSizePx, E = p.inkDescent / s - m * b.fontSizePx, S = p.leftOverhang / s, y = p.rightOverhang / s;
    l.top = Math.max(l.top, k), l.bottom = Math.max(l.bottom, E), l.left = Math.max(l.left, S), l.right = Math.max(l.right, y), c = Math.min(c, o.paddingTop - k), a = Math.min(a, o.paddingLeft - S), d = Math.max(
      d,
      o.scrollHeight - o.paddingBottom + E
    ), u = Math.max(u, o.scrollWidth - o.paddingRight + y);
  }
  return {
    escapes: l.top > n.top + Le || l.bottom > n.bottom + Le || l.left > n.left + Le || l.right > n.right + Le,
    overhang: l,
    inkRect: f > 0 ? { top: c, left: a, bottom: d, right: u } : null
  };
}, ge = (e) => {
  if (e === void 0 || e === "" || e === "normal") return 0;
  const t = Number.parseFloat(e);
  return Number.isFinite(t) ? t : 0;
}, tl = (e, t) => {
  const n = 10 ** t;
  return Math.round(e * n) / n;
}, vt = (e, t = 2) => tl(ge(e) / ln, t), Or = 4, Pn = (e) => Math.max(0, Math.min(255, Math.round(e))).toString(16).padStart(2, "0"), gt = (e) => {
  const t = /^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*(?:,\s*([\d.]+)\s*)?\)$/.exec(
    e.trim()
  );
  if (!t) return { hex: e.trim(), alpha: 1 };
  const n = t[4] === void 0 ? 1 : Number(t[4]);
  return {
    hex: `#${Pn(Number(t[1]))}${Pn(Number(t[2]))}${Pn(Number(t[3]))}`,
    alpha: n
  };
}, Bu = /^(rgba?\([^)]*\))\s+(-?[\d.]+)px\s+(-?[\d.]+)px\s+([\d.]+)px$/, Mu = (e) => {
  const t = Bu.exec(e.trim());
  if (!t) return null;
  const n = gt(t[1]);
  return {
    x: vt(`${t[2]}px`),
    y: vt(`${t[3]}px`),
    blur: vt(`${t[4]}px`),
    color: n.hex,
    opacity: n.alpha
  };
}, nn = (e) => {
  var t;
  return (t = e.ownerDocument.defaultView) == null ? void 0 : t.getComputedStyle(e);
}, Jn = (e, t) => {
  const n = nn(e), o = e.dataset[It], r = o === void 0 ? NaN : Number(o), i = e.dataset[ct];
  return {
    runIndex: t,
    text: e.textContent ?? "",
    kind: e.dataset[ue] ?? null,
    modelRun: i === void 0 ? null : Number(i),
    emojiCluster: e.dataset[zi] !== void 0,
    lang: e.getAttribute("lang"),
    emptyField: e.dataset[Tt] ?? null,
    authoredPt: Number.isFinite(r) ? r : null,
    fontSizePt: vt(n == null ? void 0 : n.fontSize),
    fontFamily: Kl((n == null ? void 0 : n.fontFamily) ?? ""),
    fontWeight: Number((n == null ? void 0 : n.fontWeight) ?? 400),
    fontStyle: (n == null ? void 0 : n.fontStyle) ?? "normal",
    color: gt((n == null ? void 0 : n.color) ?? "").hex,
    textDecoration: (n == null ? void 0 : n.textDecorationLine) ?? "none",
    textDecorationColor: gt((n == null ? void 0 : n.textDecorationColor) ?? "").hex,
    letterSpacingPt: vt(n == null ? void 0 : n.letterSpacing, Or),
    backgroundAlpha: gt((n == null ? void 0 : n.backgroundColor) ?? "").alpha,
    textStrokeWidthPt: vt(
      n == null ? void 0 : n.webkitTextStrokeWidth,
      Or
    ),
    textStrokeColor: gt((n == null ? void 0 : n.webkitTextStrokeColor) ?? "").hex,
    textFillColor: gt((n == null ? void 0 : n.webkitTextFillColor) ?? "").hex
  };
}, Nu = (e, t) => {
  var a;
  const n = nn(e), o = e.dataset[Bi], r = ge(n == null ? void 0 : n.fontSize), i = Array.from(
    e.querySelectorAll(B)
  ).map((d, u) => ({ run: d, runIndex: u })), s = ({ run: d }) => d.dataset[rt] !== void 0, l = i.find(s), c = e.querySelector(Ti);
  return {
    blockIndex: t,
    textAlign: (n == null ? void 0 : n.textAlign) ?? "start",
    lineHeight: r > 0 ? tl(ge(n == null ? void 0 : n.lineHeight) / r, 2) : 0,
    lineHeightPt: vt(n == null ? void 0 : n.lineHeight),
    strutPt: o === void 0 ? void 0 : Number(o),
    overflowWrap: (n == null ? void 0 : n.overflowWrap) ?? "normal",
    runs: i.filter((d) => !s(d)).map(({ run: d, runIndex: u }) => Jn(d, u)),
    filler: l ? Jn(l.run, l.runIndex) : null,
    // The stroke is the line's top border; its colour is what paints.
    rule: c ? { color: gt(((a = nn(c)) == null ? void 0 : a.borderTopColor) ?? "").hex } : null
  };
}, $u = (e) => {
  const t = nn(e), n = gt((t == null ? void 0 : t.backgroundColor) ?? ""), o = (i, s) => {
    const l = e.dataset[i];
    return l === void 0 ? ge(s) : Number(l);
  }, r = (t == null ? void 0 : t.display) === "flex" && /^(safe )?center$/.test(t.justifyContent) ? "middle" : (t == null ? void 0 : t.display) === "flex" && /^(safe )?flex-end$/.test(t.justifyContent) ? "bottom" : "top";
  return {
    background: n.alpha === 0 ? null : n.hex,
    backgroundAlpha: n.alpha,
    borderWidthPx: ge(t == null ? void 0 : t.borderTopWidth),
    borderStyle: (t == null ? void 0 : t.borderTopStyle) ?? "none",
    borderColor: gt((t == null ? void 0 : t.borderTopColor) ?? "").hex,
    borderRadiusPt: vt(t == null ? void 0 : t.borderTopLeftRadius),
    opacity: Number((t == null ? void 0 : t.opacity) ?? 1),
    visibility: (t == null ? void 0 : t.visibility) ?? "visible",
    verticalAlign: r,
    textShadow: Mu((t == null ? void 0 : t.textShadow) ?? "none"),
    padding: {
      top: o(G.top, t == null ? void 0 : t.paddingTop),
      right: o(G.right, t == null ? void 0 : t.paddingRight),
      bottom: o(G.bottom, t == null ? void 0 : t.paddingBottom),
      left: o(G.left, t == null ? void 0 : t.paddingLeft)
    }
  };
}, zu = (e) => {
  var o;
  const t = e.dataset[bo], n = t === void 0 ? NaN : Number(t);
  return {
    fitScale: Number.isFinite(n) ? n : null,
    devicePixelRatio: ((o = e.ownerDocument.defaultView) == null ? void 0 : o.devicePixelRatio) ?? 1,
    box: $u(e),
    blocks: Array.from(
      e.querySelectorAll(H)
    ).map((r, i) => Nu(r, i))
  };
}, ve = (e) => {
  const t = [];
  let n = 0, o = 0;
  for (let r = 0; r < e.length; r += 1) {
    const { top: i, bottom: s } = e[r], l = t.length > 0 ? t[t.length - 1] : void 0;
    if (l !== void 0) {
      const c = Math.min(o, s) - Math.max(n, i), a = Math.min(o - n, s - i);
      if (a === 0 || c >= a / 2) {
        l.push(r), n = Math.min(n, i), o = Math.max(o, s);
        continue;
      }
    }
    t.push([r]), n = i, o = s;
  }
  return t;
}, Hu = [
  1.02,
  1.05,
  1.1,
  1.2,
  1.35,
  1.6,
  2,
  2.5
], Wu = 1200, el = (e, t) => {
  const n = Array.from(
    e.querySelectorAll(
      `${B}[${Se}]`
    )
  ), o = n.map((a) => a.style.fontSize);
  let r = !1, i = !1;
  for (const a of Hu)
    if (n.forEach((d) => {
      const u = Number(d.dataset[It]);
      Number.isFinite(u) && (d.style.fontSize = `${u * t * a}pt`);
    }), e.offsetHeight, r = e.scrollWidth > e.clientWidth, i = e.scrollHeight > e.clientHeight, r || i) break;
  n.forEach((a, d) => {
    a.style.fontSize = o[d];
  }), e.offsetHeight;
  const s = [];
  for (const a of n)
    if (!(a.dataset[rt] !== void 0 || a.dataset[Tt] !== void 0))
      for (const d of Array.from(a.getClientRects()))
        d.height > 0 && s.push({ top: d.top, bottom: d.bottom });
  const l = ve(s).length;
  return { axis: r && i ? "both" : r ? "width" : i ? "height" : "none", contentLineCount: l };
}, Ku = (e) => {
  const t = e.dataset[bo];
  if (t === void 0) return null;
  const n = Number(t);
  if (!Number.isFinite(n) || n <= 0) return null;
  const o = Array.from(
    e.querySelectorAll(
      `${B}[${Se}]`
    )
  );
  if (o.length === 0) return null;
  const r = o.flatMap(
    (l) => l.dataset[rt] === void 0 ? [Number(l.dataset[It])] : []
  );
  if (r.length === 0) return null;
  const { axis: i, contentLineCount: s } = el(e, n);
  return As({
    scale: n,
    minScale: Wn(r),
    ceilingScale: Xi(e.offsetHeight, r),
    authoredBasesPt: r,
    minSizePt: Ee,
    overflowing: e.dataset[qe] === "true",
    bindingAxis: i,
    longWord: (i === "width" || i === "both") && s <= 1
  });
}, ju = (e, t, n) => {
  if (t.dataset[Tt] !== void 0 || t.dataset[rt] !== void 0)
    return [];
  const o = t.firstChild;
  if (!o || o.nodeType !== Node.TEXT_NODE) return [];
  const r = o.textContent ?? "", i = e.getBoundingClientRect(), s = [];
  for (let l = 0; l < r.length; l += 1) {
    const c = e.ownerDocument.createRange();
    c.setStart(o, l), c.setEnd(o, l + 1);
    const a = c.getBoundingClientRect();
    a.width === 0 && a.height === 0 || s.push({
      char: r[l],
      top: a.top - i.top,
      left: a.left - i.left,
      bottom: a.bottom - i.top,
      right: a.right - i.left,
      runIndex: n
    });
  }
  return s;
}, Gu = (e) => ve(e).map((t) => t.map((n) => e[n])), Vu = (e, t) => t ? "paragraph" : e.querySelector(`[${at}]`) ? "blank-runless" : "blank-empty-run", nl = (e) => {
  var a;
  const t = Array.from(
    e.querySelectorAll(H)
  ), n = Array.from(
    e.querySelectorAll(
      `[${un}], [${at}]`
    )
  ).reduce((d, u) => {
    var f;
    return d + (((f = u.textContent) == null ? void 0 : f.length) ?? 0);
  }, 0), r = (((a = e.textContent) == null ? void 0 : a.length) ?? 0) - n > Wu;
  let i = 0, s = 0;
  const c = t.map((d, u) => {
    const f = Array.from(
      d.querySelectorAll(B)
    ), g = r ? [] : f.flatMap((p, h) => ju(e, p, h)), b = g.length ? Gu(g) : [];
    for (const p of b) {
      const h = Math.max(...p.map((m) => m.right)) - Math.min(...p.map((m) => m.left));
      h > i && (i = h);
    }
    return { block: d, index: u, runEls: f, glyphLines: b };
  }).map(
    ({ block: d, index: u, runEls: f, glyphLines: g }) => {
      var E;
      const b = (E = e.ownerDocument.defaultView) == null ? void 0 : E.getComputedStyle(d), p = d.getBoundingClientRect(), h = e.getBoundingClientRect(), m = g.length > 0;
      s += m ? g.length : 1;
      const k = g.map((S, y) => {
        const v = Math.min(...S.map((F) => F.top)), T = Math.max(...S.map((F) => F.bottom)), Y = Math.min(...S.map((F) => F.left)), R = Math.max(...S.map((F) => F.right)) - Y, z = [];
        let j = [];
        const ft = () => {
          if (j.length === 0) return;
          const F = j[0].runIndex, mt = f[F], M = mt ? Jn(mt, F) : null;
          z.push({
            runIndex: F,
            text: j.map((st) => st.char).join(""),
            authoredPt: (M == null ? void 0 : M.authoredPt) ?? NaN,
            renderedPx: M ? M.fontSizePt * ln : NaN,
            fontFamily: (M == null ? void 0 : M.fontFamily) ?? "",
            letterSpacingPt: (M == null ? void 0 : M.letterSpacingPt) ?? 0,
            color: (M == null ? void 0 : M.color) ?? ""
          }), j = [];
        };
        let q = -1;
        for (const F of S)
          F.runIndex !== q && (ft(), q = F.runIndex), j.push(F);
        return ft(), {
          index: y,
          text: S.map((F) => F.char).join(""),
          top: v,
          height: T - v,
          width: R,
          isWrap: y > 0,
          widthDriver: R >= i - 0.5 && i > 0,
          runs: z
        };
      });
      return {
        index: u,
        role: Vu(d, m),
        blank: !m,
        top: p.top - h.top,
        height: p.height,
        lineHeight: (b == null ? void 0 : b.lineHeight) ?? "",
        align: (b == null ? void 0 : b.textAlign) ?? "",
        lines: k
      };
    }
  );
  return {
    frame: { width: e.clientWidth, height: e.clientHeight },
    content: { width: e.scrollWidth, height: e.scrollHeight },
    paintedLineCount: s,
    degraded: r,
    blocks: c,
    painted: zu(e)
  };
}, rp = (e) => ({
  fit: Ku(e),
  layout: nl(e)
}), Uu = (e) => Array.from(
  e.querySelectorAll(`[${mo}]`)
).map((t) => ({
  el: t,
  basePt: Number(t.dataset[Bi])
})), _n = (e) => Array.from(e.querySelectorAll(B)).map(
  (t) => {
    if (t.dataset[It] !== void 0)
      return { el: t, basePt: Number(t.dataset[It]) };
    const n = Number.parseFloat(t.style.fontSize) || 0;
    return t.dataset[It] = String(n), { el: t, basePt: n };
  }
), Yu = (e, t, n, o, r) => {
  const i = Au(e, t);
  return {
    inkRect: (i == null ? void 0 : i.rect) ?? Zd(e, t, n, o) ?? Od(n, o, r),
    inkClusters: (i == null ? void 0 : i.clusters) ?? null
  };
}, Zn = (e) => e.el.dataset[rt] === void 0 && e.el.dataset[Tt] === void 0, qu = (e, t) => {
  const n = e.ownerDocument, o = [];
  for (const r of t) {
    if (!Zn(r)) continue;
    let i;
    try {
      const s = n.createRange();
      s.selectNodeContents(r.el), i = s.getClientRects();
    } catch {
      continue;
    }
    for (const s of Array.from(i))
      s.height > 0 && o.push({ top: s.top, bottom: s.bottom });
  }
  return ve(o).length;
};
class Vo {
  constructor(t, n = {}) {
    x(this, "box");
    x(this, "verifyInk");
    x(this, "lastScale", 1);
    x(this, "lastFrameHeightPx", 0);
    /** The text sizing the last fit ran under, so `explain` recomputes its ceiling. */
    x(this, "lastSizing", Fa);
    x(this, "hasSettled", !1);
    x(this, "version", 0);
    x(this, "cachedExplanation", null);
    x(this, "cachedLayout", null);
    /**
     * The ink of the box: the glyph ladder's rect and the rules' rect in one,
     * either alone when the other is absent. A rule has no cluster and no
     * raster, so its ink is measured beside the ladder's and joined to it,
     * and joined again when the idle verify replaces the ladder's rect.
     */
    x(this, "lastInkRect", null);
    x(this, "lastRuleInkRect", null);
    x(this, "lastInkClusters", null);
    x(this, "lastTextHeightPx", null);
    x(this, "lastPaintedHeightPx", null);
    x(this, "lastLineCount", 0);
    x(this, "verifyHandle", null);
    x(this, "disposed", !1);
    this.box = t, this.verifyInk = n.verifyInkContainment === !0;
  }
  get scale() {
    return this.lastScale;
  }
  get inkRect() {
    return this.lastInkRect;
  }
  get inkClusters() {
    return this.lastInkClusters;
  }
  get textHeightPx() {
    return this.lastTextHeightPx;
  }
  get paintedHeightPx() {
    return this.lastPaintedHeightPx;
  }
  get lineCount() {
    return this.lastLineCount;
  }
  get settled() {
    return this.hasSettled;
  }
  get fitVersion() {
    return this.version;
  }
  capturedBasePads() {
    var n;
    const t = this.box;
    if (t.dataset[G.top] === void 0) {
      const o = (n = t.ownerDocument.defaultView) == null ? void 0 : n.getComputedStyle(t), r = (i) => String(Number.parseFloat(i ?? "") || 0);
      t.dataset[G.top] = r(o == null ? void 0 : o.paddingTop), t.dataset[G.bottom] = r(o == null ? void 0 : o.paddingBottom), t.dataset[G.left] = r(o == null ? void 0 : o.paddingLeft), t.dataset[G.right] = r(o == null ? void 0 : o.paddingRight);
    }
    return {
      top: Number(t.dataset[G.top]),
      bottom: Number(t.dataset[G.bottom]),
      left: Number(t.dataset[G.left]),
      right: Number(t.dataset[G.right])
    };
  }
  applyFontScale(t, n) {
    for (const o of [...n, ...Uu(this.box)])
      Number.isFinite(o.basePt) && (o.el.style.fontSize = `${le(o.basePt, t)}pt`);
  }
  applyInkInset(t, n, o) {
    const r = _d(n, t), i = Ld(n, t), s = {
      top: o.top + r.top,
      bottom: o.bottom + r.bottom,
      left: o.left + i.left,
      right: o.right + i.right
    };
    return this.box.style.paddingTop = `${s.top}px`, this.box.style.paddingBottom = `${s.bottom}px`, this.box.style.paddingLeft = `${s.left}px`, this.box.style.paddingRight = `${s.right}px`, s;
  }
  /**
   * The scroll height with the CSS height at auto and every run and strut
   * at `scale`, the ghost of an empty case field keeping its line.
   */
  readScrollHeightAt(t, n, o, r) {
    return this.applyFontScale(t, n), this.applyInkInset(t, o, r), { ...this.readHeightAtAuto(), scale: t };
  }
  /**
   * The height the runs need as they stand: the scroll height with the CSS
   * height at auto, restored after, and the outer height with the borders.
   */
  readHeightAtAuto() {
    const t = this.box, n = t.style.height;
    t.style.height = "auto";
    const o = t.scrollHeight;
    t.style.height = n;
    const r = t.offsetHeight - t.clientHeight;
    return { outerPx: o + r, scrollPx: o };
  }
  /**
   * The text height: the scroll height with the CSS height at auto and every
   * run and strut at fitScale 1. When the widest line does not fit the frame
   * at fitScale 1, the height is read again at the largest scale that fits
   * the width, because a word wider than the frame binds the search to that
   * scale whatever the height, and the wrap at fitScale 1 is one the fit
   * will never paint: a frame grown for it would keep the dead space. Read
   * before the search so the growth rule can set the frame the search fits
   * into.
   */
  readTextHeight(t, n, o, r) {
    const i = this.box;
    if (i.querySelector(H) === null) return null;
    const s = this.readScrollHeightAt(1, t, n, o);
    if (i.scrollWidth <= i.clientWidth) return s;
    const l = Bd(
      (c) => (this.applyFontScale(c, t), this.applyInkInset(c, n, o), i.scrollWidth <= i.clientWidth),
      { minScale: r }
    );
    return this.readScrollHeightAt(l, t, n, o);
  }
  fit(t) {
    var b;
    const n = this.box;
    this.cancelVerify();
    const o = _n(n);
    n.style.overflow = "hidden";
    const r = o.flatMap(
      (p) => Zn(p) ? [p.basePt] : []
    ), i = r.length === 0, s = i ? o.flatMap(
      (p) => p.el.dataset[rt] !== void 0 ? [p.basePt] : []
    ) : r, l = o.flatMap(
      (p) => p.el.dataset[Tt] !== void 0 ? [p.el] : []
    ), c = l.map((p) => p.textContent ?? "");
    l.forEach((p) => {
      p.textContent = "";
    });
    const a = Pu(o), d = this.capturedBasePads();
    l.forEach((p, h) => {
      p.textContent = c[h];
    });
    const u = ((b = t.overrides) == null ? void 0 : b.minScale) ?? Wn(s), f = Array.from(
      n.querySelectorAll(`[${Ye}]`)
    ).map((p) => ({ el: p, display: p.style.display }));
    f.forEach(({ el: p }) => {
      p.style.display = "none";
    });
    const g = o.flatMap((p) => {
      if (p.el.dataset[rt] === void 0) return [];
      const h = n.ownerDocument.createTextNode(" ");
      return p.el.insertBefore(h, p.el.firstChild), [h];
    });
    try {
      return this.fitMeasured(t, o, a, d, u, {
        standIn: i,
        searchBases: s
      });
    } finally {
      g.forEach((p) => p.remove()), f.forEach(({ el: p, display: h }) => {
        p.style.display = h;
      });
    }
  }
  fitMeasured(t, n, o, r, i, s) {
    const l = this.box, { growth: c } = t, { standIn: a, searchBases: d } = s, u = this.readTextHeight(n, o, r, i), f = l.offsetHeight - l.clientHeight, g = Fd({
      growth: c,
      framePx: l.clientHeight,
      textHeightPx: (u == null ? void 0 : u.scrollPx) ?? null
    }), b = g + f, p = (T) => (this.applyFontScale(T, n), this.applyInkInset(T, o, r), l.scrollHeight <= g + Eo && l.scrollWidth <= l.clientWidth);
    this.lastSizing = t.sizing;
    const h = {
      minScale: i,
      ceiling: lr({
        sizing: t.sizing,
        frameHeightPx: b,
        basesPt: d
      }),
      minGrow: Oa(b),
      ...t.overrides
    }, m = d.length === 0 ? { scale: 1, overflowing: !1 } : Dd(p, h), k = a ? { ...m, overflowing: !1 } : m;
    this.applyFontScale(k.scale, n);
    const E = this.applyInkInset(k.scale, o, r);
    l.style.overflow = k.overflowing ? "hidden" : "visible", this.lastScale = k.scale, this.lastFrameHeightPx = b, this.lastTextHeightPx = (u == null ? void 0 : u.outerPx) ?? null, this.lastPaintedHeightPx = u === null ? null : k.scale === u.scale ? u.outerPx : this.readHeightAtAuto().outerPx, l.dataset[bo] = k.scale.toFixed(3), l.dataset[qe] = String(k.overflowing), delete l.dataset[tr];
    const S = {
      paddingTop: E.top,
      paddingBottom: E.bottom,
      paddingLeft: E.left,
      paddingRight: E.right,
      scrollWidth: l.scrollWidth,
      scrollHeight: l.scrollHeight
    }, y = Yu(l, n, o, k.scale, S);
    this.lastRuleInkRect = Cu(l), this.lastInkRect = Er(y.inkRect, this.lastRuleInkRect), this.lastInkClusters = y.inkClusters, this.lastLineCount = qu(l, n), this.hasSettled = !0, this.version += 1, this.verifyInk && !k.overflowing && o.some((T) => T.raster !== void 0) && this.scheduleVerify(
      Ou(n),
      E,
      S
    );
    const v = {
      scale: k.scale,
      overflowing: k.overflowing,
      textHeightPx: this.lastTextHeightPx,
      paintedHeightPx: this.lastPaintedHeightPx,
      lineCount: this.lastLineCount,
      frameHeightPx: b
    };
    return this.lastInkRect ? {
      ...v,
      inkRect: this.lastInkRect,
      ...y.inkClusters ? { inkClusters: y.inkClusters } : {}
    } : v;
  }
  /**
   * A handle is held: nothing counts as settled until the release. A pill's
   * paint-only fits repaint the runs every frame; a corner previews
   * authored × k; the model's sizes stay where the last write left them.
   */
  holdForDrag() {
    this.cancelVerify(), this.hasSettled = !1, this.box.style.overflow = "visible";
  }
  /** A corner scale in progress: every authored size × k, live, with no fit. */
  previewCornerScale(t) {
    Number.isFinite(t) && t > 0 && this.applyFontScale(t, _n(this.box));
  }
  explain() {
    var s;
    if (((s = this.cachedExplanation) == null ? void 0 : s.version) === this.version)
      return this.cachedExplanation.value;
    const t = _n(this.box);
    if (t.length === 0) return null;
    const n = t.flatMap(
      (l) => Zn(l) ? [l.basePt] : []
    );
    if (n.length === 0) return null;
    const { axis: o, contentLineCount: r } = el(
      this.box,
      this.lastScale
    ), i = As({
      scale: this.lastScale,
      minScale: Wn(n),
      ceilingScale: lr({
        sizing: this.lastSizing,
        frameHeightPx: this.lastFrameHeightPx || this.box.offsetHeight,
        basesPt: n
      }),
      authoredBasesPt: n,
      minSizePt: Ee,
      overflowing: this.box.dataset[qe] === "true",
      bindingAxis: o,
      longWord: (o === "width" || o === "both") && r <= 1
    });
    return this.cachedExplanation = { version: this.version, value: i }, i;
  }
  describeLayout() {
    var n;
    if (((n = this.cachedLayout) == null ? void 0 : n.version) === this.version)
      return this.cachedLayout.value;
    const t = nl(this.box);
    return this.cachedLayout = { version: this.version, value: t }, t;
  }
  dispose() {
    this.cancelVerify(), this.disposed = !0;
  }
  cancelVerify() {
    if (this.verifyHandle === null) return;
    const t = this.box.ownerDocument.defaultView;
    this.verifyHandle.kind === "idle" && t && typeof t.cancelIdleCallback == "function" ? t.cancelIdleCallback(this.verifyHandle.id) : t == null || t.clearTimeout(this.verifyHandle.id), this.verifyHandle = null;
  }
  scheduleVerify(t, n, o) {
    this.cancelVerify();
    const r = this.box.ownerDocument.defaultView;
    if (!r) return;
    const i = () => {
      if (this.verifyHandle = null, this.disposed) return;
      const s = Du(
        this.box.ownerDocument,
        t,
        n,
        o
      );
      s && (s.inkRect && this.lastInkClusters === null && (this.lastInkRect = Er(
        s.inkRect,
        this.lastRuleInkRect
      )), s.escapes && (this.box.dataset[tr] = "true"));
    };
    typeof r.requestIdleCallback == "function" ? this.verifyHandle = {
      kind: "idle",
      id: r.requestIdleCallback(i, { timeout: 500 })
    } : this.verifyHandle = { kind: "timeout", id: r.setTimeout(i, 500) };
  }
}
const Xu = "font-retry", Ju = [
  ["font-weight", "weight"],
  ["font-style", "style"],
  ["font-stretch", "stretch"],
  ["unicode-range", "unicodeRange"],
  ["font-display", "display"],
  ["font-feature-settings", "featureSettings"],
  ["ascent-override", "ascentOverride"],
  ["descent-override", "descentOverride"],
  ["line-gap-override", "lineGapOverride"]
], Zu = {
  normal: "400",
  bold: "700"
}, Dr = (e) => e.trim().toLowerCase().split(/\s+/).map((t) => Zu[t] ?? t).join(" ") || "400", Qn = (e, t) => e.trim().toLowerCase().replace(/\s+/g, " ") || t, Br = (e) => {
  const t = Qn(e, "normal");
  return t === "100%" ? "normal" : t;
}, Mr = (e) => Ho(e || "U+0-10FFFF").map(([t, n]) => `${t}-${n}`).sort().join(","), Nr = (e) => {
  try {
    return e == null ? void 0 : e.cssRules;
  } catch {
    return;
  }
}, Qu = (e) => {
  const t = e.defaultView;
  if (!t) return [];
  const n = [], o = (r) => {
    for (const i of Array.from(r ?? []))
      i instanceof t.CSSFontFaceRule ? n.push(i) : i instanceof t.CSSImportRule ? o(Nr(i.styleSheet)) : i instanceof t.CSSGroupingRule && o(i.cssRules);
  };
  for (const r of Array.from(e.styleSheets)) o(Nr(r));
  return n;
}, tf = (e, t) => {
  const n = it(t.family), o = Dr(t.weight), r = Qn(t.style, "normal"), i = Br(t.stretch), s = Mr(t.unicodeRange);
  return Qu(e).filter((l) => {
    const c = (a) => l.style.getPropertyValue(a);
    return it(c("font-family")) === n && Dr(c("font-weight")) === o && Qn(c("font-style"), "normal") === r && Br(c("font-stretch")) === i && Mr(c("unicode-range")) === s;
  });
}, ef = (e, t) => e.replace(
  /url\(\s*(['"]?)(.*?)\1\s*\)/g,
  (n, o, r) => {
    let i;
    try {
      i = new URL(r, t);
    } catch {
      return n;
    }
    return i.protocol !== "http:" && i.protocol !== "https:" ? n : (i.searchParams.set(Xu, "1"), `url("${i.href}")`);
  }
), nf = (e, t, n) => {
  var l;
  const o = e.defaultView;
  if (!o) return null;
  const r = ((l = n.parentStyleSheet) == null ? void 0 : l.href) ?? e.baseURI, i = {};
  for (const [c, a] of Ju) {
    const d = n.style.getPropertyValue(c).trim();
    d !== "" && (i[a] = d);
  }
  i.display === void 0 && (i.display = "swap");
  const s = ef(n.style.getPropertyValue("src"), r);
  if (s.trim() === "") return null;
  try {
    return new o.FontFace(t, s, i);
  } catch {
    return null;
  }
}, zt = /* @__PURE__ */ new WeakMap(), ol = /* @__PURE__ */ new WeakMap(), on = /* @__PURE__ */ new WeakMap(), of = (e, t) => Ds(e.face) && [...t].some((n) => n.isConnected), rl = (e, t) => {
  var n;
  e.told.has(t) || (e.told.add(t), (n = e.onFailedForGood) == null || n.call(e, t.family));
}, rf = (e, t, n) => {
  const o = {
    onFailedForGood: t,
    timeoutMs: n,
    told: /* @__PURE__ */ new WeakSet()
  };
  zt.set(e, [...zt.get(e) ?? [], o]);
  const r = t ? on.get(e) : void 0;
  if (r !== void 0) {
    on.delete(e);
    for (const [i, s] of r)
      of(i, s) && rl(o, i);
  }
  return () => {
    zt.set(
      e,
      (zt.get(e) ?? []).filter((i) => i !== o)
    );
  };
}, sf = (e, t) => new Promise((n) => {
  const o = setTimeout(() => n(!1), t);
  e.load().then(
    () => {
      clearTimeout(o), n(!0);
    },
    () => {
      clearTimeout(o), n(!1);
    }
  );
}), il = (e, t, n) => {
  const o = [...n].filter((l) => l.isConnected);
  if (o.length === 0) return;
  const r = (zt.get(e) ?? []).filter(
    (l) => l.onFailedForGood !== void 0
  );
  if (r.length > 0) {
    for (const l of r) rl(l, t);
    return;
  }
  const i = on.get(e) ?? /* @__PURE__ */ new Map(), s = [...i.get(t) ?? []].filter(
    (l) => l.isConnected
  );
  i.set(t, /* @__PURE__ */ new Set([...s, ...o])), on.set(e, i);
}, lf = (e, t, n, o) => {
  const r = tf(e, t).map((l) => nf(e, t.family, l)).filter((l) => l !== null), i = {
    face: t,
    family: bn(t.family),
    askers: /* @__PURE__ */ new Set([n]),
    verdict: "out"
  };
  for (const l of [t, ...r]) ol.set(l, i);
  for (const l of r)
    Qd(t, l), su(e.fonts, l);
  const s = () => {
    for (const l of r)
      l.status !== "loaded" && lu(e.fonts, l);
  };
  for (const l of [t, ...r])
    l.loaded.then(s, () => {
    });
  Promise.all(
    [t, ...r].map((l) => sf(l, o))
  ).then((l) => {
    const c = [...i.askers];
    if (i.askers.clear(), l.includes(!0)) {
      i.verdict = "landed";
      return;
    }
    i.verdict = "failed", tu(t), il(e, i, c);
  });
}, sl = (e, t) => {
  const n = e.ownerDocument, o = zt.get(n) ?? [];
  for (const r of t) {
    const i = ol.get(r);
    (i == null ? void 0 : i.verdict) === "out" ? i.askers.add(e) : (i == null ? void 0 : i.verdict) === "failed" ? il(n, i, [e]) : i === void 0 && o.length > 0 && lf(n, r, e, o[o.length - 1].timeoutMs);
  }
}, cf = (e) => {
  const t = /* @__PURE__ */ new Set(), n = e.ownerDocument.defaultView;
  if (!n) return t;
  const o = (r) => {
    for (const i of n.getComputedStyle(r).fontFamily.split(","))
      t.add(it(i));
  };
  return o(e), e.querySelectorAll(
    `${H}, ${B}`
  ).forEach(o), t;
}, af = (e, t) => {
  const n = t.fontfaces;
  if (!n || n.length === 0) return !0;
  const o = cf(e);
  return n.some((r) => o.has(it(r.family)));
}, df = (e, t, n) => {
  const o = e == null ? void 0 : e.fonts;
  if (!(o != null && o.addEventListener)) return () => {
  };
  const r = (i) => {
    n !== void 0 && !af(n, i) || t();
  };
  return o.addEventListener("loadingdone", r), o.addEventListener("loadingerror", r), () => {
    o.removeEventListener("loadingdone", r), o.removeEventListener("loadingerror", r);
  };
}, xn = 1e4, ip = (e, t, n = xn) => rf(e, t, n), uf = (e, t) => {
  const n = /* @__PURE__ */ new Map(), o = (r) => {
    const i = t.getComputedStyle(r), s = i.fontFamily;
    if (!s) return;
    const l = `${i.fontStyle || "normal"} ${i.fontWeight || "400"} 16px ${s}`;
    let c = n.get(l);
    c || (c = {
      chars: /* @__PURE__ */ new Set(),
      families: new Set(s.split(",").map(it)),
      weight: Number(i.fontWeight) || 400,
      style: i.fontStyle || "normal"
    }, n.set(l, c));
    const a = r.textContent;
    if (a) for (const d of a) c.chars.add(d);
  };
  return e.querySelectorAll(B).forEach(o), e.querySelectorAll(H).forEach((r) => {
    r.style.fontFamily !== "" && o(r);
  }), n;
}, Rt = (e) => {
  const t = e.ownerDocument, n = t == null ? void 0 : t.fonts, o = t == null ? void 0 : t.defaultView;
  return !n || !o ? null : { fonts: n, specs: uf(e, o) };
}, ll = ({ fonts: e, specs: t }) => {
  if (typeof e.load == "function")
    for (const [n, { chars: o }] of t) {
      const r = o.size > 0 ? Array.from(o).join("") : void 0;
      try {
        e.load(n, r).catch(() => []);
      } catch {
      }
    }
}, ff = ({ specs: e }) => {
  const t = /* @__PURE__ */ new Map();
  for (const o of e.values())
    for (const r of o.families) {
      const i = t.get(r) ?? /* @__PURE__ */ new Set();
      for (const s of o.chars) i.add(s);
      t.set(r, i);
    }
  const n = /* @__PURE__ */ new Map();
  for (const [o, r] of t)
    n.set(o, Array.from(r).join(""));
  return n;
}, we = (e) => Ws(e.fonts, ff(e)), kn = ({ specs: e }) => Array.from(e.values(), ({ families: t, chars: n, weight: o, style: r }) => ({
  families: t,
  text: Array.from(n).join(""),
  weight: o,
  style: r
})), Uo = (e) => du(e.fonts, kn(e)), Yo = (e, t) => sl(e, Ks(t.fonts, kn(t))), hf = (e) => {
  const t = Rt(e);
  return t === null || we(t).length === 0;
}, sp = (e) => {
  const t = Rt(e);
  return t === null || we(t).length === 0 && Uo(t).length === 0;
}, $r = (e) => hf(e) && !cl(e), cl = (e) => pf(e).length > 0, pf = (e) => {
  const t = Rt(e);
  if (t === null) return [];
  const n = Ks(t.fonts, kn(t)).map(
    (o) => bn(o.family)
  );
  return [...new Set(n)];
}, to = /* @__PURE__ */ new WeakMap(), al = (e) => {
  const t = Rt(e);
  if (t === null) return !1;
  ll(t), Yo(e, t);
  const n = we(t);
  for (const o of to.get(e) ?? [])
    o.outdatedBy(n) && o.wake();
  return n.length > 0 || Uo(t).length > 0;
}, dl = (e, t, n, o) => new Promise((r) => {
  const i = to.get(e) ?? /* @__PURE__ */ new Set();
  to.set(e, i);
  const s = {
    outdatedBy: o,
    wake: () => {
      clearTimeout(l), i.delete(s), r();
    }
  }, l = setTimeout(s.wake, n);
  i.add(s);
  for (const c of t) c.loaded.then(s.wake, s.wake);
}), gf = (e) => (t) => t.length !== e.length || t.some((n) => !e.includes(n)), mf = async (e, t, n) => {
  let o = t;
  for (; o.length > 0; ) {
    const r = n - performance.now();
    if (r <= 0) {
      const s = Rt(e);
      s !== null && sl(
        e,
        uu(s.fonts, kn(s))
      );
      return;
    }
    if (await dl(e, o, r, gf(o)), !e.isConnected) return;
    e.getBoundingClientRect();
    const i = Rt(e);
    if (i === null) return;
    Yo(e, i), o = we(i);
  }
}, bf = (e, t = xn) => {
  const n = Rt(e);
  if (n === null) return null;
  ll(n), Yo(e, n);
  const o = we(n);
  return o.length === 0 ? null : mf(e, o, performance.now() + t);
}, ul = (e, t = xn) => {
  const n = bf(e, t);
  if (n !== null) return n;
  const o = Rt(e);
  if (o === null) return null;
  const r = Uo(o);
  return r.length === 0 ? null : dl(
    e,
    r,
    t,
    (i) => i.length > 0
  );
}, lp = (e, t, n = xn) => {
  let o = !0;
  const r = () => {
    const i = ul(e, n);
    i !== null && i.then(() => {
      o && (t(), r());
    });
  };
  return r(), () => {
    o = !1;
  };
}, Ln = (e) => !cl(e), xf = (e, t, n) => e && (!t || !n), kf = ({
  ownPx: e,
  paintedHeightPx: t,
  followsText: n
}) => {
  if (!n) return e;
  if (t === null || !Number.isFinite(t) || t <= 0)
    return null;
  const o = Math.ceil(t - 1e-6);
  return o <= e + Eo ? e : o;
}, zr = (e, t) => e.blockIndex === t.blockIndex && e.offset === t.offset, Oe = (e) => ({
  blockIndex: e.blockIndex,
  offset: e.start
}), De = (e) => ({
  blockIndex: e.blockIndex,
  offset: e.end
}), yf = (e, t, n, o = null) => {
  const r = P(e.pos, t.pos) <= 0;
  let i = e.pos, s = t.pos;
  const l = e.insideField !== null || t.insideField !== null;
  if (e.insideField && (i = r ? Oe(e.insideField) : De(e.insideField)), t.insideField && (s = r ? De(t.insideField) : Oe(t.insideField)), n) {
    const a = Oe(n), d = De(n);
    r ? P(a, i) >= 0 && P(s, d) < 0 && (s = d) : P(d, i) <= 0 && P(s, a) > 0 && (s = a);
  }
  if (o) {
    const a = Oe(o), d = De(o);
    r ? (P(i, a) > 0 && (i = a), P(s, d) < 0 && (s = d)) : (P(i, d) < 0 && (i = d), P(s, a) > 0 && (s = a));
  }
  return !(!zr(i, e.pos) || !zr(s, t.pos)) && !l ? null : { anchor: i, focus: s };
}, Sf = 8, fl = (e, t) => {
  const n = t > 0 ? e / t : 1;
  return Math.min(Sf * n, e / 3);
}, Hr = (e, t, n) => {
  const r = Array.from(e.getClientRects()).find((s) => n >= s.top && n <= s.bottom) ?? e.getBoundingClientRect(), i = fl(r.width, e.offsetWidth);
  return i <= 0 ? null : t <= r.left + i ? Bo(e).length === 0 ? "before" : null : t >= r.right - i ? Ls(e) ? null : "after" : null;
}, Ef = (e, t, n) => (t > 0 || Bo(e).length > 0) && (t < n || Ls(e));
class If {
  constructor(t) {
    x(this, "selected", null);
    this.deps = t;
  }
  get selection() {
    return this.selected;
  }
  stamp(t, n) {
    var r;
    this.clear();
    const o = (r = this.deps.blockElement(t)) == null ? void 0 : r.querySelectorAll(
      `${B}[${go}="${n}"]`
    );
    !o || o.length === 0 || (this.selected = { blockIndex: t, runIndex: n }, o.forEach(
      (i) => i.setAttribute(Sn, "")
    ));
  }
  clear() {
    this.selected = null, this.deps.el.querySelectorAll(
      `[${Sn}]`
    ).forEach((n) => n.removeAttribute(Sn));
  }
  dropForRepaint() {
    this.selected = null;
  }
  retireIfStale() {
    this.selected && !this.selectionIs(this.selected) && this.clear();
  }
  selectionIs(t) {
    const n = this.deps.readSelection();
    if (!n) return !1;
    const [o, r] = V(n.anchor, n.focus);
    if (o.blockIndex !== t.blockIndex || r.blockIndex !== t.blockIndex)
      return !1;
    const i = yt(
      this.deps.box().blocks[t.blockIndex],
      t.runIndex
    );
    return o.offset === i && r.offset === i + 1;
  }
}
const hl = (e, t) => {
  const n = e.runs[t];
  return (n == null ? void 0 : n.kind) === "field" ? n.fieldKey : null;
}, pl = (e, t) => t.hasAttribute(un) ? [] : en(e, t.getClientRects()), gl = (e) => Array.from(e.querySelectorAll(B)), vf = (e, t) => {
  const n = Math.min(e.top, t.top), o = Math.min(e.left, t.left), r = Math.max(e.top + e.height, t.top + t.height), i = Math.max(e.left + e.width, t.left + t.width);
  return { top: n, left: o, width: i - o, height: r - n };
}, wf = (e) => {
  var o;
  const t = (o = e.ownerDocument) == null ? void 0 : o.defaultView, n = t ? parseFloat(t.getComputedStyle(e).lineHeight) : NaN;
  return Number.isFinite(n) && n > 0 ? n : null;
}, Rf = (e, t) => {
  const n = [];
  for (const o of [...e].sort((r, i) => r.top - i.top)) {
    const r = n[n.length - 1], i = o.top + o.height / 2;
    r && i >= r.top && i <= r.top + r.height ? n[n.length - 1] = vf(r, o) : n.push({ ...o });
  }
  if (t !== null)
    for (const o of n)
      o.top = o.top + o.height / 2 - t / 2, o.height = t;
  for (let o = 0; o + 1 < n.length; o += 1) {
    const r = n[o], i = n[o + 1], s = (r.top + r.height + i.top) / 2;
    r.height = s - r.top, i.height = i.top + i.height - s, i.top = s;
  }
  return n;
}, Tf = (e, t, n, o) => {
  const r = hl(n, 0), i = t.querySelector("table");
  if (r === null || !i || !gl(t).some((l) => pl(e, l).length > 0))
    return null;
  const s = en(e, [i.getBoundingClientRect()]);
  return s.length > 0 ? { blockIndex: o, runIndex: 0, fieldKey: r, lines: s } : null;
}, Af = (e, t) => {
  const n = [], o = e.querySelectorAll(H);
  for (const r of Array.from(o)) {
    const i = Number(r.dataset[Et]), s = Number.isInteger(i) ? t.blocks[i] : void 0;
    if (!s) continue;
    if (s.kind === "case_detail_table") {
      const c = Tf(e, r, s, i);
      c && n.push(c);
      continue;
    }
    const l = /* @__PURE__ */ new Map();
    for (const c of gl(r)) {
      const a = Number(c.dataset[ct]);
      if (!Number.isInteger(a)) continue;
      const d = l.get(a);
      d ? d.push(c) : l.set(a, [c]);
    }
    for (const [c, a] of l) {
      const d = hl(s, c);
      if (d === null) continue;
      const u = Rf(
        a.flatMap((f) => pl(e, f)),
        wf(a[0])
      );
      u.length > 0 && n.push({ blockIndex: i, runIndex: c, fieldKey: d, lines: u });
    }
  }
  return n;
}, Wr = (e) => String(Math.round(e * 100) / 100), Cf = (e, t) => {
  const n = [], o = (s, l) => {
    const c = `${Wr(s)} ${Wr(l)}`;
    n[n.length - 1] !== c && n.push(c);
  };
  e.forEach((s) => {
    o(s.left + s.width + t, s.top), o(s.left + s.width + t, s.top + s.height);
  }), [...e].reverse().forEach((s) => {
    o(s.left - t, s.top + s.height), o(s.left - t, s.top);
  });
  const [r, ...i] = n;
  return `M ${r} L ${i.join(" L ")} Z`;
}, cp = (e, t) => {
  const n = e.map((r, i) => {
    const s = i === 0 ? r.top - t.y : r.top, l = r.top + r.height + (i === e.length - 1 ? t.y : 0);
    return { ...r, top: s, height: l - s };
  }), o = [];
  return n.forEach((r, i) => {
    const s = i > 0 ? n[i - 1] : null;
    s !== null && s.left - t.x < r.left + r.width + t.x && r.left - t.x < s.left + s.width + t.x ? o[o.length - 1].push(r) : o.push([r]);
  }), o.map((r) => Cf(r, t.x));
};
class Ff {
  constructor(t) {
    x(this, "selected", null);
    this.deps = t;
  }
  /** The block index of the rule the selection covers alone, or null. */
  get selection() {
    return this.selected;
  }
  sync() {
    const t = this.deps.readSelection(), n = t === null ? null : xa(this.deps.box(), t), o = n === null ? null : this.deps.blockElement(n);
    n === this.selected && (n === null || o != null && o.hasAttribute(oe)) || (this.clear(), !(n === null || o === null) && (o.setAttribute(oe, ""), this.selected = n));
  }
  clear() {
    this.selected = null, this.deps.el.querySelectorAll(`[${oe}]`).forEach((t) => t.removeAttribute(oe));
  }
  /** A repaint rebuilds the block's attributes; the next sync marks again. */
  dropForRepaint() {
    this.selected = null;
  }
}
class Pf {
  constructor(t) {
    x(this, "covered", []);
    x(this, "selected", null);
    x(this, "stop", null);
    this.deps = t;
  }
  /** The block index of the table the selection covers whole and alone, or null. */
  get selection() {
    return this.selected;
  }
  /** The table stop the caret bar is painted at, or null. */
  get caret() {
    return this.stop;
  }
  sync() {
    const t = this.deps.readSelection(), n = this.deps.box(), o = t === null ? [] : Ui(n, t);
    this.selected = t === null ? null : Yt(n, t);
    const r = t !== null && D(t) && this.deps.hasFocus() ? Wt(n, t.focus) : null;
    this.markCovered(o), this.markCaret(r);
  }
  clear() {
    this.selected = null, this.markCovered([]), this.stop = null, this.removeCaretMarks();
  }
  /** A repaint rebuilds the blocks' attributes; the next sync marks again. */
  dropForRepaint() {
    this.covered = [], this.selected = null, this.stop = null;
  }
  markCovered(t) {
    var o;
    if (!(t.length === this.covered.length && t.every(
      (r, i) => {
        var s;
        return r === this.covered[i] && ((s = this.deps.blockElement(r)) == null ? void 0 : s.hasAttribute(Mt));
      }
    ))) {
      this.deps.el.querySelectorAll(`[${Mt}]`).forEach((r) => r.removeAttribute(Mt));
      for (const r of t)
        (o = this.deps.blockElement(r)) == null || o.setAttribute(Mt, "");
      this.covered = t;
    }
  }
  removeCaretMarks() {
    this.deps.el.querySelectorAll(`[${St}]`).forEach((t) => t.removeAttribute(St));
  }
  markCaret(t) {
    var r;
    const n = this.stop;
    if (n === null && t === null || n !== null && t !== null && n.blockIndex === t.blockIndex && n.side === t.side && ((r = this.deps.blockElement(t.blockIndex)) != null && r.hasAttribute(St)))
      return;
    this.removeCaretMarks();
    const o = t === null ? null : this.deps.blockElement(t.blockIndex);
    if (t === null || o === null) {
      this.stop = null;
      return;
    }
    o.setAttribute(St, t.side), this.stop = t;
  }
}
const _f = (e, t) => {
  const n = (t.top + t.bottom) / 2, o = (r, i, s) => ({
    top: r,
    bottom: i,
    span: {
      left: t.left,
      right: t.right,
      before: { blockIndex: e, offset: s },
      after: { blockIndex: e, offset: s }
    }
  });
  return [o(t.top, n, 0), o(n, t.bottom, 1)];
}, Lf = (e) => ve(e).map((t) => ({
  top: Math.min(...t.map((n) => e[n].top)),
  bottom: Math.max(...t.map((n) => e[n].bottom)),
  spans: t.map((n) => e[n].span)
})), Of = (e, t, n) => {
  const o = Df(e, n);
  if (!o) return null;
  const r = o.spans;
  if (r.length === 0) return null;
  const i = r[0], s = r[r.length - 1];
  if (t <= i.left) return i.before;
  if (t >= s.right) return s.after;
  for (const [l, c] of r.entries()) {
    if (t < c.left) {
      const a = r[l - 1];
      return c.left - t < t - a.right ? c.before : a.after;
    }
    if (t <= c.right)
      return t < (c.left + c.right) / 2 ? c.before : c.after;
  }
  return s.after;
}, Df = (e, t) => {
  let n = null, o = Number.POSITIVE_INFINITY, r = null, i = Number.POSITIVE_INFINITY;
  for (const s of e) {
    if (t >= s.top && t <= s.bottom) {
      const c = Math.abs((s.top + s.bottom) / 2 - t);
      c < o && (o = c, n = s);
      continue;
    }
    const l = t < s.top ? s.top - t : t - s.bottom;
    l < i && (i = l, r = s);
  }
  return n ?? r;
}, Bf = (e, t, n) => {
  const o = e.ownerDocument, r = e.getBoundingClientRect(), i = [], s = e.querySelectorAll(H);
  for (const l of Array.from(s)) {
    const c = Number(l.dataset[Et]);
    if (!Number.isInteger(c)) continue;
    const a = n(l);
    if (a !== null) {
      const f = l.getBoundingClientRect();
      f.height > 0.5 && i.push(
        ..._f(a, {
          top: f.top - r.top,
          bottom: f.bottom - r.top,
          left: f.left - r.left,
          right: f.right - r.left
        })
      );
      continue;
    }
    let d = !1;
    const u = l.querySelectorAll(B);
    for (const f of Array.from(u)) {
      if (f.hasAttribute(at)) continue;
      const g = f.firstChild;
      if (!g || g.nodeType !== 3) continue;
      let b = 0;
      for (const p of $(g.textContent ?? "")) {
        const h = b, m = b + p.length;
        b = m;
        const k = o.createRange();
        k.setStart(g, h), k.setEnd(g, m);
        const E = k.getBoundingClientRect();
        if (E.width <= 0.5 || E.height <= 0.5) continue;
        const S = t(g, h), y = t(g, m);
        !S || !y || (i.push({
          top: E.top - r.top,
          bottom: E.bottom - r.top,
          span: {
            left: E.left - r.left,
            right: E.right - r.left,
            before: S,
            after: y
          }
        }), d = !0);
      }
    }
    if (!d) {
      const f = l.getBoundingClientRect();
      if (f.height <= 0.5) continue;
      const g = { blockIndex: c, offset: 0 };
      i.push({
        top: f.top - r.top,
        bottom: f.bottom - r.top,
        span: {
          left: f.left - r.left,
          right: f.right - r.left,
          before: g,
          after: g
        }
      });
    }
  }
  return Lf(i);
}, Mf = (e) => {
  const t = e.ownerDocument.defaultView;
  if (!t) return !1;
  for (let n = e; n; n = n.parentElement) {
    const o = t.getComputedStyle(n).transform;
    if (!o || o === "none") continue;
    const r = /^matrix(3d)?\((.+)\)$/.exec(o);
    if (!r) return !0;
    const i = r[2].split(",").map(Number), [s, l] = r[1] ? [i[1], i[4]] : [i[1], i[2]];
    if (Math.abs(s) > 1e-3 || Math.abs(l) > 1e-3) return !0;
  }
  return !1;
}, Be = {
  mode: "edit-inside-single-textbox",
  fieldModal: !1
}, Nf = "page", $f = {
  formatJustifyLeft: {
    kind: "set-block-style",
    delta: { textAlign: "start" }
  },
  formatJustifyCenter: {
    kind: "set-block-style",
    delta: { textAlign: "center" }
  },
  formatJustifyRight: {
    kind: "set-block-style",
    delta: { textAlign: "end" }
  },
  formatJustifyFull: {
    kind: "set-block-style",
    delta: { textAlign: "justify" }
  }
}, Me = {
  formatBold: { on: { fontWeight: "700" }, off: { fontWeight: "400" } },
  formatItalic: { on: { fontStyle: "italic" }, off: { fontStyle: "normal" } },
  formatUnderline: {
    on: { textDecoration: "underline" },
    off: { textDecoration: "none" }
  },
  formatStrikeThrough: {
    on: { textDecoration: "line-through" },
    off: { textDecoration: "none" }
  },
  formatStrikethrough: {
    on: { textDecoration: "line-through" },
    off: { textDecoration: "none" }
  }
}, Kr = {
  deleteWordBackward: { direction: "backward", granularity: "word" },
  deleteWordForward: { direction: "forward", granularity: "word" },
  deleteSoftLineBackward: {
    direction: "backward",
    granularity: "lineboundary"
  },
  deleteSoftLineForward: { direction: "forward", granularity: "lineboundary" }
}, zf = /* @__PURE__ */ new Set([
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "End",
  "PageUp",
  "PageDown"
]), jr = (e) => {
  if (!(e.ctrlKey || e.metaKey)) return null;
  const t = e.key.toLowerCase();
  return t === "z" ? e.shiftKey ? "historyRedo" : "historyUndo" : t === "y" ? "historyRedo" : null;
}, Hf = (e) => ({
  kind: "paragraph",
  authoredContainerId: Lt(e, `${e.boxId}:b0`),
  runs: []
}), Wf = (e) => e.blocks.length > 0 ? e : { ...e, blocks: [Hf(e)] }, On = (e, t) => {
  var n;
  return ((n = e.blocks[t]) == null ? void 0 : n.authoredContainerId) ?? `${e.boxId}:${t}`;
}, Kf = [
  de,
  Ve,
  Ue
], jf = /* @__PURE__ */ new Set([...Xc, "contenteditable"]), Gr = (e, t) => {
  for (const n of Array.from(t.attributes))
    e.getAttribute(n.name) !== n.value && e.setAttribute(n.name, n.value);
  for (const n of Array.from(e.attributes))
    jf.has(n.name) || t.hasAttribute(n.name) || e.removeAttribute(n.name);
}, Vr = (e) => {
  var t;
  return ((t = e.dataset) == null ? void 0 : t[ue]) === "field" || e.getAttribute(kt) === "field";
}, Ur = (e) => {
  var t;
  return ((t = e.dataset) == null ? void 0 : t[rt]) !== void 0 || e.hasAttribute(at);
}, Gf = (e, t) => {
  if (globalThis.__editorDisableMorph)
    return !1;
  const n = e.ownerDocument.createElement("template");
  n.innerHTML = t;
  const o = e.querySelectorAll(
    H
  ), r = n.content.querySelectorAll(
    H
  );
  if (o.length !== r.length || o.length === 0 || e.childElementCount !== o.length) return !1;
  for (let i = 0; i < o.length; i += 1) {
    for (const c of Kf)
      if (o[i].classList.contains(c) !== r[i].classList.contains(c))
        return !1;
    const s = o[i].querySelectorAll(
      B
    ), l = r[i].querySelectorAll(
      B
    );
    if (s.length !== l.length) return !1;
    for (let c = 0; c < s.length; c += 1) {
      const a = s[c], d = l[c];
      if (a.tagName !== d.tagName || Ur(a) !== Ur(d) || Vr(a) && (a.textContent ?? "") !== (d.textContent ?? ""))
        return !1;
    }
  }
  for (let i = 0; i < o.length; i += 1) {
    Gr(o[i], r[i]);
    const s = o[i].querySelectorAll(
      B
    ), l = r[i].querySelectorAll(
      B
    );
    for (let c = 0; c < s.length; c += 1) {
      const a = s[c], d = l[c];
      if (Gr(a, d), !Vr(a)) {
        const u = d.textContent ?? "", f = a.firstChild;
        f && f.nodeType === 3 ? f.data !== u && (f.data = u) : (a.textContent ?? "") !== u && (a.textContent = u);
      }
    }
  }
  return !0;
}, Vf = "script, style, iframe, embed, object, noscript, template, link, meta, title, head", Uf = /* @__PURE__ */ new Set([
  "P",
  "DIV",
  "LI",
  "TR",
  "H1",
  "H2",
  "H3",
  "H4",
  "H5",
  "H6",
  "BLOCKQUOTE",
  "PRE",
  "UL",
  "OL",
  "TABLE",
  "SECTION",
  "ARTICLE",
  "HEADER",
  "FOOTER"
]), Yf = /* @__PURE__ */ new Set([
  "PRE",
  "TEXTAREA",
  "LISTING",
  "PLAINTEXT",
  "XMP"
]), Yr = /* @__PURE__ */ new Map([
  ["normal", "collapse"],
  ["nowrap", "collapse"],
  ["collapse", "collapse"],
  ["pre", "preserve"],
  ["pre-wrap", "preserve"],
  ["break-spaces", "preserve"],
  ["preserve", "preserve"],
  ["pre-line", "preserve-breaks"],
  ["preserve-breaks", "preserve-breaks"]
]), qf = /[ \t\n\r\f]/, Xf = /^[ \t\n\r\f]/, Jf = /\r\n|\r|\n/, Zf = /^\s*$/, Qf = (e) => {
  const t = e.getAttribute("style");
  if (!t) return;
  let n;
  for (const o of t.split(";")) {
    const r = o.indexOf(":");
    if (r < 0) continue;
    const i = o.slice(0, r).trim().toLowerCase();
    if (i !== "white-space" && i !== "white-space-collapse")
      continue;
    const s = o.slice(r + 1).replace(/!important/i, "").trim().toLowerCase().split(/\s+/).find((l) => Yr.has(l));
    s && (n = Yr.get(s));
  }
  return n;
}, th = (e, t) => Qf(e) ?? (Yf.has(e.tagName) || e.classList.contains(Ht) ? "preserve" : t), qr = "<!--StartFragment-->", eh = "<!--EndFragment-->", nh = /^<meta charset=['"]?utf-8['"]?>/i, oh = (e) => {
  const t = e.indexOf(qr), n = e.lastIndexOf(eh);
  return t >= 0 && n > t ? e.slice(t + qr.length, n) : e.replace(nh, "");
};
class rh {
  /**
   * `leadingSpace`: the fragment starts with whitespace. The HTML parser
   * drops whitespace that comes before the body, so it never reaches the
   * walk; it is carried in here as the fragment's leading edge.
   */
  constructor(t) {
    x(this, "text", "");
    x(this, "line", "");
    x(this, "pendingSpace", !1);
    /** The open line holds text a preformatted element kept as written. */
    x(this, "lineKept", !1);
    /** Nothing of the fragment has landed yet: a space here is its edge. */
    x(this, "atFragmentStart", !0);
    x(this, "ended", 0);
    /** For each block the walk is inside, the lines ended when it opened. */
    x(this, "blockStarts", []);
    this.pendingSpace = t;
  }
  append(t, n) {
    if (n === "collapse") {
      this.appendCollapsed(t);
      return;
    }
    t.split(Jf).forEach((o, r) => {
      r > 0 && this.endLine(), n === "preserve-breaks" ? this.appendCollapsed(o) : o !== "" && (this.put(o), this.lineKept = !0);
    });
  }
  /** A `<br>` or a kept newline: ends the line, an empty one included. */
  endLine() {
    this.text += `${this.lineText(this.line)}
`, this.line = "", this.pendingSpace = !1, this.lineKept = !1, this.atFragmentStart = !1, this.ended += 1;
  }
  /** A block opens: the line ends if anything is on it. */
  openBlock() {
    this.endOpenLine(), this.atFragmentStart = !1, this.blockStarts.push(this.ended);
  }
  /**
   * A block closes: the line ends if anything is on it, and a block that
   * ended no line at all still takes one, as TinyMCE's `<p></p>` blank line
   * does.
   */
  closeBlock() {
    const t = this.blockStarts.pop();
    this.line === "" && this.ended === t ? this.endLine() : this.endOpenLine();
  }
  /**
   * The lines, the last one keeping the space the fragment ends on: a
   * fragment copied from partway through a paragraph lands partway through
   * one, where the spaces at its edges still separate words.
   */
  result() {
    return this.text + this.lineText(this.line + (this.pendingSpace ? " " : ""));
  }
  /**
   * A line holding only whitespace lands empty unless a preformatted element
   * kept it: Word and many editors hold an empty paragraph open with a
   * no-break space, and it is a blank line.
   */
  lineText(t) {
    return !this.lineKept && Zf.test(t) ? "" : t;
  }
  endOpenLine() {
    this.line !== "" && this.endLine(), this.pendingSpace = !1;
  }
  appendCollapsed(t) {
    for (const n of t)
      qf.test(n) ? (this.line !== "" || this.atFragmentStart) && (this.pendingSpace = !0) : this.put(n);
  }
  put(t) {
    this.pendingSpace && (this.line += " "), this.pendingSpace = !1, this.atFragmentStart = !1, this.line += t;
  }
}
const ml = (e, t, n) => {
  if (e.nodeType === Node.TEXT_NODE) {
    n.append(e.nodeValue ?? "", t);
    return;
  }
  if (e.nodeType !== Node.ELEMENT_NODE) return;
  const o = e;
  if (o.tagName === "BR") {
    n.endLine();
    return;
  }
  const r = th(o, t), i = Uf.has(o.tagName);
  i && n.openBlock();
  for (const s of o.childNodes) ml(s, r, n);
  i && n.closeBlock();
}, Xr = (e) => {
  const t = e.html ?? "";
  if (t.trim()) {
    const n = oh(t), o = new DOMParser().parseFromString(n, "text/html");
    o.querySelectorAll(Vf).forEach((s) => s.remove());
    const r = new rh(
      Xf.test(n)
    );
    o.body && ml(o.body, "collapse", r);
    const i = rn(r.result()).replace(/\n+$/, "");
    if (i) return i;
  }
  return rn(e.text ?? "").replace(/\n+$/, "");
}, rn = (e) => {
  let t = "";
  for (const n of e.replace(/\r\n?/g, `
`)) {
    const o = n.codePointAt(0) ?? 0, r = zl(o);
    if (r === "forbidden" || r === "artifact") continue;
    const i = Hl(o);
    if (i !== void 0 && i !== o) {
      t += String.fromCodePoint(i);
      continue;
    }
    t += n;
  }
  return t;
}, ih = /* @__PURE__ */ new Set([
  "split-block",
  "blur-into-styling-chrome",
  "paste"
]), Jr = (e, t) => {
  var n;
  return e !== void 0 && w(e.kind) ? 0 : ((n = Yi(e, t)) == null ? void 0 : n.runIndex) ?? ((e == null ? void 0 : e.runs.length) ?? 0) - 1;
}, sh = (e, t, n) => Pt([
  ...ke(e, n),
  be(
    wt(t.styling, n.refs),
    n.refs
  )
]);
class lh {
  constructor(t) {
    x(this, "ctx");
    x(this, "armedStyle", null);
    x(this, "emptied", null);
    this.ctx = t;
  }
  get armed() {
    return this.armedStyle;
  }
  merge(t) {
    this.armedStyle = Z(
      this.armedStyle ?? void 0,
      t
    );
  }
  onSeal(t) {
    return ih.has(t) || this.armedStyle === null ? !1 : (this.armedStyle = null, !0);
  }
  takeForInsert(t) {
    const n = this.emptied;
    !t.replacing && t.blockWasEmpty && n && n.containerId === t.containerId && (this.armedStyle = Z(
      n.style,
      this.armedStyle ?? {}
    ));
    const o = this.armedStyle;
    return this.armedStyle = null, o;
  }
  rememberEmptied(t, n) {
    this.emptied = { style: t, containerId: n };
  }
  /**
   * A style set on an empty box is the box's own, and what the next
   * keystroke carries takes it too: the memory of the run the block was
   * emptied of, and an armed style, both fold the delta in. Without this a
   * size typed into the field of an emptied box followed the frame down to
   * the new caret and the first character still landed at the erased
   * text's size, which the memory carried over the box's own.
   */
  followEmptyBoxStyle(t) {
    this.emptied !== null && (this.emptied = {
      ...this.emptied,
      style: Z(this.emptied.style, t)
    }), this.armedStyle !== null && (this.armedStyle = Z(this.armedStyle, t));
  }
  /**
   * The box's sizes were written or baked × ratio: the style the next
   * keystroke carries, armed or remembered from an emptied block, moves
   * with them, so the character lands at the strut the caret shows.
   */
  /**
   * The armed style and the emptied-run memory as they stand. The fold of a
   * held fit residual into the authored sizes scales both (`scaleLengths`),
   * and that fold rides the author's own edit step, so an undo of that step
   * must put them back or the next character lands at the size the box had
   * before the fold and is folded a second time.
   */
  snapshot() {
    return { armedStyle: this.armedStyle, emptied: this.emptied };
  }
  restore(t) {
    this.armedStyle = t.armedStyle, this.emptied = t.emptied;
  }
  scaleLengths(t) {
    this.armedStyle !== null && (this.armedStyle = Ir(
      this.armedStyle,
      t
    )), this.emptied !== null && (this.emptied = {
      ...this.emptied,
      style: Ir(this.emptied.style, t)
    });
  }
  armedLayer() {
    return this.armedStyle === null ? {} : be(
      this.armedStyle,
      this.ctx.context().refs
    );
  }
  resolvedAt(t) {
    const n = this.ctx.box(), o = this.ctx.context(), r = n.blocks[t.blockIndex];
    if (r === void 0) return {};
    const i = r.runs[Jr(r, t.offset)];
    return i !== void 0 ? sh(r, i, o) : Ia(r, o);
  }
  effectiveAt(t) {
    return { ...this.resolvedAt(t), ...this.armedLayer() };
  }
  carriedAt(t) {
    const n = this.ctx.box(), o = this.ctx.context().refs, r = n.blocks[t.blockIndex], i = r == null ? void 0 : r.runs[Jr(r, t.offset)], s = wt(i !== void 0 ? i.styling : r == null ? void 0 : r.characterStyling, o);
    return this.armedStyle === null ? { ...s ?? {} } : Z(s, this.armedStyle);
  }
}
const Zr = "editor-text-box-resolved", Qr = /* @__PURE__ */ new WeakMap(), ch = (e) => e ?? (typeof document < "u" ? document : null), ah = (e) => "cssRules" in e && e.name === dn, dh = (e) => {
  let t = e.getElementById(Zr);
  const n = Qr.get(e);
  if (n && (t != null && t.sheet) && t.isConnected) return n;
  if (!t) {
    if (!e.head) return null;
    t = e.createElement("style"), t.id = Zr, t.setAttribute(Zc, ""), t.textContent = `${vi}@layer ${dn}{}`, e.head.appendChild(t);
  }
  const o = t.sheet;
  if (!o) return null;
  const r = Array.from(o.cssRules).find(ah) ?? o, i = /* @__PURE__ */ new Set();
  for (const l of Array.from(r.cssRules))
    "selectorText" in l && i.add(String(l.selectorText).replace(/^\./, ""));
  const s = { container: r, known: i };
  return Qr.set(e, s), s;
}, bl = (e, t) => {
  const n = ch(t);
  if (!n) return;
  const o = dh(n);
  if (o)
    for (const { name: r, decls: i } of e)
      o.known.has(r) || (o.container.insertRule(
        `.${r}{${i}}`,
        o.container.cssRules.length
      ), o.known.add(r));
}, uh = /* @__PURE__ */ new Set([
  "nw",
  "ne",
  "sw",
  "se"
]), ap = (e) => e != null && uh.has(e), ti = (e) => e === "grow", fh = 3, hh = 0.1, ei = { asTyped: !0 }, ph = (e) => {
  var n;
  const t = ((n = e == null ? void 0 : e.userAgentData) == null ? void 0 : n.platform) ?? (e == null ? void 0 : e.platform) ?? "";
  return /mac/i.test(t);
}, gh = (e, t) => {
  const n = e.getBoundingClientRect(), o = fl(n.height, e.offsetHeight);
  return o <= 0 ? null : t <= n.top + o ? "before" : t >= n.bottom - o ? "after" : null;
}, sn = class sn {
  constructor(t, n, o) {
    x(this, "box");
    x(this, "stack", Ya);
    /**
     * The id of the empty line the mount appended as the caret's home, null
     * when it appended none. That line stays the host's while it is empty and
     * last, even after the rule before it is removed: the fit leaves it out
     * and leaving the box drops it (`isEditorCaretHome`).
     */
    x(this, "caretHomeId", null);
    x(this, "el");
    /** The box class the element carries, swapped by every paint (`applyBoxLayout`). */
    x(this, "boxClassName", null);
    x(this, "anchor");
    x(this, "revision");
    x(this, "context");
    x(this, "mounted", !1);
    x(this, "fitter");
    x(this, "drag", null);
    /** The animation frame a pill drag's paint-only fit is waiting on. */
    x(this, "dragFitFrame", null);
    x(this, "pendingRefill", null);
    /**
     * How many writes are on the stack: a write repaints, the repaint fits,
     * and that fit may write again when the paint at the written sizes
     * measures differently from the search's trial (the ink reserve and the
     * struts are re-read at the new base sizes, and a line can round a px
     * taller). Every pass moves the sizes onto what the paint needs, so the
     * chain converges in one or two; the cap ends it if it ever would not.
     */
    x(this, "writeDepth", 0);
    /**
     * How deep a gesture of the person's own is: their content entry, a style
     * or size command, a paste, a drop, a handle release, a width or height
     * from the drawer. Only inside one may a fit fold its scale into the
     * authored sizes, and only inside one may it settle the frame. Mounting, an
     * undo, a refill, the caret's own remetering, a resize the page echoed
     * back and a face that arrives with no author edit pending all paint the
     * fit and hold its residual instead, so a box nobody has edited keeps the
     * sizes and the frame its row holds (docs/lotus/sizing.md, "The write").
     */
    x(this, "writesAllowed", 0);
    /**
     * True from a fold until a fit measures the text at the folded sizes. The
     * fitter's scale still describes the paint, but the residual it carried is
     * already in the authored sizes, so a gesture that runs before that fit
     * folds nothing more: the insert after a range delete that did not
     * repaint, or a composition's text after the delete at its start, would
     * otherwise scale the sizes by the same residual twice.
     */
    x(this, "residualFolded", !1);
    /**
     * True from a fold until the next render. The paint still carries the
     * sizes from before the fold, and the fitter reads its bases off the
     * paint, so a fit of it measures text the box no longer holds: a handle
     * drag's fit leaves the fold marked, and `fitToBox` renders first.
     */
    x(this, "paintPredatesFold", !1);
    /**
     * The floor the frame settles onto: the height the box was entered at, and
     * after that whatever height the person's own hand set — a pill or corner
     * release, a width or a height from the drawer. Their editing gestures
     * carry the frame between this floor and the height their text needs, and
     * nothing takes it below (docs/lotus/sizing.md, "Events"). Undo and redo
     * take it down with them: the frame a step restores is the floor the next
     * edit settles from (`performHistory`).
     */
    x(this, "frameFloorPx", 0);
    /**
     * The handle a release just let go of, until the settle that follows the
     * release has run: that settle can raise the frame to the lines the
     * released width wraps, and the page hears which edge the raise anchors
     * to (`onFrameChange`), so a box narrowed by a north handle keeps its
     * bottom edge. Null outside that window; a new gesture on the frame
     * clears it.
     */
    x(this, "releaseAnchor", null);
    x(this, "resizeObserver", null);
    x(this, "uninstallFontRefit", null);
    /** The rule the next face arrival refits under; null while every face is settled. */
    x(this, "faceArrivalRule", null);
    /** The settle the box's own loading faces are awaited by; null while none is. */
    x(this, "boxFacesSettling", null);
    x(this, "format");
    x(this, "caretMap");
    x(this, "listener", (t) => this.handleBeforeInput(t));
    x(this, "pasteListener", (t) => this.handlePaste(t));
    x(this, "dragStartListener", (t) => this.handleDragStart(t));
    x(this, "dragOverListener", (t) => this.handleDragOver(t));
    x(this, "dropListener", (t) => this.handleDrop(t));
    x(this, "dragEndListener", () => {
      this.dragSource = null, this.endPointerTrail(), this.pointerDown = !1, this.pointerClient = null, this.dragOriginField = null;
    });
    x(this, "dragSource", null);
    x(this, "blurListener", (t) => {
      var r, i;
      const n = t.relatedTarget, o = n instanceof Element && ((i = (r = this.hooks) == null ? void 0 : r.isStylingChrome) == null ? void 0 : i.call(r, n)) === !0;
      if (!o) {
        const s = rd(
          this.box,
          this.caretHomeId
        );
        if (s) {
          const l = { blockIndex: 0, offset: 0 }, c = ee(s, this.stack, {
            selectionBefore: this.caretSelection(l),
            selectionAfter: this.caretSelection(l)
          });
          this.box = c.box, this.stack = c.stack, this.render("hold");
        }
      }
      this.seal(o ? "blur-into-styling-chrome" : "blur"), this.tableHighlight.sync(), this.syncCaretColor();
    });
    x(this, "focusListener", () => {
      this.tableHighlight.sync(), this.syncCaretColor();
    });
    x(this, "cutListener", (t) => this.handleCut(t));
    x(this, "pointerListener", (t) => {
      this.seal("pointer");
      const n = t;
      n.isPrimary && n.button === 0 && (this.pointerDown = !0, this.pointerClient = { x: n.clientX, y: n.clientY }, this.dragOriginField = this.fieldSpanAtClientPoint(n.clientX, n.clientY), this.beginPointerTrail(n));
    });
    x(this, "pointerMoveListener", (t) => {
      const n = t;
      !this.pointerDown || (n.buttons & 1) === 0 || (this.pointerClient = { x: n.clientX, y: n.clientY }, !this.extendSelectionFromField(n) && (this.followPointer(), this.enforceFieldCover()));
    });
    x(this, "pointerUpListener", (t) => {
      t.isPrimary && (this.endPointerTrail(), this.pointerDown = !1, this.pointerClient = null, this.dragOriginField = null, this.fieldPress = null);
    });
    x(this, "pointerDown", !1);
    x(this, "pointerClient", null);
    x(this, "dragOriginField", null);
    /**
     * The primary press in progress, from pointerdown to release. The
     * browser extends a selection drag itself, and it does so wrongly once
     * the pointer is over an element whose transform chain differs from the
     * box's — the page's zoom, the chrome's inverse scale, the item's own
     * translate, a turned frame — because it maps that point through layout
     * coordinates, transforms ignored; and it repeats that extension every
     * animation frame while the button is down, since the canvas scrolls and
     * a selection drag arms autoscroll. Preventing the press would cost the
     * caret's native placement and the drag of a selection, and no listener
     * can veto the extension, so while the pointer is outside the box the
     * host reads the point through the painted glyphs instead and asserts
     * that focus every frame, after the browser's and before the paint.
     * `ownsFocus` is decided by the mousedown that follows the press; `lines`
     * are box-relative, so a canvas the autoscroll moves needs one rect read
     * per frame, not a new measurement.
     */
    x(this, "trail", null);
    /**
     * A primary press that began on a field's body, with where it began: the
     * host owns that gesture, since the browser would either drag the field
     * (when it is selected) or start a selection it cannot anchor inside the
     * field. Moved past the slop, it selects from the field outward.
     */
    x(this, "fieldPress", null);
    x(this, "coveringFields", !1);
    x(this, "mousedownListener", (t) => this.handleMousedown(t));
    x(this, "clickListener", (t) => this.handleClick(t));
    x(this, "fieldHighlight");
    x(this, "ruleHighlight");
    x(this, "tableHighlight");
    x(this, "keydownListener", (t) => this.handleKeydown(t));
    x(this, "lastPrintableKey", null);
    x(this, "recentPrintableKey", null);
    x(this, "keyupListener", () => {
      this.lastPrintableKey !== null && (this.recentPrintableKey = {
        key: this.lastPrintableKey,
        until: Date.now() + sn.PRINTABLE_EVIDENCE_TAIL_MS
      }), this.lastPrintableKey = null;
    });
    x(this, "inputListener", (t) => {
      if (this.composing) return;
      const n = t.inputType ?? "";
      n === "insertCompositionText" || n === "insertFromComposition" || this.scheduleModelReheal();
    });
    x(this, "rehealPending", !1);
    x(this, "selectionListener", () => this.handleSelectionChange());
    x(this, "composing", !1);
    x(this, "composeAnchor", { blockIndex: 0, offset: 0 });
    x(this, "composeReplaced", !1);
    /**
     * The history step that opened a line at a table for a composition
     * (`openLineForComposition`), so the composed text joins it: one undo
     * takes back the line and its text together.
     */
    x(this, "composeLineStep", null);
    x(this, "compStartListener", () => this.handleCompositionStart());
    x(this, "compEndListener", (t) => this.handleCompositionEnd(t));
    x(this, "projectionIndex", null);
    x(this, "hooks");
    this.el = t, this.fitter = new Vo(t, { verifyInkContainment: !0 }), this.anchor = n.anchor, this.revision = n.revision, this.context = n.context, this.caretMap = new Jd(
      t,
      () => this.box,
      () => this.projectionIndex ?? qi(this.box, this.context, ei)
    ), this.fieldHighlight = new If({
      el: t,
      box: () => this.box,
      blockElement: (r) => this.caretMap.blockElement(r),
      readSelection: () => this.getModelSelection()
    }), this.ruleHighlight = new Ff({
      el: t,
      box: () => this.box,
      blockElement: (r) => this.caretMap.blockElement(r),
      readSelection: () => this.getModelSelection()
    }), this.tableHighlight = new Pf({
      el: t,
      box: () => this.box,
      blockElement: (r) => this.caretMap.blockElement(r),
      readSelection: () => this.getModelSelection(),
      hasFocus: () => this.el.ownerDocument.activeElement === this.el
    }), this.format = new lh({
      box: () => this.box,
      context: () => this.context
    }), this.box = Wf(n.box), this.hooks = o;
  }
  printableEvidence() {
    if (this.lastPrintableKey !== null) return this.lastPrintableKey;
    const t = this.recentPrintableKey;
    return t !== null && Date.now() <= t.until ? t.key : null;
  }
  get model() {
    return this.box;
  }
  get documentContext() {
    return this.context;
  }
  source() {
    return {
      anchor: this.anchor,
      revision: this.revision,
      box: this.box,
      context: this.context
    };
  }
  resolved() {
    const t = this.box.blocks.map(
      (n) => ({
        paintedRunText: n.kind === "paragraph" ? Vt(n.runs, this.context).map(
          (o) => o.kind === "literal" ? o.text : o.resolvedText ?? ""
        ) : []
      })
    );
    return ki(this.source(), t).resolved;
  }
  /**
   * The frame as the page holds it, outside any handle drag: a settled frame
   * echoing back, or a width or height typed into the drawer, which fits like
   * the matching pill release.
   */
  setInternalRect(t, n) {
    t === this.box.width && n === this.box.height || (this.box = { ...this.box, width: t, height: n }, this.releaseAnchor = null, !(!this.mounted || this.drag !== null) && (this.applyFrameToElement(t, n), this.frameFloorPx = n, this.allowingWrites(() => {
      this.foldResidual() ? this.rerenderKeepingSelection("grow") : this.fitToBox("grow");
    }), this.frameFloorPx = this.box.height));
  }
  beginResize(t) {
    var n, o;
    this.drag === null && (this.releaseAnchor = null, this.drag = {
      handle: t,
      startWidth: this.box.width,
      startHeight: this.box.height,
      cornerScale: 1,
      width: this.box.width,
      height: this.box.height,
      heldHeight: this.box.height,
      paintScale: Math.min(this.fitter.scale, 1)
    }, this.mounted && (this.fitter.holdForDrag(), (o = (n = this.hooks) == null ? void 0 : n.onDragStateChange) == null || o.call(n, !0)));
  }
  /**
   * The frame follows the pointer. With text scaling on, a corner scale
   * previews authored × k and a pill fits the text into the moving frame on
   * the paint, once per animation frame, so what is under the pointer is
   * what the release writes — the model's sizes stay as they are until
   * then. With it off every handle is a frame resize: the fit once per
   * animation frame keeps the paint's scale, measures the height the text
   * needs at the handed width, and stands the frame at the larger of the
   * handle's own height and that need (`settleHeldFrame`).
   */
  resizeTo(t, n) {
    const o = this.drag;
    if (o === null) {
      this.setInternalRect(t, n);
      return;
    }
    o.width = t, o.height = n, o.heldHeight = n, this.mounted && this.applyFrameToElement(t, n), this.mounted && this.scheduleDragFit();
  }
  scheduleDragFit() {
    if (this.dragFitFrame !== null) return;
    const t = this.el.ownerDocument.defaultView;
    t && (this.dragFitFrame = t.requestAnimationFrame(() => {
      this.dragFitFrame = null;
      const n = this.drag;
      if (!this.mounted || n === null || this.composing) return;
      const o = this.fitBox({
        growth: Ln(this.el),
        sizing: this.textSizing(),
        overrides: { ceiling: n.paintScale }
      });
      this.settleHeldFrame(n, o.paintedHeightPx);
    }));
  }
  /**
   * A held handle never takes the frame under the text, and gives the room
   * back once the text no longer needs it: the element stands at the larger
   * of the handle's own height — the handed height for a corner or a top or
   * bottom pill, the drag-start height for a side pill — and the height the
   * paint needs at the handed width, and the page hears every move. So a
   * pill stops at the text, a narrowing that wraps a line taller raises the
   * frame by that line, and widening back brings it down to the handle's own
   * height and no lower. The one px the fit tolerates is tolerated here too.
   */
  settleHeldFrame(t, n) {
    var r, i;
    const o = kf({
      ownPx: t.handle === "e" || t.handle === "w" ? t.startHeight : t.height,
      paintedHeightPx: n,
      followsText: Ln(this.el)
    });
    o === null || o === t.heldHeight || (t.heldHeight = o, this.applyFrameToElement(t.width, o), (i = (r = this.hooks) == null ? void 0 : r.onFrameChange) == null || i.call(r, t.width, o));
  }
  /** The box's text sizing as its row holds it, handed to every fit. */
  textSizing() {
    return Pa(this.box);
  }
  cancelDragFit() {
    var t;
    this.dragFitFrame !== null && ((t = this.el.ownerDocument.defaultView) == null || t.cancelAnimationFrame(this.dragFitFrame), this.dragFitFrame = null);
  }
  /**
   * The release: the frame is fixed at the dragged size and that size becomes
   * the floor the person's later edits settle onto, a case field or cascade
   * change that arrived during the drag lands, and one full fit runs. With
   * text scaling on, a corner scale bakes its factor into every authored
   * size and the fit scales the text into the released frame. With it off
   * the scale the paint held folds into the sizes, so the text keeps the
   * size it was painted at, and the fit settles the frame onto the larger of
   * the released height and the text's, which is then the floor.
   */
  endResize(t, n) {
    var i, s;
    const o = this.drag;
    if (o === null) {
      this.setInternalRect(t, n);
      return;
    }
    if (this.drag = null, this.cancelDragFit(), this.box, this.box = { ...this.box, width: t, height: n }, this.frameFloorPx = n, this.mounted && this.applyFrameToElement(t, n), !this.mounted) return;
    (s = (i = this.hooks) == null ? void 0 : i.onDragStateChange) == null || s.call(i, !1), this.allowingWrites(() => {
      this.foldResidual(), this.releaseAnchor = o.handle;
    });
    const r = this.pendingRefill;
    this.pendingRefill = null, r !== null && r(), this.allowingWrites(() => {
      r !== null ? this.fitToBox("grow") : this.rerenderKeepingSelection("grow"), this.frameFloorPx = this.box.height;
    });
  }
  /**
   * What a corner release may bake. The frame scales by the pointer's whole
   * factor — it is the person's hand — but on a Fill text box with a maximum
   * the authored sizes are clamped so the largest stays at or under it,
   * rather than baked past the maximum and shrunk straight back by the fit
   * that follows: a gesture meant to enlarge the box would otherwise leave
   * the row holding sizes above its own cap. Air results, honestly.
   */
  cornerBakeRatio(t) {
    const n = this.authoredBasesPt();
    if (t > 1) {
      const r = this.textSizing();
      if (r.mode !== "fill" || r.maxFontSizePt === null) return t;
      const i = Ji(r, n);
      return Number.isFinite(i) ? Math.min(t, Math.max(i, 1)) : t;
    }
    const o = La(n);
    return o > 0 ? Math.max(t, Math.min(o, 1)) : t;
  }
  /** Every authored size the box carries, the struts of empty blocks included. */
  authoredBasesPt() {
    return this.resolved().blocks.flatMap(
      (t) => t.runs.length === 0 ? [t.style.fontSizePt] : t.runs.map((n) => n.style.fontSizePt)
    ).filter((t) => typeof t == "number");
  }
  rerenderKeepingSelection(t) {
    let n = null;
    try {
      n = this.getModelSelection();
    } catch {
      n = null;
    }
    this.render(t), this.restoreSelection(n ?? void 0);
  }
  setCaseData(t) {
    if (t === this.context.caseData) return;
    if (this.drag !== null) {
      this.pendingRefill = () => this.setCaseData(t);
      return;
    }
    if (this.context = { ...this.context, caseData: t }, !this.mounted || this.composing) return;
    this.seal("external-refill");
    const n = this.getModelPosition(), o = this.box.blocks;
    this.settleFieldLines();
    const r = n === null ? null : {
      blockIndex: n.blockIndex,
      offset: Ad(
        o[n.blockIndex],
        this.box.blocks[n.blockIndex],
        n.offset
      )
    };
    this.render("hold"), r !== null && this.placeCaretAtPos(r);
  }
  /**
   * A save that lands while the box is live moves the row past the revision
   * the mount was born with; the next commit must carry the new one or the
   * server refuses it as a conflict the user never caused.
   */
  setRevision(t) {
    this.revision = t;
  }
  settleFieldLines() {
    const t = Td(this.box, this.context);
    return t === this.box ? !1 : (this.box = t, !0);
  }
  sourceForSave() {
    return this.settleFieldLines() && this.mounted && !this.composing && this.render("hold"), this.source();
  }
  setContext(t) {
    this.context = t, this.repaintInPlace();
  }
  setLocale(t) {
    this.context = { ...this.context, locale: t ?? ui }, this.repaintInPlace();
  }
  /**
   * The box's text sizing, changed from outside the host while the box is
   * being edited: the app's sizing hook writes the box's draft (the
   * properties drawer's maximum field, shown only while text scaling is on,
   * shows on an entered box because it is still selected, and the armed e2e
   * probe writes
   * through the same hook) and hands both columns in here; without this the
   * host would keep fitting under the values it was mounted with and the
   * designer would see nothing happen.
   *
   * It changes what the fit is allowed to do and nothing else: the repaint
   * runs under `'hold'`, so no frame moves; no scale is folded into the
   * sizes and nothing is written; and it is not a history step, because
   * neither control is undoable — the drawer's width and height fields
   * record nothing either — while `performHistory` carries these two columns
   * across a step so an in-box undo cannot take them away.
   */
  setTextSizing(t, n) {
    const o = { ...this.box, sizing: t, maxFontSizePt: n };
    t == null && delete o.sizing, n == null && delete o.maxFontSizePt, !(o.sizing === this.box.sizing && o.maxFontSizePt === this.box.maxFontSizePt) && (this.box = o, this.repaintInPlace());
  }
  repaintInPlace() {
    if (!this.mounted || this.composing) return;
    if (this.drag !== null) {
      this.pendingRefill = () => this.repaintInPlace();
      return;
    }
    this.seal("external-refill");
    const t = this.getModelPosition();
    this.render("hold"), t !== null && this.placeCaretAtPos(t);
  }
  mount() {
    this.el.setAttribute("contenteditable", "true"), this.el.setAttribute("spellcheck", "false"), this.el.setAttribute("autocorrect", "off"), this.el.setAttribute("autocapitalize", "off"), this.el.setAttribute("writingsuggestions", "false"), this.el.setAttribute("translate", "no"), this.el.setAttribute("data-gramm", "false"), this.el.setAttribute("data-gramm_editor", "false"), this.el.setAttribute("data-enable-grammarly", "false"), this.el.style.whiteSpace = "pre-wrap", this.el.style.boxSizing = "border-box", this.el.style.outline = "none", this.el.addEventListener("beforeinput", this.listener), this.el.addEventListener("input", this.inputListener), this.el.addEventListener("keyup", this.keyupListener), this.el.addEventListener("paste", this.pasteListener), this.el.addEventListener("dragstart", this.dragStartListener), this.el.addEventListener("dragover", this.dragOverListener), this.el.addEventListener("drop", this.dropListener), this.el.addEventListener("dragend", this.dragEndListener), this.el.addEventListener("blur", this.blurListener), this.el.addEventListener("focus", this.focusListener), this.el.addEventListener("cut", this.cutListener), this.el.addEventListener("pointerdown", this.pointerListener), this.el.addEventListener("mousedown", this.mousedownListener), this.el.addEventListener("click", this.clickListener), this.el.addEventListener("keydown", this.keydownListener), this.el.ownerDocument.addEventListener("pointerup", this.pointerUpListener), this.el.ownerDocument.addEventListener(
      "pointercancel",
      this.pointerUpListener
    ), this.el.addEventListener("compositionstart", this.compStartListener), this.el.addEventListener("compositionend", this.compEndListener), this.el.ownerDocument.addEventListener(
      "selectionchange",
      this.selectionListener
    );
    const t = this.el.ownerDocument.defaultView;
    if (t && typeof t.ResizeObserver == "function" && (this.resizeObserver = new t.ResizeObserver(() => {
      !this.mounted || this.drag !== null || this.fitToBox("hold");
    }), this.resizeObserver.observe(this.el, { box: "border-box" })), this.uninstallFontRefit = df(
      this.el.ownerDocument,
      () => {
        this.faceArrivalRule !== null && this.refitForArrivedFaces();
      },
      this.el
    ), this.mounted = !0, this.frameFloorPx = this.box.height, us(this.box.blocks)) {
      const n = od(this.box), o = {
        blockIndex: this.box.blocks.length,
        offset: 0
      }, r = ee(n, this.stack, {
        selectionBefore: this.caretSelection(o),
        selectionAfter: this.caretSelection(o)
      });
      this.box = r.box, this.stack = r.stack, this.caretHomeId = this.box.blocks[o.blockIndex].authoredContainerId ?? null, this.seal("edit-boundary");
    }
    this.render("hold");
  }
  destroy() {
    var t, n;
    this.el.removeEventListener("beforeinput", this.listener), this.el.removeEventListener("input", this.inputListener), this.el.removeEventListener("keyup", this.keyupListener), this.el.removeEventListener("paste", this.pasteListener), this.el.removeEventListener("dragstart", this.dragStartListener), this.el.removeEventListener("dragover", this.dragOverListener), this.el.removeEventListener("drop", this.dropListener), this.el.removeEventListener("dragend", this.dragEndListener), this.el.removeEventListener("blur", this.blurListener), this.el.removeEventListener("focus", this.focusListener), this.el.removeEventListener("cut", this.cutListener), this.el.removeEventListener("pointerdown", this.pointerListener), this.el.removeEventListener("mousedown", this.mousedownListener), this.el.removeEventListener("click", this.clickListener), this.el.removeEventListener("keydown", this.keydownListener), this.el.ownerDocument.removeEventListener(
      "pointerup",
      this.pointerUpListener
    ), this.el.ownerDocument.removeEventListener(
      "pointercancel",
      this.pointerUpListener
    ), this.el.removeEventListener("compositionstart", this.compStartListener), this.el.removeEventListener("compositionend", this.compEndListener), this.el.ownerDocument.removeEventListener(
      "selectionchange",
      this.selectionListener
    ), (t = this.resizeObserver) == null || t.disconnect(), this.resizeObserver = null, this.endPointerTrail(!1), this.cancelDragFit(), (n = this.uninstallFontRefit) == null || n.call(this), this.uninstallFontRefit = null, this.boxFacesSettling = null, this.fitter.dispose(), this.tableHighlight.clear(), Ar(this.el), this.el.style.removeProperty(Ne), this.boxClassName !== null && this.el.classList.remove(this.boxClassName), this.boxClassName = null, this.mounted = !1;
  }
  scheduleModelReheal() {
    this.rehealPending || !this.mounted || (this.rehealPending = !0, setTimeout(() => {
      if (this.rehealPending = !1, !this.mounted || this.composing) return;
      let t = null;
      try {
        t = this.getModelSelection();
      } catch {
        t = null;
      }
      this.render("grow", !0), t !== null && this.placeRangeAtPos(t.anchor, t.focus);
    }, 0));
  }
  render(t, n = !1) {
    const o = this.resolved(), r = this.mounted ? this.caretMap.readPosition() : null;
    this.fieldHighlight.dropForRepaint(), this.ruleHighlight.dropForRepaint(), this.tableHighlight.dropForRepaint(), this.applyBoxLayout(o);
    const i = va(
      this.source(),
      ei
    );
    this.projectionIndex = i.index;
    const s = Ki(
      i.document.resolved,
      o.boxId,
      Nf,
      "editor"
    );
    Ar(this.el), (n || !Gf(this.el, s)) && (this.el.innerHTML = s), this.decorateEditorAffordances(), qd(
      this.box.blocks,
      (l) => this.caretMap.blockElement(l)
    ), this.markCaretHome(), this.injectResolvedSheet(o, i.document.resolved), this.trail && (this.trail.lines = null), r !== null && this.paintArmedShapeOnFiller(r), this.paintPredatesFold = !1, this.fitToBox(t);
  }
  /**
   * The caret's home, marked for the fit to leave out: the empty paragraph
   * the mount appends to a box whose own blocks are all atomic and end in a
   * rule, so the rule has a line after it the caret can stand on. It is the
   * host's line and not the person's, and a frame grown to hold it on a
   * double-click would be a frame move nobody asked for; the fit ignores it
   * until the first character makes it an ordinary block, and the frame
   * then settles on that line like it does on any other typing. It stays
   * the host's after the rule before it is removed, since the host knows it
   * by its id (`caretHomeId`); any other empty line after a table is one
   * the person made, since the table has a stop after it. The mark is
   * derived from the model and that id on every paint, through the test the
   * compact on leaving takes (`isEditorCaretHome`), so it comes off by
   * itself the moment the block holds a run, and it marks exactly the line
   * leaving drops.
   */
  markCaretHome() {
    const t = this.box.blocks.length - 1, n = fs(this.box.blocks, this.caretHomeId);
    for (let o = 0; o <= t; o += 1) {
      const r = this.caretMap.blockElement(o);
      r && (n && o === t ? r.setAttribute(Ye, "") : r.removeAttribute(Ye));
    }
  }
  /**
   * The caret's empty block is painted in the face and at the size the
   * next character takes, armed style included, before the fit measures
   * it: the fit reads the filler's face for its ink reserve and its size
   * for the strut, so a face or a size armed at the caret refits the box
   * the way typing it would, and the repaint a write makes keeps the armed
   * shape the emitter knows nothing of. True when a length or face moved.
   */
  paintArmedShapeOnFiller(t) {
    const n = this.caretMap.blockElement(t.blockIndex), o = (n == null ? void 0 : n.querySelector(`[${at}]`)) ?? null;
    if (!o) return !1;
    const r = this.format.effectiveAt(t);
    let i = !1;
    const s = r.fontSizePt;
    if (typeof s == "number" && Number.isFinite(s)) {
      const g = Number(o.dataset[It]);
      (!Number.isFinite(g) || Math.abs(g - s) > 0.01) && (i = !0), o.dataset[It] = String(s), o.style.fontSize = `${le(s, this.fitter.scale)}pt`;
    }
    const l = this.format.armed !== null, c = r.fontFamily, a = r.fontWeight, d = r.fontStyle, u = [
      l && typeof c == "string" ? Ge(c) : "",
      l && (typeof a == "number" || typeof a == "string") ? String(a) : "",
      l && typeof d == "string" ? d : ""
    ], f = o.style.fontFamily;
    return o.style.fontFamily = u[0], o.style.fontFamily !== f && (i = !0), o.style.fontWeight !== u[1] && (o.style.fontWeight = u[1], i = !0), o.style.fontStyle !== u[2] && (o.style.fontStyle = u[2], i = !0), i;
  }
  /**
   * The classes of every tree the render reads: the resolved box, and the
   * live paint's projection the spans are emitted from. A run's classes
   * follow its parts, which follow its text, and the two trees' texts can
   * differ while a field is edited.
   */
  injectResolvedSheet(...t) {
    bl(
      t.flatMap((n) => Fi(n)),
      this.el.ownerDocument
    );
  }
  /**
   * The model's frame on the element itself, before any fit reads it: the
   * page applies the same numbers on its next render, but a fit that ran
   * against the element's old size in between (undo restoring a frame, a
   * release) would write sizes for the wrong frame.
   */
  applyFrameToElement(t, n) {
    Number.isFinite(t) && t > 0 && (this.el.style.width = `${t}px`), Number.isFinite(n) && n > 0 && (this.el.style.height = `${n}px`);
  }
  applyBoxLayout(t) {
    this.applyFrameToElement(t.rect.width, t.rect.height);
    const n = t.padding;
    this.el.style.padding = n ? `${n.top}px ${n.right}px ${n.bottom}px ${n.left}px` : "0px", t.overflowWrap === "break-word" ? this.el.dataset[Qo] = "break-word" : delete this.el.dataset[Qo];
    const o = t.style;
    this.el.style.borderWidth = (o == null ? void 0 : o.borderWidth) !== void 0 ? `${o.borderWidth}pt` : "", this.el.style.borderStyle = (o == null ? void 0 : o.borderStyle) ?? "", this.el.style.borderColor = (o == null ? void 0 : o.borderColor) ?? "";
    const r = o ? lo(o) : null;
    this.boxClassName !== null && this.boxClassName !== (r == null ? void 0 : r.name) && this.el.classList.remove(this.boxClassName), this.boxClassName = (r == null ? void 0 : r.name) ?? null, this.boxClassName !== null && this.el.classList.add(this.boxClassName), delete this.el.dataset[G.top], delete this.el.dataset[G.bottom], delete this.el.dataset[G.left], delete this.el.dataset[G.right];
  }
  /**
   * The editing hooks on the painted runs: the run kind, the case field
   * key, and contenteditable off on fields and atomic blocks. The ghost of
   * an empty field and its marker come from the emitter, on every surface.
   */
  decorateEditorAffordances() {
    this.box.blocks.forEach((t, n) => {
      const o = this.caretMap.blockElement(n);
      if (!o) return;
      if (C(t.kind)) {
        if (o.contentEditable = "false", t.kind !== "literal_grid") return;
      } else
        o.removeAttribute("contenteditable");
      o.querySelectorAll(B).forEach((i) => {
        const s = Number(i.dataset[ct]), l = t.runs[s];
        if (l) {
          if (i.dataset[ue] = l.kind, l.kind !== "field") {
            i.removeAttribute("contenteditable"), delete i.dataset[er];
            return;
          }
          i.contentEditable = "false", i.dataset[er] = l.fieldKey;
        }
      });
    });
  }
  /**
   * Starts the box's face loads and says whether a face its text needs is
   * still loading. The first time one is, it waits on the box's own faces,
   * not the page's: the refit runs once they land or fail, or the settle's
   * time limit passes, even while other fonts of the page are still
   * downloading. One settle is awaited at a time; it re-reads the box's
   * faces as they land, so a face a later fit asks for is waited on by the
   * same settle or the next one. A face that never lands starts a new settle
   * after each one gives up, so the box refits once per
   * EDITOR_FONT_SETTLE_TIMEOUT_MS until the face lands or fails. A settle
   * whose faces a later fit has already measured (faceArrivalRule cleared,
   * as by the page's `loadingdone`) refits nothing more.
   */
  boxFacesPending() {
    if (this.boxFacesSettling !== null) return al(this.el);
    const t = ul(this.el);
    return t === null ? !1 : (this.boxFacesSettling = t, t.then(() => {
      this.boxFacesSettling === t && (this.boxFacesSettling = null, this.faceArrivalRule !== null && this.refitForArrivedFaces());
    }), !0);
  }
  /**
   * The refit a face's arrival owes the box. A face the author's own edit
   * asked for, landing late, finishes that edit: it settles the frame and
   * writes as the edit would have, had the face been ready. A face with no
   * edit of theirs pending is a load and holds both.
   */
  refitForArrivedFaces() {
    if (!this.mounted) return;
    const t = this.faceArrivalRule ?? "hold";
    ti(t) ? this.allowingWrites(() => this.fitToBox(t)) : this.fitToBox(t);
  }
  /**
   * The editing surface's fit. Under the grow rule the height the search
   * fits into is max(frame, text height) and the frame is then settled onto
   * max(floor, text height); under the hold rule the text is scaled into the
   * frame as it stands. Nothing fits here while a handle is
   * held (a held handle fits the paint through scheduleDragFit) or a
   * composition is open. A scale the fit finds is written into the authored
   * sizes, so what is painted is the authored size.
   */
  /**
   * A fit under a face still loading measures a fallback, so the refit the
   * face's arrival triggers is the one that finishes the gesture — and it
   * runs under the gesture's own rule. An author's edit that changed the
   * face (a family, a role, a paste) settles the frame when the face lands,
   * exactly as it would have had the face been ready; only a fit nothing
   * of the author's caused holds the frame. The rule is kept until every
   * face the box uses has settled, so a hold in between (a resize tick)
   * never demotes it. The settle waits for the face as well: a frame moved
   * to a fallback's wrap would be moved again the moment the real face
   * landed, while the shrunk paint of the pending fit lasts only until then.
   */
  fitToBox(t) {
    var s, l;
    const n = this.boxFacesPending();
    if (this.faceArrivalRule = n ? ti(t) ? t : this.faceArrivalRule ?? "hold" : null, this.composing || this.drag !== null) return;
    if (this.paintPredatesFold) {
      this.rerenderKeepingSelection(t);
      return;
    }
    const o = t === "grow" && this.writesAllowed > 0, r = o && Ln(this.el), i = this.fitBox({
      growth: r,
      sizing: this.textSizing()
    });
    xf(o, r, n) && (r && this.settleFrameToText(i.textHeightPx), this.releaseAnchor = null), !this.writeFitIntoSizes(i.scale) && ((l = (s = this.hooks) == null ? void 0 : s.onRefit) == null || l.call(s));
  }
  /**
   * The settle: while the person edits, the frame's height is the larger of
   * the floor and the height their text needs, and every gesture of theirs
   * puts it there — up when the text outgrows the frame, back down when a
   * deletion, a smaller size or a shorter style frees the room again, and
   * never under the floor. The page hears each move. The one CSS px the fit
   * tolerates is symmetric here: a write rounded onto the 0.1 pt grid leaves
   * the text within a px of the frame either way, and moving the frame for
   * that px would jitter it on every keystroke and on entry.
   */
  settleFrameToText(t) {
    if (t === null || !Number.isFinite(t) || t <= 0)
      return;
    const n = Math.max(this.frameFloorPx, Math.ceil(t - 1e-6));
    Math.abs(n - this.box.height) <= Eo || this.setFrameHeight(n);
  }
  setFrameHeight(t) {
    var n, o;
    this.box = { ...this.box, height: t }, this.applyFrameToElement(this.box.width, t), (o = (n = this.hooks) == null ? void 0 : n.onFrameChange) == null || o.call(
      n,
      this.box.width,
      t,
      this.releaseAnchor ?? void 0
    );
  }
  /**
   * The fit's scale becomes the authored sizes: every run × scale, the size
   * on the 0.1 pt grid and its tracking and outline with it, no undo step of
   * its own (undo restores an older text, and the fit that follows writes
   * the sizes that text needs), then a repaint at 1. The repaint's own fit
   * usually lands within the write threshold, or within the grace, and
   * writes nothing; when the paint at the written sizes overflows the frame
   * past the threshold — the ink reserve re-read at the new sizes can be a
   * px taller than the search's scaled one — it writes the shrink, up to
   * EDITOR_MAX_WRITE_PASSES deep, so the authored size is the size that
   * paints and no residual is left on the paint by a refused write. A fit
   * under a face still loading measured a fallback and writes nothing; the
   * refit the face's arrival triggers writes what the text needs. A fit
   * under a face that failed writes nothing either
   * (editorTextBoxFacesWriteSizes).
   */
  writeFitIntoSizes(t) {
    if (this.writesAllowed === 0 || this.writeDepth >= fh || !cr(t) || !$r(this.el)) return !1;
    const n = this.boxWithSizesScaled(t);
    if (n === null) return !1;
    this.writeDepth += 1;
    try {
      this.box = n, this.format.scaleLengths(t), this.rerenderKeepingSelection("hold");
    } finally {
      this.writeDepth -= 1;
    }
    return !0;
  }
  /**
   * A gesture that may write, with no fold in front of it: a handle release
   * and a width or height from the drawer, whose own fit finds the whole
   * scale the released frame needs and writes it. Re-entrant, because a
   * release renders and the render fits again.
   */
  allowingWrites(t) {
    this.writesAllowed += 1;
    try {
      return t();
    } finally {
      this.writesAllowed -= 1;
    }
  }
  /**
   * The fold: the residual the paint has been carrying since the box was
   * mounted becomes the authored sizes, before the gesture that triggered it
   * is applied. It runs first because the fit that follows an author's edit
   * measures the text at the AUTHORED sizes: with the residual still
   * unfolded, the first keystroke into a box a load fit shrank would raise the
   * frame by exactly what the load had fitted away. Nothing moves on screen —
   * the sizes rise by the factor the scale falls by, on the one grid
   * `editorPaintedSizePt` keeps them both on. The pending format's armed
   * style is scaled with the sizes, or the next character would land at the
   * size the box had before the fold. It records no step: the gesture's own
   * snapshot (`withAuthorGesture`) carries it. False when there is nothing
   * to fold.
   */
  foldResidual() {
    if (this.residualFolded || !cr(this.fitter.scale) || !$r(this.el)) return !1;
    const t = this.boxWithSizesScaled(this.fitter.scale);
    return t === null ? !1 : (this.box = t, this.format.scaleLengths(this.fitter.scale), this.residualFolded = !0, this.paintPredatesFold = !0, !0);
  }
  /**
   * The fitter's fit. Its scale measures the authored sizes again, folded or
   * not, once the paint is at those sizes; a fit of a paint from before a
   * fold measures the old sizes, so the fold stays marked.
   */
  fitBox(t) {
    const n = this.fitter.fit(t);
    return this.paintPredatesFold || (this.residualFolded = !1), n;
  }
  /**
   * One of the person's own gestures, as one history step: the fold runs
   * first, the gesture is applied, its fits write what they write, and the
   * whole of it is recorded as a single snapshot of the box and the pending
   * format before and after — so one undo takes back the edit, the fold and
   * every size and frame the gesture's fits wrote, and one redo puts them all
   * back. The step keeps the coalesce key of the step the gesture recorded,
   * so a run of typing is still one step. Only the outermost gesture folds
   * and records — a paste applies many content edits and is one gesture —
   * and a gesture that changed nothing records nothing.
   */
  withAuthorGesture(t) {
    return this.writesAllowed > 0 ? this.allowingWrites(() => t(!1)) : this.allowingWrites(() => {
      const n = this.box, o = this.format.snapshot(), r = this.foldResidual(), i = this.stack.cursor, s = this.stack.steps[i - 1], l = t(r);
      if (this.box === n) return l;
      const a = this.stack.cursor !== i || this.stack.steps[this.stack.cursor - 1] !== s ? this.stack.steps[this.stack.cursor - 1] : null, d = s === void 0 ? { steps: [], cursor: 0 } : {
        steps: [...this.stack.steps.slice(0, i - 1), s],
        cursor: i
      }, u = this.format.snapshot(), f = this.box, g = this.stylingSelection();
      return this.stack = Ct(d, {
        undo: () => (this.format.restore(o), n),
        redo: () => (this.format.restore(u), f),
        ...(a == null ? void 0 : a.coalesceKey) === void 0 ? {} : { coalesceKey: a.coalesceKey },
        selectionBefore: (a == null ? void 0 : a.selectionBefore) ?? g,
        selectionAfter: (a == null ? void 0 : a.selectionAfter) ?? g
      }), l;
    });
  }
  fitExplanation() {
    return this.fitter.explain();
  }
  overflowing() {
    return this.el.dataset[qe] === "true";
  }
  describeBoxLayout() {
    return this.fitter.describeLayout();
  }
  get inkRect() {
    return this.fitter.inkRect;
  }
  get inkClusters() {
    return this.fitter.inkClusters;
  }
  get textHeightPx() {
    return this.fitter.textHeightPx;
  }
  get paintedHeightPx() {
    return this.fitter.paintedHeightPx;
  }
  getModelPosition() {
    return this.caretMap.readPosition();
  }
  caretRecovery() {
    const t = this.box.blocks.findIndex(
      (n) => !C(n.kind)
    );
    return { blockIndex: t >= 0 ? t : 0, offset: 0 };
  }
  getModelOffset() {
    var t;
    return ((t = this.getModelPosition()) == null ? void 0 : t.offset) ?? null;
  }
  getModelSelection() {
    return this.caretMap.readSelection();
  }
  stylingSelection() {
    return this.getModelSelection() ?? this.caretSelection({ blockIndex: 0, offset: 0 });
  }
  /**
   * A caret a style arms for the next keystroke instead of applying: every
   * caret, one at either stop of a table included. A table takes a style
   * when it is selected whole.
   */
  isBareCaret(t) {
    return D(t);
  }
  /**
   * The caret at a position, in the form the caret map reads it back
   * (`canonicalEditorPosition`), so the stop before a table that follows
   * another table is placed, and then read, as the first table's stop after.
   */
  placeCaretAtPos(t) {
    return this.caretMap.placeCaret(et(this.box, t)) ? (this.tableHighlight.sync(), this.syncCaretColor(), this.syncCaretMetrics(), this.ruleHighlight.sync(), !0) : !1;
  }
  placeCaret(t) {
    return this.placeCaretAtPos({ blockIndex: 0, offset: t });
  }
  placeRangeAtPos(t, n) {
    return this.caretMap.placeRange(
      et(this.box, t),
      et(this.box, n)
    ) ? (this.tableHighlight.sync(), this.syncCaretColor(), this.syncCaretMetrics(), this.ruleHighlight.sync(), !0) : !1;
  }
  placeRange(t, n) {
    return this.placeRangeAtPos(
      { blockIndex: 0, offset: t },
      { blockIndex: 0, offset: n }
    );
  }
  /**
   * A caret as a selection, in the form the caret map reads it back in
   * `box`, the box the position belongs to: the one a history step records.
   */
  caretSelection(t, n = this.box) {
    const o = et(n, t);
    return {
      kind: "within-box",
      boxId: n.boxId,
      anchor: o,
      focus: o
    };
  }
  restoreSelection(t) {
    !t || t.kind !== "within-box" || this.placeRangeAtPos(t.anchor, t.focus);
  }
  seal(t) {
    this.stack = Qt(this.stack), this.format.onSeal(t) && (this.syncCaretColor(), this.syncCaretMetrics());
  }
  closeTypingRun() {
    this.seal("blur");
  }
  /**
   * The edit was computed against the box as it stood; a fold in front of it
   * moves the authored sizes under it, so the edit is replayed onto the
   * folded box through its own `redo` rather than taking its `box` as it
   * came. Its `undo` needs no such care: it patches whatever box it is
   * handed, and the fold's own step restores the sizes behind it.
   *
   * `before` is what an undo of the edit puts back: the caret it was made
   * at, or a selection, the table selected for an edit that removes a
   * table. An edit that returns the very box it was given only moves the
   * caret: the caret goes to `caretAfter`, the typing run it interrupts is
   * sealed as a caret jump would seal it, and no history step is recorded.
   */
  applyContentEdit(t, n, o) {
    if (t.box === this.box) {
      this.seal("caret-jump"), this.placeCaretAtPos(o);
      return;
    }
    const r = "kind" in n ? Xe(this.box, n) : this.caretSelection(n);
    if (this.withAuthorGesture((i) => {
      const s = i ? { ...t, box: t.redo(this.box) } : t, l = ee(s, this.stack, {
        selectionBefore: r,
        selectionAfter: this.caretSelection(o, s.box)
      });
      this.box = l.box, this.stack = l.stack, this.render("grow");
    }), !this.placeCaretAtPos(o)) {
      const i = this.box.blocks[o.blockIndex];
      i && this.placeCaretAtPos({
        blockIndex: o.blockIndex,
        offset: Math.max(
          0,
          Math.min(o.offset, A(i))
        )
      });
    }
  }
  applyRangeDelete(t, n = !0) {
    return this.seal("edit-boundary"), this.withAuthorGesture(
      () => this.applyRangeDeleteFolded(t, n)
    );
  }
  /**
   * The range deleted, and the caret where the delete puts it: where the
   * range started, or, when the range took the block it started in (a
   * table it covered), the position the model gives in a block the box
   * still holds.
   */
  applyRangeDeleteFolded(t, n) {
    const o = Lo(this.box, t.anchor, t.focus), r = ee(o, this.stack, {
      selectionBefore: Xe(this.box, t),
      selectionAfter: this.caretSelection(o.caretAfter, o.box)
    });
    return this.box = r.box, this.stack = r.stack, n && (this.render("grow"), this.placeCaretAtPos(o.caretAfter)), o.caretAfter;
  }
  /**
   * Where content entered now lands. The table selected is never replaced
   * by what is entered: the content lands at its stop after, on a new line
   * below it, and the table stays (`editorTableEntryStop`). Any other range
   * is deleted first, and the content lands where the delete puts the
   * caret; `replacing` says so, for the entry to join the delete's history
   * step. A caret is where it stands. Null when the box holds no selection.
   */
  entryPoint() {
    const t = this.getModelSelection();
    if (t === null) return null;
    const n = wr(this.box, t);
    return n !== null ? { pos: n, replacing: !1 } : D(t) ? { pos: t.focus, replacing: !1 } : { pos: this.applyRangeDelete(t, !1), replacing: !0 };
  }
  /** The entry point, or the caret's recovery position when the box holds no selection. */
  entryPointOrRecovery() {
    return this.entryPoint() ?? { pos: this.caretRecovery(), replacing: !1 };
  }
  /**
   * A field or a table inserted at its entry point: one history step with
   * the range it replaced, sealed as a field gesture.
   */
  commitFieldEntry(t, n) {
    this.applyContentEdit(n, t.pos, n.caretAfter), t.replacing && (this.stack = ht(this.stack, "latest-key")), this.seal("field-gesture");
  }
  extendCaretByUnit(t, n) {
    const o = this.modifiableSelection();
    if (o === null || !o.isCollapsed) return null;
    o.modify("extend", t, n);
    const r = this.getModelSelection();
    return !r || D(r) ? null : r;
  }
  selectAllGesture() {
    if (!this.mounted) return !1;
    this.seal("select-all");
    const t = this.box.blocks.length - 1;
    return this.placeRangeAtPos(
      { blockIndex: 0, offset: 0 },
      {
        blockIndex: t,
        offset: A(this.box.blocks[t])
      }
    );
  }
  historyGesture(t) {
    this.mounted && (this.composing || this.performHistory(t));
  }
  handleMousedown(t) {
    var r, i;
    if (this.composing || t.button !== 0 || t.shiftKey) return;
    const n = this.ruleBlockIndexOf(t.target);
    if (n !== null) {
      t.preventDefault(), t.detail >= 4 ? this.selectAllGesture() : this.selectRule(n);
      return;
    }
    const o = this.tablePressOf(t);
    if (o !== null) {
      t.preventDefault(), t.detail >= 4 ? this.selectAllGesture() : o.stop !== null ? this.placeTableStop(o.stop) : this.selectTable(o.blockIndex);
      return;
    }
    if (t.detail === 1) {
      const s = (i = (r = this.el.ownerDocument.elementFromPoint(t.clientX, t.clientY)) == null ? void 0 : r.closest) == null ? void 0 : i.call(
        r,
        `${B}[${kt}="field"]`
      ), l = s && this.el.contains(s) ? this.fieldSpanOf(s) : null;
      if (s && l !== null && Hr(s, t.clientX, t.clientY) === null) {
        t.preventDefault(), this.fieldPress = { field: l, x: t.clientX, y: t.clientY, moved: !1 };
        return;
      }
      this.trail && !this.pressIsInsideSelection(t.clientX, t.clientY) && (this.trail.ownsFocus = !0);
      return;
    }
    if (t.detail === 2) {
      this.trail && (this.trail.ownsFocus = !0, this.trail.granularity = "word");
      return;
    }
    t.detail < 3 || (t.preventDefault(), t.detail === 3 ? this.selectLineAtPoint(t.clientX, t.clientY) : this.selectAllGesture());
  }
  /**
   * A press that began on a field and moved: the selection runs from the
   * field's far edge to the caret position under the pointer, so the field
   * stays whole at one end and the words the pointer crosses join it, the
   * way a drag from plain text selects. True while the press owns the move.
   */
  extendSelectionFromField(t) {
    const n = this.fieldPress;
    if (n === null) return !1;
    const o = 3;
    if (!n.moved && Math.abs(t.clientX - n.x) < o && Math.abs(t.clientY - n.y) < o)
      return !0;
    n.moved = !0;
    const r = this.pointerIsOverBox(t.clientX, t.clientY) ? this.caretMap.fromClientPoint(t.clientX, t.clientY) : this.projectedPositionAt(t.clientX, t.clientY);
    if (r === null) return !0;
    const { field: i } = n, s = {
      blockIndex: i.blockIndex,
      offset: i.start
    }, l = {
      blockIndex: i.blockIndex,
      offset: i.end
    }, c = P(r, s) < 0, a = P(r, l) > 0, d = c ? l : s, u = c || a ? r : l;
    return this.placeRangeAtPos(d, u), this.enforceFieldCover(), !0;
  }
  pressIsInsideSelection(t, n) {
    const o = this.getModelSelection();
    if (o === null || D(o)) return !1;
    const r = this.caretMap.fromClientPoint(t, n);
    if (r === null) return !1;
    const [i, s] = V(o.anchor, o.focus);
    return P(r, i) >= 0 && P(r, s) <= 0;
  }
  beginPointerTrail(t) {
    this.endPointerTrail(), this.el.ownerDocument.addEventListener(
      "pointermove",
      this.pointerMoveListener
    ), t.pointerType !== "touch" && (this.trail = {
      ownsFocus: !1,
      granularity: "character",
      word: null,
      lines: null,
      turned: null,
      anchor: null,
      focus: null,
      frame: null
    });
  }
  /**
   * The release: the host's selection is asserted once more now, since
   * the browser's release handling follows this listener, and once in the
   * next frame, so the last outside move is what gets painted. A host
   * being destroyed asserts nothing.
   */
  endPointerTrail(t = !0) {
    this.el.ownerDocument.removeEventListener(
      "pointermove",
      this.pointerMoveListener
    );
    const n = this.trail;
    if (n === null) return;
    const o = this.el.ownerDocument.defaultView;
    if (n.frame !== null && (o == null || o.cancelAnimationFrame(n.frame)), n.frame = null, this.trail = null, !t || n.focus === null || n.anchor === null) return;
    this.assertPointerSelection(n.anchor, n.focus);
    const r = this.getModelSelection(), i = (r == null ? void 0 : r.anchor) ?? n.anchor, s = (r == null ? void 0 : r.focus) ?? n.focus;
    o && typeof o.requestAnimationFrame == "function" && o.requestAnimationFrame(() => {
      this.mounted && this.trail === null && this.assertPointerSelection(i, s);
    });
  }
  /**
   * A move of an owned press: inside the box the browser's own hit test
   * is right and the host stands aside; outside it, the focus is the
   * point projected onto the painted lines, asserted now and then every
   * frame until the pointer is back over the box or released, since the
   * browser's autoscroll re-extends from the same point each frame.
   */
  followPointer() {
    const t = this.trail, n = this.pointerClient;
    if (t === null || !t.ownsFocus || n === null) return;
    if (t.granularity === "word" && t.word === null) {
      const s = this.getModelSelection();
      if (s !== null && !D(s)) {
        const [l, c] = V(s.anchor, s.focus);
        t.word = { start: l, end: c };
      }
    }
    if (this.pointerIsOverBox(n.x, n.y)) {
      t.focus = null;
      return;
    }
    let o = this.projectedPositionAt(n.x, n.y);
    if (o === null) return;
    let r = t.anchor ?? (t.anchor = this.selectionAnchorInBox());
    if (t.granularity === "word" && t.word !== null) {
      const { start: s, end: l } = t.word;
      P(o, l) > 0 ? (r = s, o = this.wordEdgeAt(o, "end")) : P(o, s) < 0 ? (r = l, o = this.wordEdgeAt(o, "start")) : (r = s, o = l), t.anchor = r;
    }
    if (r === null) return;
    t.focus = o, this.assertPointerSelection(r, o);
    const i = this.el.ownerDocument.defaultView;
    t.frame === null && i && typeof i.requestAnimationFrame == "function" && (t.frame = i.requestAnimationFrame(() => {
      t.frame = null, this.trail === t && this.pointerDown && this.mounted && this.followPointer();
    }));
  }
  /**
   * The far edge of the word a position is inside of; the position itself
   * when it sits between words or on a word's own edge, so a line's end
   * (the stop after its last word) never reaches into the next line's
   * first word.
   */
  wordEdgeAt(t, n) {
    const o = this.box.blocks[t.blockIndex];
    if (!o || C(o.kind)) return t;
    const r = kr(
      o,
      t.offset,
      this.context.locale
    );
    if (!r || r.start >= t.offset || r.end <= t.offset)
      return t;
    const i = n === "end" ? r.end : r.start;
    return { blockIndex: t.blockIndex, offset: i };
  }
  selectionAnchorInBox() {
    var n;
    const t = (n = this.el.ownerDocument.defaultView) == null ? void 0 : n.getSelection();
    return !t || t.rangeCount === 0 || !t.anchorNode || !this.el.contains(t.anchorNode) ? null : this.caretMap.toPosition(t.anchorNode, t.anchorOffset);
  }
  /**
   * The selection set to the host's anchor and focus when the browser's
   * differs. The field cover then runs on the result, and the ends it
   * settles on become the ones asserted from here on, so an end inside a
   * field does not fight the cover frame after frame. The ends are compared
   * in the form the caret map reads back, and a browser end left inside a
   * table is put back even when its reading already matches, since the
   * reading snaps such an end to the stop that covers the table while the
   * paint does not.
   */
  assertPointerSelection(t, n) {
    const o = this.getModelSelection();
    if (o !== null && P(
      o.anchor,
      et(this.box, t)
    ) === 0 && P(
      o.focus,
      et(this.box, n)
    ) === 0 && !this.domEndInsideTable() || !this.placeRangeAtPos(t, n)) return;
    this.enforceFieldCover();
    const r = this.getModelSelection(), i = this.trail;
    i !== null && i.focus !== null && r !== null && (i.anchor = r.anchor, i.focus = r.focus);
  }
  /**
   * Whether the element under the point is the box or something painted
   * in it. A caret read from a point beside the box would name the nearest
   * text inside it — the browser descends into the box from whatever it
   * hit — so the box's own extent is what says inside from outside.
   */
  pointerIsOverBox(t, n) {
    const o = this.el.ownerDocument.elementFromPoint(t, n);
    return o !== null && this.el.contains(o);
  }
  /**
   * The position a point outside the painted text stands for, read from
   * the box's own glyph geometry. Null for a turned box, whose client rects
   * do not describe its lines, and for a box that paints nothing.
   */
  projectedPositionAt(t, n) {
    const o = this.trail, r = (o == null ? void 0 : o.turned) ?? Mf(this.el);
    if (o && (o.turned = r), r) return null;
    const i = (o == null ? void 0 : o.lines) ?? Bf(
      this.el,
      (l, c) => this.caretMap.toPosition(l, c),
      (l) => this.caretMap.tableBlockIndexOf(l)
    );
    o && (o.lines = i);
    const s = this.el.getBoundingClientRect();
    return Of(
      i,
      t - s.left,
      n - s.top
    );
  }
  /**
   * The caret at the text under a client point — where a double-click that
   * opened the box landed — so the word under the pointer is the word a
   * size command sizes. False when the point maps to no text.
   */
  placeCaretAtClientPoint(t, n) {
    if (!this.mounted) return !1;
    const o = this.caretMap.fromClientPoint(t, n) ?? this.projectedPositionAt(t, n);
    return o !== null && this.placeCaretAtPos(o);
  }
  selectLineAtPoint(t, n) {
    if (!this.mounted) return !1;
    const o = this.caretMap.fromClientPoint(t, n) ?? this.getModelPosition();
    if (!o) return !1;
    this.placeCaretAtPos(o);
    const r = this.extendCaretByUnit("backward", "lineboundary");
    this.placeCaretAtPos(o);
    const i = this.extendCaretByUnit("forward", "lineboundary");
    if (!r && !i) {
      const c = this.box.blocks[o.blockIndex];
      return this.placeRangeAtPos(
        { blockIndex: o.blockIndex, offset: 0 },
        { blockIndex: o.blockIndex, offset: A(c) }
      );
    }
    const s = r ? V(r.anchor, r.focus)[0] : o, l = i ? V(i.anchor, i.focus)[1] : o;
    return this.placeRangeAtPos(s, l);
  }
  handleClick(t) {
    var u;
    if (this.composing || t.detail >= 3) return;
    const n = t.target, o = n && n.nodeType === 3 ? n.parentElement : n, r = (u = o == null ? void 0 : o.closest) == null ? void 0 : u.call(
      o,
      `${B}[${kt}="field"]`
    );
    if (!r || !this.el.contains(r)) return;
    const i = this.caretMap.blockAncestorOf(r);
    if (!i) return;
    const s = Number(i.dataset[Et]), l = Number(r.dataset[ct]);
    if (!Number.isInteger(s) || !Number.isInteger(l)) return;
    const c = this.box.blocks[s];
    if (c === void 0 || C(c.kind)) return;
    const a = Hr(r, t.clientX, t.clientY);
    if (a === null) {
      this.selectFieldRun(s, l);
      return;
    }
    const d = yt(this.box.blocks[s], l);
    this.placeCaretAtPos({
      blockIndex: s,
      offset: a === "before" ? d : d + 1
    });
  }
  selectFieldRun(t, n) {
    var s;
    if (!this.mounted) return !1;
    const o = (s = this.box.blocks[t]) == null ? void 0 : s.runs[n];
    if (!o || o.kind !== "field") return !1;
    this.seal("field-gesture");
    const r = yt(this.box.blocks[t], n), i = this.placeRangeAtPos(
      { blockIndex: t, offset: r },
      { blockIndex: t, offset: r + 1 }
    );
    return i && this.fieldHighlight.stamp(t, n), i;
  }
  get fieldRunSelection() {
    return this.fieldHighlight.selection;
  }
  /**
   * The rule block an event's target sits in, else null. The whole block is
   * the target — the stroke and its leading above and below — since the
   * stroke alone is a pixel tall.
   */
  ruleBlockIndexOf(t) {
    var s, l;
    const n = t, o = n && n.nodeType === 3 ? n.parentElement : n, r = (s = o == null ? void 0 : o.closest) == null ? void 0 : s.call(o, `.${de}`);
    if (!r || !this.el.contains(r)) return null;
    const i = Number(r.dataset[Et]);
    return Number.isInteger(i) && ((l = this.box.blocks[i]) == null ? void 0 : l.kind) === "rule" ? i : null;
  }
  /**
   * Selects a rule and nothing else — the selection editorRuleSelection
   * gives, its focus on the rule so the toolbar reads the rule's styling —
   * and the placement marks its block for the band. A style applied to it
   * lands on the rule's own character styling; a keystroke replaces it.
   */
  selectRule(t) {
    if (!this.mounted) return !1;
    const n = ba(this.box, t);
    return n === null ? !1 : (this.seal("rule-gesture"), this.focusForPress(), this.placeRangeAtPos(n.anchor, n.focus));
  }
  /**
   * The press that selects a rule or a table, or puts the caret at a
   * table's stop, is prevented, so it moved no focus: a box whose focus a
   * toolbar control took gets it back here, so the keys and the toolbar act
   * on what the press chose.
   */
  focusForPress() {
    const t = this.el.ownerDocument.activeElement;
    t !== this.el && !this.el.contains(t) && this.el.focus({ preventScroll: !0 });
  }
  /** The block index of the rule the selection covers alone, else null. */
  get ruleSelection() {
    return this.ruleHighlight.selection;
  }
  /**
   * The table a press lands on, and, for a press in the thin band along
   * the table's top or bottom edge, the stop on that edge; null for a press
   * off every table.
   */
  tablePressOf(t) {
    const n = this.caretMap.tableBlockIndexOf(t.target), o = n === null ? null : this.caretMap.blockElement(n);
    if (n === null || o === null) return null;
    const r = gh(o, t.clientY);
    return {
      blockIndex: n,
      stop: r === null ? null : { blockIndex: n, offset: r === "before" ? 0 : 1 }
    };
  }
  placeTableStop(t) {
    this.focusForPress(), this.placeCaretAtPos(t);
  }
  /**
   * Selects a table whole, the selection editorTableSelection gives: from
   * its stop before to its stop after, the focus after it, so a caret the
   * selection collapses to stands after the table. The placement marks the
   * block for the band; a style applied then reaches every cell, and
   * Backspace, Delete or Cut removes the table.
   */
  selectTable(t) {
    if (!this.mounted) return !1;
    const n = So(this.box, t);
    return n === null ? !1 : (this.seal("table-gesture"), this.focusForPress(), this.placeRangeAtPos(n.anchor, n.focus));
  }
  /** The block index of the table the selection covers whole and alone, else null. */
  get tableSelection() {
    return this.tableHighlight.selection;
  }
  /**
   * The table stop the caret stands at while the box has focus, and the
   * stop's side, before the table or after it; the caret bar is painted
   * there. Null otherwise.
   */
  get tableCaret() {
    return this.tableHighlight.caret;
  }
  insertField(t, n, o) {
    if (!this.mounted) return !1;
    const r = this.entryPoint();
    if (r === null) return !1;
    const i = gs(
      this.box,
      r.pos,
      t,
      n,
      this.styleForFieldGesture(o)
    );
    return this.commitFieldEntry(r, i), !0;
  }
  /**
   * Paragraphs of fields and literal text at the caret, placed as
   * `insertEditorFieldParagraphs` places them, the caret after the last one.
   * A range selection is replaced: the delete and the insert run inside one
   * author gesture, as a paste's do, so they are one history step and a box
   * a load fit shrank folds its sizes once. The table selected is not
   * replaced: the paragraphs go below it, as any insert does
   * (`editorTableEntryStop`).
   */
  insertFieldParagraphs(t, n) {
    if (!this.mounted || t.length === 0) return !1;
    const o = this.getModelSelection(), r = o === null ? null : wr(this.box, o), i = r === null && o !== null && !D(o) ? o : null, s = i === null ? r ?? this.getModelPosition() : null;
    return i === null && s === null ? !1 : (this.withAuthorGesture(() => {
      const l = this.stack.cursor, c = i === null ? s : this.applyRangeDelete(i, !1);
      if (c === null) return;
      const a = bs(
        this.box,
        c,
        t,
        this.styleForFieldGesture(n)
      );
      this.applyContentEdit(a, c, a.caretAfter);
      const d = this.stack.cursor - l;
      for (let u = 1; u < d; u += 1)
        this.stack = ht(this.stack, "latest-key");
    }), this.seal("field-gesture"), !0);
  }
  /**
   * A field inserted at an armed caret takes the armed style exactly as the
   * next typed character would; the caller's explicit style still wins.
   */
  styleForFieldGesture(t) {
    const n = this.format.armed;
    return n === null ? t : Z(n, t ?? {});
  }
  /**
   * A horizontal rule at the caret, inside the box: the paragraph splits
   * around it and the caret lands on the line after it. A range selection
   * is replaced by the rule; a selected table is not, the rule goes below
   * it. It renders under the grow rule like any edit of the author's: the
   * rule's leading is one more line the frame settles onto.
   */
  insertRule() {
    var o;
    if (!this.mounted) return !1;
    const t = ((o = this.entryPoint()) == null ? void 0 : o.pos) ?? this.caretRecovery(), n = ps(this.box, t);
    return this.applyContentEdit(n, t, n.caretAfter), this.seal("edit-boundary"), !0;
  }
  insertCaseDetailTable(t, n, o) {
    if (!this.mounted) return !1;
    const r = this.entryPoint();
    if (r === null) return !1;
    const i = ci(
      t,
      this.context.caseData,
      n == null ? void 0 : n.rowType
    ).length, s = ms(
      this.box,
      r.pos,
      t,
      i,
      this.styleForFieldGesture(o),
      n
    );
    return this.commitFieldEntry(r, s), !0;
  }
  fieldRun(t) {
    for (let n = 0; n < this.box.blocks.length; n++) {
      const o = this.box.blocks[n].runs;
      for (let r = 0; r < o.length; r++) {
        const i = o[r];
        if (i.kind === "field" && (t === void 0 || i.fieldKey === t))
          return {
            blockIndex: n,
            runIndex: r,
            fieldKey: i.fieldKey,
            params: i.params
          };
      }
    }
    return null;
  }
  setFieldParams(t, n, o = 0, r) {
    var c;
    if (!this.mounted) return !1;
    const i = (c = this.box.blocks[o]) == null ? void 0 : c.runs[t];
    if (!i || i.kind !== "field") return !1;
    const s = this.getModelPosition() ?? { blockIndex: 0, offset: 0 }, l = ys(
      this.box,
      t,
      n,
      o,
      r
    );
    return this.applyContentEdit(l, s, s), this.seal("field-gesture"), !0;
  }
  convertFieldToText(t, n) {
    var s, l;
    if (!this.mounted) return !1;
    const o = t !== void 0 && n !== void 0 ? this.fieldRunAt(t, n) : this.fieldRun();
    if (!o) return !1;
    const r = (l = (s = this.resolved().blocks[o.blockIndex]) == null ? void 0 : s.runs[o.runIndex]) == null ? void 0 : l.text;
    if (r === void 0) return !1;
    const i = this.getModelPosition() ?? { blockIndex: 0, offset: 0 };
    return this.applyContentEdit(
      ud(
        this.box,
        o.runIndex,
        r,
        this.context,
        o.blockIndex
      ),
      i,
      i
    ), this.seal("field-gesture"), !0;
  }
  convertAllFieldsToText() {
    if (!this.mounted) return 0;
    const t = this.stack.cursor, n = this.box.blocks.reduce(
      (s, l) => s + l.runs.length,
      0
    );
    let o = 0;
    const r = [() => this.emptyFieldRun(), () => this.fieldRun()];
    for (const s of r)
      for (let l = 0; l < n; l += 1) {
        const c = s();
        if (c === null || !this.convertFieldToText(c.blockIndex, c.runIndex)) break;
        o += 1;
      }
    if (o === 0) return 0;
    const i = this.stack.cursor - t;
    for (let s = 1; s < i; s += 1)
      this.stack = ht(this.stack);
    return this.stack = Qt(this.stack), o;
  }
  fieldRunCount() {
    return this.box.blocks.reduce(
      (t, n) => t + n.runs.filter((o) => o.kind === "field").length,
      0
    );
  }
  fieldRunAt(t, n) {
    var r;
    const o = (r = this.box.blocks[t]) == null ? void 0 : r.runs[n];
    return (o == null ? void 0 : o.kind) === "field" ? {
      blockIndex: t,
      runIndex: n,
      fieldKey: o.fieldKey,
      params: o.params
    } : null;
  }
  /** The first empty field run outside an atomic block, in document order. */
  emptyFieldRun() {
    for (let t = 0; t < this.box.blocks.length; t++) {
      const n = this.box.blocks[t];
      if (C(n.kind)) continue;
      const o = Vt(n.runs, this.context).findIndex(
        (r) => r.kind === "field" && Wl(r.resolvedText ?? "")
      );
      if (o !== -1) return this.fieldRunAt(t, o);
    }
    return null;
  }
  /**
   * Tag every paragraph the selection touches with a role (a caret tags
   * its own paragraph); the theme's decoration for that role dresses them
   * through the cascade. The selection is put back where it was.
   */
  setParagraphRole(t) {
    if (!this.mounted) return !1;
    const n = this.getModelSelection();
    return n === null || n.kind !== "within-box" || !this.withAuthorGesture(() => this.setParagraphRoleFolded(t)) ? !1 : (this.seal("edit-boundary"), !0);
  }
  /**
   * One of the person's own gestures, like every other style command: the
   * gesture opens the write gate, so the grow fit settles the frame onto the
   * text the role's decoration re-wraps and writes what it finds, and the
   * step the tracked edit records is folded into the gesture's one snapshot.
   */
  setParagraphRoleFolded(t) {
    const n = this.getModelSelection();
    if (n === null || n.kind !== "within-box") return !1;
    const { anchor: o, focus: r } = n, i = Math.min(o.blockIndex, r.blockIndex), s = Math.max(o.blockIndex, r.blockIndex);
    if (!this.box.blocks[i] || !this.box.blocks[s]) return !1;
    const l = ee(
      nd(this.box, i, s, t),
      this.stack,
      { selectionBefore: n, selectionAfter: n }
    );
    return this.box = l.box, this.stack = l.stack, this.render("grow"), D(n) ? this.placeCaretAtPos(r) : this.placeRangeAtPos(o, r), !0;
  }
  /** The role of the paragraph at the selection's focus. */
  paragraphRole() {
    var n;
    const t = this.getModelPosition() ?? { blockIndex: 0 };
    return (n = this.box.blocks[t.blockIndex]) == null ? void 0 : n.role;
  }
  /**
   * The whole span of every paragraph the selection touches — what a role
   * applies to — from the first one's start to the last one's end.
   */
  paragraphRange() {
    if (!this.mounted) return null;
    const t = this.getModelSelection();
    if (t === null || t.kind !== "within-box") return null;
    const n = Math.min(t.anchor.blockIndex, t.focus.blockIndex), o = Math.max(t.anchor.blockIndex, t.focus.blockIndex), r = this.box.blocks[o];
    return !this.box.blocks[n] || !r ? null : {
      anchor: { blockIndex: n, offset: 0 },
      focus: { blockIndex: o, offset: A(r) }
    };
  }
  applyStyle(t) {
    return !this.mounted || this.stylingSelection().kind !== "within-box" ? !1 : this.withAuthorGesture(() => this.applyStyleFolded(t));
  }
  applyStyleFolded(t) {
    const n = this.stylingSelection();
    if (n.kind !== "within-box") return !1;
    const { anchor: o, focus: r } = n, i = this.isBareCaret(n);
    if (t.kind === "set-box-style") {
      const c = te(
        this.box,
        t,
        { selection: "whole-box" },
        this.stack,
        { selectionBefore: n, selectionAfter: n }
      );
      return this.box = c.box, this.stack = c.stack, this.render("grow"), i ? this.placeCaretAtPos(r) : this.placeRangeAtPos(o, r), !0;
    }
    if (i) {
      if (t.kind === "set-character-style")
        return this.styleEmptyBox(t.delta, n) || this.mergePending(t.delta), !0;
      if (t.kind === "set-block-style") {
        const c = te(
          this.box,
          t,
          { selection: "run", blockIndex: r.blockIndex, runIndex: 0 },
          this.stack,
          { selectionBefore: n, selectionAfter: n }
        );
        return this.box = c.box, this.stack = c.stack, this.render("grow"), this.placeCaretAtPos(r), !0;
      }
      return !1;
    }
    const s = Fe(
      Be,
      this.box,
      n
    );
    if (!s.ok) return !1;
    const l = te(
      this.box,
      t,
      s.target,
      this.stack,
      { selectionBefore: n, selectionAfter: n }
    );
    return this.box = l.box, this.stack = l.stack, this.render("grow"), this.placeRangeAtPos(o, r), !0;
  }
  /**
   * An empty box has no run to carry a style, so a collapsed-caret style
   * becomes the box's own: it saves, it survives leaving the box, and every
   * run and field typed or inserted later inherits it through the cascade.
   */
  styleEmptyBox(t, n, o) {
    return Hn(this.box) ? this.withAuthorGesture(
      () => this.styleEmptyBoxFolded(t, n, o)
    ) : !1;
  }
  styleEmptyBoxFolded(t, n, o) {
    const r = this.box;
    let i = r;
    const s = te(
      this.box,
      { kind: "set-character-style", delta: t },
      { selection: "whole-box" },
      this.stack,
      { selectionBefore: n, selectionAfter: n }
    );
    return this.box = s.box, this.format.followEmptyBoxStyle(t), this.stack = o === void 0 ? s.stack : Ct(this.stack, {
      undo: () => r,
      redo: () => i,
      coalesceKey: o.coalesceKey,
      selectionBefore: n,
      selectionAfter: n
    }), this.render("grow"), i = this.box, this.placeCaretAtPos(n.focus), !0;
  }
  applyCharacterToggle(t, n) {
    if (!this.mounted) return !1;
    const o = this.stylingSelection();
    if (o.kind !== "within-box") return !1;
    const r = this.coveredRuns(o.anchor, o.focus), i = this.deltaActiveOn(r, o.focus, t);
    if (r.length === 0) {
      const s = i ? n : t;
      return this.styleEmptyBox(s, o) || this.mergePending(s), !0;
    }
    return this.applyStyle({
      kind: "set-character-style",
      delta: i ? n : t
    });
  }
  /**
   * Every length the fit scales × ratio, rounded down on its grid: run
   * sizes, tracking, outline weight and the struts of empty blocks. Null
   * when the ratio moves nothing.
   */
  boxWithSizesScaled(t) {
    const n = _s(
      this.box,
      this.context,
      t
    );
    return n === this.box ? null : n;
  }
  /**
   * The corner scale's bake: the sizes × ratio as one undo step that carries
   * the box as it was before the release, so undo restores the frame and the
   * sizes together.
   */
  bakeCornerScale(t, n = {}) {
    if (!this.mounted) return !1;
    const o = n.before ?? this.box, r = this.boxWithSizesScaled(t);
    if (r === null) return !1;
    const i = this.stylingSelection();
    let s = r;
    const l = {
      undo: () => o,
      redo: () => s,
      coalesceKey: n.coalesceKey ?? "corner-scale",
      selectionBefore: i,
      selectionAfter: i
    };
    return this.box = r, this.format.scaleLengths(t), this.stack = Ct(this.stack, l), this.stack = Qt(this.stack), this.render("hold"), s = this.box, i.kind === "within-box" && (D(i) ? this.placeCaretAtPos(i.focus) : this.placeRangeAtPos(i.anchor, i.focus)), !0;
  }
  /**
   * What a size command at a bare caret sizes: the field run the caret
   * touches on either side, else the word the caret stands inside — a
   * word character on both sides, the TinyMCE editor's rule, so a caret at
   * a word's edge arms and what is typed or pasted there lands at the
   * armed size while the word keeps its own. A field is one unit of text no
   * caret can enter, so a caret beside it is as much "in" it as a caret is
   * in a word; and a box holding a field alone can be sized no other way.
   * Null at a word break with no field beside it.
   */
  sizeTargetAtCaret(t) {
    const n = this.box.blocks[t.blockIndex];
    if (!n || C(n.kind)) return null;
    const o = (s, l) => ({
      kind: "within-box",
      boxId: this.box.boxId,
      anchor: { blockIndex: t.blockIndex, offset: s },
      focus: { blockIndex: t.blockIndex, offset: l }
    }), r = Yi(n, t.offset);
    if (r) {
      const s = n.runs[r.runIndex];
      if ((s == null ? void 0 : s.kind) === "field") {
        const c = yt(n, r.runIndex);
        return o(c, c + 1);
      }
      const l = r.offsetInRun === 0 ? n.runs[r.runIndex - 1] : null;
      if ((l == null ? void 0 : l.kind) === "field") {
        const c = yt(n, r.runIndex - 1);
        return o(c, c + 1);
      }
    }
    const i = kr(
      n,
      t.offset,
      this.context.locale
    );
    return i && i.start < t.offset && i.end > t.offset ? o(i.start, i.end) : null;
  }
  /**
   * A size command, in the one order that works: fold, rebuild the grid,
   * then apply. The grid the command computes from is the resolved AUTHORED
   * sizes, while the number on screen and in the size field is the authored
   * size through the fit's residual; the settling fit that ends the command
   * then repaints the whole box at one scale. Applied against an unfolded
   * grid, a size typed onto one run would silently resize every other run
   * by the reciprocal of the residual, and one stepper press of half a
   * point would move the paint by several. The fold is the gesture's, so
   * one undo takes the box back to the sizes its row holds.
   */
  applyFontSizeWith(t, n, o = "whole-box") {
    return !this.mounted || this.stylingSelection().kind !== "within-box" ? !1 : this.withAuthorGesture(
      () => this.applyFontSizeFolded(t, n, o)
    );
  }
  applyFontSizeFolded(t, n, o) {
    const r = this.stylingSelection();
    if (r.kind !== "within-box") return !1;
    const i = this.box, s = this.maxAuthoredPt(), l = (m) => Ha(s === null ? m : Math.min(m, s)), c = this.resolved().blocks, a = this.box.blocks.map(
      (m, k) => m.runs.map((E, S) => {
        var v, T;
        const y = (T = (v = c[k]) == null ? void 0 : v.runs[S]) == null ? void 0 : T.style.fontSizePt;
        return typeof y == "number" ? y : xt.fontSizePt;
      })
    ), d = () => {
      const m = this.format.effectiveAt(r.focus).fontSizePt;
      this.mergePending({
        fontSize: l(
          t(
            typeof m == "number" ? m : xt.fontSizePt
          )
        )
      });
    };
    if (D(r) && Hn(this.box)) {
      const m = this.format.effectiveAt(r.focus).fontSizePt, k = l(
        t(
          typeof m == "number" ? m : xt.fontSizePt
        )
      );
      return this.styleEmptyBox({ fontSize: k }, r, { coalesceKey: n });
    }
    const u = this.isBareCaret(r), f = u && o === "arm" ? this.sizeTargetAtCaret(r.focus) : null;
    if (u && o === "arm" && f === null)
      return d(), !0;
    const g = u ? f ?? this.wholeBoxSelection() : r, b = Fe(
      Be,
      this.box,
      g
    );
    let p = this.box;
    b.ok ? (p = ja(
      p,
      b.target,
      (m, k) => {
        var E;
        return l(
          t(((E = a[m]) == null ? void 0 : E[k]) ?? xt.fontSizePt)
        );
      }
    ), p = sd(
      p,
      g.anchor.blockIndex,
      g.focus.blockIndex,
      (m) => {
        var k;
        return l(
          t(
            ((k = c[m]) == null ? void 0 : k.style.fontSizePt) ?? xt.fontSizePt
          )
        );
      }
    )) : d();
    let h = p;
    if (p !== i) {
      const m = {
        undo: () => i,
        redo: () => h,
        coalesceKey: n,
        selectionBefore: r,
        selectionAfter: r
      };
      this.box = p, this.stack = Ct(this.stack, m);
    }
    return this.render("grow"), h = this.box, D(r) ? this.placeCaretAtPos(r.focus) : this.placeRangeAtPos(r.anchor, r.focus), !0;
  }
  stepFontSize(t) {
    return !Number.isFinite(t) || t === 0 ? !1 : this.applyFontSizeWith((n) => n + t, "font-size:step", "arm");
  }
  setFontSize(t, n) {
    return !Number.isFinite(t) || t <= 0 ? !1 : this.applyFontSizeWith(() => t, void 0, n);
  }
  /**
   * The style the toolbar readouts describe. A range reads its first covered
   * run, never its focus position: a focus that lands exactly on a run
   * boundary — which every backward selection does — resolves to the run
   * BEFORE the selection, so the toolbar would describe the wrong text.
   */
  selectionCharacterStyle(t, n) {
    var i;
    const [o] = this.coveredRuns(t, n);
    if (o === void 0) return this.format.effectiveAt(n);
    const r = (i = this.resolved().blocks[o.blockIndex]) == null ? void 0 : i.runs[o.runIndex];
    return r === void 0 ? this.format.effectiveAt(n) : r.style;
  }
  /**
   * The authored size at the caret, never the rendered one: fitScale is the
   * badge's alone. A corner scale in progress moves it live with the sizes.
   */
  fontSizePt() {
    const t = this.fontSizeReadout();
    return t.kind === "pt" ? t.pt : null;
  }
  /**
   * The largest size a command may author: a Fill text box's maximum, or
   * null under Shrink and with no maximum set. A stored maximum is inert
   * under Shrink, where the text is never scaled above its authored sizes.
   */
  maxAuthoredPt() {
    const t = this.textSizing();
    return t.mode === "fill" ? t.maxFontSizePt : null;
  }
  /**
   * What the size field shows: the size the text at the caret is PAINTED at
   * — the authored size through the fit's residual, on the same 0.1 pt grid
   * the paint itself is on, times any corner scale in progress. A box the
   * person has not edited holds its residual, so the authored size and the
   * painted size differ until the first edit folds them together, and a
   * field showing the authored size would be a number that is nowhere on
   * screen. `atMax` says the box's maximum is what holds the size, so the
   * toolbar can say so rather than look broken.
   */
  fontSizeReadout() {
    var d, u, f;
    if (!this.mounted) return { kind: "none" };
    const t = this.stylingSelection();
    if (t.kind !== "within-box") return { kind: "none" };
    const n = this.paintScaleOverSizes() * (((d = this.drag) == null ? void 0 : d.cornerScale) ?? 1), o = this.maxAuthoredPt(), r = (g) => {
      const b = le(g, n);
      return o !== null && b >= o - hh ? { kind: "pt", pt: b, atMax: o } : { kind: "pt", pt: b };
    }, i = this.coveredRuns(t.anchor, t.focus);
    if (i.length === 0) {
      const g = this.format.effectiveAt(t.focus).fontSizePt;
      return typeof g == "number" ? r(g) : { kind: "none" };
    }
    const s = this.resolved().blocks, l = /* @__PURE__ */ new Set();
    for (const { blockIndex: g, runIndex: b } of i) {
      const p = (f = (u = s[g]) == null ? void 0 : u.runs[b]) == null ? void 0 : f.style.fontSizePt;
      typeof p == "number" && l.add(p);
    }
    if (l.size === 0) return { kind: "none" };
    if (new Set(
      [...l].map((g) => le(g, n))
    ).size > 1) return { kind: "mixed" };
    const [a] = l;
    return r(a);
  }
  /**
   * What the text colour button shows. A range reads its covered runs, so a
   * range over two colours is `mixed`; a caret reads the colour typing there
   * takes, an armed colour included.
   */
  colorReadout() {
    if (!this.mounted) return { kind: "none" };
    const t = this.stylingSelection();
    if (t.kind !== "within-box") return { kind: "none" };
    const n = this.resolved().blocks, o = this.coveredRuns(t.anchor, t.focus).map(
      ({ blockIndex: s, runIndex: l }) => {
        var c, a;
        return (a = (c = n[s]) == null ? void 0 : c.runs[l]) == null ? void 0 : a.style.color;
      }
    ).filter((s) => typeof s == "string"), r = o[0] ?? this.format.effectiveAt(t.focus).color;
    if (typeof r != "string") return { kind: "none" };
    const i = new Set(o.map((s) => s.toLowerCase()));
    return { kind: "color", color: r, mixed: i.size > 1 };
  }
  fontFitScale() {
    return this.paintScaleOverSizes();
  }
  /**
   * The scale the paint carries over the authored sizes. A fold that did not
   * repaint has already written the fitter's scale into the sizes, so until
   * the next render the paint shows the sizes at 1, and the fitter's scale
   * describes the sizes from before the fold.
   */
  paintScaleOverSizes() {
    return this.paintPredatesFold ? 1 : this.fitter.scale;
  }
  effectiveFontFamily() {
    if (!this.mounted) return null;
    const t = this.stylingSelection();
    if (t.kind !== "within-box") return null;
    const n = this.selectionCharacterStyle(
      t.anchor,
      t.focus
    ).fontFamily;
    return typeof n == "string" ? n : null;
  }
  effectiveLetterSpacing() {
    if (!this.mounted) return null;
    const t = this.stylingSelection();
    if (t.kind !== "within-box") return null;
    const n = this.selectionCharacterStyle(
      t.anchor,
      t.focus
    ).letterSpacing;
    return typeof n == "number" ? n : 0;
  }
  /** The selection's outline width in pt; 0 when it has no outline. */
  effectiveTextStrokeWidth() {
    if (!this.mounted) return null;
    const t = this.stylingSelection();
    if (t.kind !== "within-box") return null;
    const n = this.selectionCharacterStyle(
      t.anchor,
      t.focus
    ).textStrokeWidth;
    return typeof n == "number" ? n : 0;
  }
  stepLetterSpacing(t) {
    if (!this.mounted || !Number.isFinite(t) || t === 0) return !1;
    const n = this.stylingSelection();
    if (n.kind !== "within-box") return !1;
    if (this.isBareCaret(n)) {
      const o = this.format.effectiveAt(n.focus).letterSpacing, r = {
        letterSpacing: pr(
          (typeof o == "number" ? o : 0) + t
        )
      };
      return this.styleEmptyBox(r, n) || this.mergePending(r), !0;
    }
    return this.withAuthorGesture(() => this.stepLetterSpacingFolded(t));
  }
  /**
   * The step on a selection, as one of the person's own gestures like every
   * other style command: inside it the grow fit settles the frame onto text
   * the wider tracking wraps, and the step it records is folded into the
   * gesture's one snapshot, keeping its own coalesce key so a run of steps
   * stays one undo.
   */
  stepLetterSpacingFolded(t) {
    const n = this.stylingSelection();
    if (n.kind !== "within-box") return !1;
    const o = Fe(Be, this.box, n);
    if (!o.ok) return !1;
    const r = this.resolved().blocks, i = this.box, s = Ga(
      i,
      o.target,
      (l, c) => {
        var d, u;
        const a = (u = (d = r[l]) == null ? void 0 : d.runs[c]) == null ? void 0 : u.style.letterSpacing;
        return pr(
          (typeof a == "number" ? a : 0) + t
        );
      }
    );
    return s !== i && (this.box = s, this.stack = Ct(this.stack, {
      undo: () => i,
      redo: () => s,
      coalesceKey: "letter-spacing:step",
      selectionBefore: n,
      selectionAfter: n
    })), this.render("grow"), this.placeRangeAtPos(n.anchor, n.focus), !0;
  }
  effectiveLineHeight() {
    var r;
    if (!this.mounted) return null;
    const t = this.stylingSelection();
    if (t.kind !== "within-box") return null;
    const o = (r = this.resolved().blocks[t.focus.blockIndex]) == null ? void 0 : r.style.lineHeight;
    return typeof o == "number" ? o : null;
  }
  selectionRects(t, n) {
    return this.mounted ? this.caretMap.rangeRects(t, n) : [];
  }
  fieldOutlines() {
    return this.mounted ? Af(this.el, this.box) : [];
  }
  wholeBoxSelection() {
    const t = Math.max(0, this.box.blocks.length - 1), n = this.box.blocks[t];
    return {
      kind: "within-box",
      boxId: this.box.boxId,
      anchor: { blockIndex: 0, offset: 0 },
      focus: {
        blockIndex: t,
        offset: n ? A(n) : 0
      }
    };
  }
  characterStyleActive(t) {
    if (!this.mounted) return !1;
    const n = this.stylingSelection();
    return n.kind !== "within-box" ? !1 : this.deltaActiveOn(
      this.coveredRuns(n.anchor, n.focus),
      n.focus,
      t
    );
  }
  characterStyleTriState(t) {
    if (!this.mounted) return "off";
    const n = this.stylingSelection();
    if (n.kind !== "within-box") return "off";
    const o = this.coveredRuns(n.anchor, n.focus), r = this.paintedStylesOf(o);
    if (r.length === 0)
      return this.deltaActiveOn(o, n.focus, t) ? "on" : "off";
    const i = this.deltaLayer(t), s = Object.keys(i);
    let l = !1, c = !1;
    for (const a of r)
      if (s.every((u) => a[u] === i[u]) ? l = !0 : c = !0, l && c) return "mixed";
    return l ? "on" : "off";
  }
  deltaLayer(t) {
    return be(
      t,
      this.context.refs
    );
  }
  deltaActiveOn(t, n, o) {
    const r = this.deltaLayer(o), i = Object.keys(r), s = this.paintedStylesOf(t);
    if (s.length === 0) {
      const l = this.format.effectiveAt(n);
      return i.every((c) => l[c] === r[c]);
    }
    return i.every((l) => s.every((c) => c[l] === r[l]));
  }
  /**
   * The resolved styles of the covered runs that paint. A table keeps the
   * runs it was inserted with and paints one cell per row the case holds
   * now, so a run past the last row paints nothing and has no say in what
   * the selection reads.
   */
  paintedStylesOf(t) {
    const n = this.resolved().blocks;
    return t.flatMap(({ blockIndex: o, runIndex: r }) => {
      var s;
      const i = (s = n[o]) == null ? void 0 : s.runs[r];
      return i === void 0 ? [] : [i.style];
    });
  }
  coveredRuns(t, n) {
    return ya(this.box, {
      boxId: this.box.boxId,
      anchor: t,
      focus: n
    });
  }
  rememberIfEmptied(t, n) {
    const o = this.box.blocks[n];
    o && A(o) === 0 && this.format.rememberEmptied(
      t,
      On(this.box, n)
    );
  }
  mergePending(t) {
    this.format.merge(t), this.syncCaretColor(), this.syncCaretMetrics();
  }
  resolvedStyleAtPos(t) {
    return !this.mounted || !this.box.blocks[t.blockIndex] ? null : this.format.resolvedAt(t);
  }
  resolvedRunStyle(t, n) {
    var o, r;
    return this.mounted ? ((r = (o = this.resolved().blocks[t]) == null ? void 0 : o.runs[n]) == null ? void 0 : r.style) ?? null : null;
  }
  /**
   * The caret in the colour the next character takes: the armed colour,
   * else the colour at the caret. The caret bar beside a table takes the
   * same colour through EDITOR_TABLE_CARET_COLOR_PROPERTY, and while the
   * bar shows the browser's own caret is transparent.
   */
  syncCaretColor() {
    const t = this.caretColor();
    this.el.style.caretColor = this.tableHighlight.caret !== null ? "transparent" : t, t === "" ? this.el.style.removeProperty(Ne) : this.el.style.setProperty(Ne, t);
  }
  caretColor() {
    const t = this.format.armedLayer().color;
    if (typeof t == "string") return t;
    const n = this.getModelPosition();
    if (n === null) return "";
    const o = this.format.effectiveAt(n).color;
    return typeof o == "string" ? o : "";
  }
  syncCaretMetrics() {
    var s;
    if (this.composing) return;
    const t = (s = this.el.ownerDocument.defaultView) == null ? void 0 : s.getSelection(), n = (t == null ? void 0 : t.focusNode) ?? null;
    if (!n || !this.el.contains(n)) return;
    const o = n.nodeType === 3 ? n.parentElement : n;
    if (!((o == null ? void 0 : o.closest(`[${at}]`)) ?? null)) return;
    const i = this.getModelPosition();
    i !== null && this.paintArmedShapeOnFiller(i) && this.allowingWrites(() => this.fitToBox("grow"));
  }
  handleSelectionChange() {
    var n;
    if (this.composing) return;
    this.fieldHighlight.retireIfStale(), this.ruleHighlight.sync(), this.tableHighlight.sync();
    const t = (n = this.el.ownerDocument.defaultView) == null ? void 0 : n.getSelection();
    !t || t.rangeCount === 0 || !t.focusNode || this.el.contains(t.focusNode) && (this.trail !== null && this.trail.focus !== null && this.followPointer(), !this.enforceTableCover() && (this.enforceFieldCover(), this.syncCaretColor(), this.syncCaretMetrics()));
  }
  /** Whether an end of the browser's selection lies inside a table's block. */
  domEndInsideTable() {
    var n;
    const t = (n = this.el.ownerDocument.defaultView) == null ? void 0 : n.getSelection();
    return !t || t.rangeCount === 0 ? !1 : this.caretMap.tableBlockIndexOf(t.anchorNode) !== null || this.caretMap.tableBlockIndexOf(t.focusNode) !== null;
  }
  /**
   * The table cover: no end of the browser's selection stays inside a
   * table, where the model has no position. A caret inside one (a tap, the
   * browser's own placement) becomes the table selected; a range end inside
   * one moves to the stop the model reads it as, the stop that covers the
   * table, so the band paints the table whole or not at all, as the
   * selection holds it. True when the selection was put back.
   */
  enforceTableCover() {
    var i;
    if (this.composing || !this.mounted) return !1;
    const t = (i = this.el.ownerDocument.defaultView) == null ? void 0 : i.getSelection();
    if (!t || t.rangeCount === 0 || !this.domEndInsideTable()) return !1;
    const { anchorNode: n, focusNode: o } = t;
    if (!n || !o || !this.el.contains(n) || !this.el.contains(o))
      return !1;
    if (t.isCollapsed) {
      const s = this.caretMap.tableBlockIndexOf(o);
      return s !== null && this.selectTable(s);
    }
    const r = this.getModelSelection();
    return r !== null && this.placeRangeAtPos(r.anchor, r.focus);
  }
  enforceFieldCover() {
    var l;
    if (this.coveringFields || this.composing || !this.mounted) return;
    const t = (l = this.el.ownerDocument.defaultView) == null ? void 0 : l.getSelection();
    if (!t || t.rangeCount === 0 || t.isCollapsed) return;
    const { anchorNode: n, focusNode: o } = t;
    if (!n || !o || !this.el.contains(n) || !this.el.contains(o)) return;
    const r = this.getModelSelection();
    if (!r || r.kind !== "within-box") return;
    const i = this.pointerDown && this.pointerClient ? this.fieldSpanAtClientPoint(
      this.pointerClient.x,
      this.pointerClient.y
    ) : null, s = yf(
      {
        pos: r.anchor,
        insideField: this.fieldGlyphInteriorAt(n, t.anchorOffset)
      },
      {
        pos: r.focus,
        insideField: this.fieldGlyphInteriorAt(o, t.focusOffset)
      },
      i,
      this.pointerDown ? this.dragOriginField : null
    );
    if (s) {
      this.coveringFields = !0;
      try {
        this.placeRangeAtPos(s.anchor, s.focus);
      } finally {
        this.coveringFields = !1;
      }
    }
  }
  fieldGlyphInteriorAt(t, n) {
    var i, s;
    if (t.nodeType !== 3) return null;
    const o = (s = (i = t.parentElement) == null ? void 0 : i.closest) == null ? void 0 : s.call(
      i,
      `${B}[${kt}="field"]`
    );
    if (!o || !this.el.contains(o)) return null;
    const r = (t.textContent ?? "").length;
    return Ef(o, n, r) ? this.fieldSpanOf(o) : null;
  }
  fieldSpanAtClientPoint(t, n) {
    var i;
    const o = this.el.ownerDocument.elementFromPoint(t, n), r = (i = o == null ? void 0 : o.closest) == null ? void 0 : i.call(
      o,
      `${B}[${kt}="field"]`
    );
    return !r || !this.el.contains(r) ? null : this.fieldSpanOf(r);
  }
  /**
   * The field a run span paints, as caret offsets in its line; null for a
   * span that paints no field, and for a field in a table's cell, which a
   * caret never enters: the table is selected whole.
   */
  fieldSpanOf(t) {
    var l;
    const n = this.caretMap.blockAncestorOf(t);
    if (!n) return null;
    const o = Number(n.dataset[Et]), r = Number(t.dataset[ct]);
    if (!Number.isInteger(o) || !Number.isInteger(r))
      return null;
    const i = this.box.blocks[o];
    if (i === void 0 || C(i.kind) || ((l = i.runs[r]) == null ? void 0 : l.kind) !== "field") return null;
    const s = yt(i, r);
    return { blockIndex: o, start: s, end: s + 1 };
  }
  /**
   * The style the caret was armed with, applied to the characters just
   * inserted. It runs inside the gesture that inserted them: the insert's
   * own fit measured the box BEFORE this style reached the new run, so the
   * fit that follows here is the first to see what the person's armed size
   * actually costs, and it is the one that must settle the frame onto it. Left
   * outside, it would be a fit that cannot move the frame, and the box's
   * existing text would be shrunk to make room for the armed character — with the
   * shrink then folded into the sizes by the next keystroke.
   */
  applyPendingTo(t, n, o) {
    n.offset <= t.offset || this.allowingWrites(() => this.applyPendingToNow(t, n, o));
  }
  applyPendingToNow(t, n, o) {
    const r = {
      kind: "within-box",
      boxId: this.box.boxId,
      anchor: t,
      focus: n
    }, i = Fe(Be, this.box, r);
    if (!i.ok) return;
    const s = te(
      this.box,
      { kind: "set-character-style", delta: o },
      i.target,
      this.stack,
      { selectionBefore: r, selectionAfter: this.caretSelection(n) }
    );
    this.box = s.box, this.stack = ht(s.stack), this.render("grow"), this.placeCaretAtPos(n);
  }
  /**
   * Typed text at the entry point, the caret after it: a range the text
   * replaces goes in the same history step, and a style armed at the caret
   * lands on the text, on its new line when the text opened one beside a
   * table.
   */
  enterTypedText(t) {
    const { pos: n, replacing: o } = this.entryPointOrRecovery(), r = this.box.blocks[n.blockIndex], i = w(r.kind), s = i || A(r) === 0, l = $e(this.box, n, t), c = l.caretAfter;
    this.applyContentEdit(l, n, c), o && (this.stack = ht(this.stack, "latest-key"));
    const a = this.format.takeForInsert({
      blockWasEmpty: s,
      replacing: o,
      containerId: On(this.box, c.blockIndex)
    });
    a && (this.syncCaretColor(), this.syncCaretMetrics(), this.applyPendingTo(
      i ? { blockIndex: c.blockIndex, offset: 0 } : n,
      c,
      a
    )), vd(t, this.context.locale) && this.seal("word-boundary");
  }
  /** Enter at the entry point: a new line, the caret at its start. */
  enterSplit() {
    const { pos: t, replacing: n } = this.entryPointOrRecovery(), o = ce(this.box, t, this.format.carriedAt(t));
    this.applyContentEdit(o, t, o.caretAfter), n && (this.stack = ht(this.stack, "latest-key")), this.seal("split-block");
  }
  /**
   * Backspace at a caret, as the model deletes backward from it. A
   * character or field it takes from the caret's own line leaves its style
   * to the next keystroke when the line is left empty.
   */
  deleteBackwardAt(t) {
    const n = this.box.blocks[t.blockIndex], o = !C(n.kind) && t.offset > 0, r = this.format.carriedAt(t), i = he(this.box, t);
    this.applyContentEdit(i, t, i.caretAfter), o && this.rememberIfEmptied(r, t.blockIndex);
  }
  /**
   * Delete at a caret, as the model deletes forward from the last of the
   * stops painted where the caret is, so a stop that paints nothing after
   * the caret goes first. While the delete takes what follows the caret in
   * its own line the caret stays where it stood, and the line left empty
   * keeps the style for the next keystroke.
   */
  deleteForwardAt(t) {
    var c;
    const n = (c = this.projectionIndex) == null ? void 0 : c.blocks[t.blockIndex], o = n ? {
      blockIndex: t.blockIndex,
      offset: n.toModel(n.toProjected(t.offset), "right")
    } : t, r = this.box.blocks[t.blockIndex], i = !C(r.kind) && o.offset < A(r), s = this.format.carriedAt(t), l = Je(this.box, o);
    this.applyContentEdit(l, t, i ? t : l.caretAfter), i && this.rememberIfEmptied(s, t.blockIndex);
  }
  handleBeforeInput(t) {
    if (this.composing) return;
    const n = Rn(t.inputType);
    if (n.kind !== "edit-action") {
      n.kind !== "composition" && t.cancelable && t.preventDefault();
      return;
    }
    if (n.action === "delete-text") {
      if (this.printableEvidence() !== null) {
        const r = this.getModelSelection();
        if (r === null || D(r)) {
          t.preventDefault();
          return;
        }
      }
      const o = this.getModelSelection();
      if (o !== null && !D(o)) {
        t.preventDefault();
        const r = this.format.carriedAt(o.anchor), i = this.applyRangeDelete(o);
        this.rememberIfEmptied(r, i.blockIndex), this.seal("edit-boundary");
        return;
      }
    }
    if (!n.supported) {
      t.cancelable && t.preventDefault();
      return;
    }
    if (n.action === "insert-text" || n.action === "insert-hard-break") {
      t.preventDefault();
      const o = t.data ?? "", r = this.printableEvidence(), i = t.inputType === "insertText" && r !== null && o !== r ? r : o, s = n.action === "insert-hard-break" ? `
` : rn(i);
      if (s === "" && i !== "")
        return;
      this.enterTypedText(s);
    } else if (n.action === "split-block")
      t.preventDefault(), this.enterSplit();
    else if (n.action === "delete-text") {
      const o = this.getModelPosition();
      if (o === null) {
        t.cancelable && t.preventDefault();
        return;
      }
      if (t.inputType === "deleteContentForward")
        t.preventDefault(), this.deleteForwardAt(o);
      else if (t.inputType === "deleteContentBackward")
        t.preventDefault(), this.deleteBackwardAt(o);
      else if (Kr[t.inputType]) {
        t.preventDefault();
        const { direction: r, granularity: i } = Kr[t.inputType], s = this.extendCaretByUnit(r, i);
        if (s) {
          const l = this.format.carriedAt(o), c = this.applyRangeDelete(s);
          this.rememberIfEmptied(l, c.blockIndex), this.seal("edit-boundary");
        } else r === "backward" ? o.offset === 0 && this.deleteBackwardAt(o) : o.offset >= A(this.box.blocks[o.blockIndex]) && this.deleteForwardAt(o);
      } else t.cancelable && t.preventDefault();
    } else if (n.action === "apply-mark" || n.action === "set-block-property") {
      const o = Me[t.inputType];
      if (o) {
        t.preventDefault(), this.applyCharacterToggle(o.on, o.off);
        return;
      }
      const r = $f[t.inputType];
      if (!r) {
        t.cancelable && t.preventDefault();
        return;
      }
      t.preventDefault(), this.applyStyle(r);
    } else n.action === "paste" && t.preventDefault();
  }
  handleKeydown(t) {
    if (t.isComposing || this.composing) {
      jr(t) && t.preventDefault();
      return;
    }
    if (this.recentPrintableKey = null, this.lastPrintableKey = t.key.length === 1 && !t.ctrlKey && !t.metaKey ? t.key : null, (t.ctrlKey || t.metaKey) && !t.shiftKey && !t.altKey && t.key.toLowerCase() === "a") {
      t.preventDefault(), t.stopPropagation(), this.selectAllGesture();
      return;
    }
    if ((t.ctrlKey || t.metaKey) && t.shiftKey && !t.altKey && t.key.toLowerCase() === "x") {
      const o = Rn("formatStrikeThrough");
      o.kind === "edit-action" && o.supported && Me.formatStrikeThrough && (t.preventDefault(), t.stopPropagation(), this.applyCharacterToggle(
        Me.formatStrikeThrough.on,
        Me.formatStrikeThrough.off
      ));
      return;
    }
    const n = jr(t);
    if (n) {
      const o = Rn(n);
      o.kind === "edit-action" && o.supported && (t.preventDefault(), this.performHistory(o.action === "undo" ? "undo" : "redo"));
      return;
    }
    this.handleTableKey(t) || zf.has(t.key) && this.seal("caret-jump");
  }
  /**
   * A key at a table, taken here instead of by the browser: the answer
   * `resolveEditorTableKey` gives for the selection, applied. A key whose
   * answer is a composition goes on to the input method, into the line
   * opened for it; every other key the table takes is prevented. True
   * when the key was the table's.
   */
  handleTableKey(t) {
    var r;
    const n = this.getModelSelection();
    if (n === null) return !1;
    const o = Ud(this.box, n, {
      key: t.keyCode === 229 ? "Process" : t.key,
      shiftKey: t.shiftKey,
      altKey: t.altKey,
      metaKey: t.metaKey,
      ctrlKey: t.ctrlKey,
      altGraph: t.getModifierState("AltGraph"),
      macOS: ph((r = this.el.ownerDocument.defaultView) == null ? void 0 : r.navigator)
    });
    return o.kind === "native" ? !1 : (o.kind !== "compose" && t.preventDefault(), this.applyTableKey(o), !0);
  }
  applyTableKey(t) {
    switch (t.kind) {
      case "caret":
        this.seal("caret-jump"), this.placeCaretAtPos(t.to);
        return;
      case "select":
        this.seal("table-gesture"), this.placeRangeAtPos(t.anchor, t.focus);
        return;
      case "line":
        this.seal("caret-jump"), this.moveByLineBeside(t);
        return;
      case "edit":
        this.applyKeyEdit(t.edit, t.selectionBefore);
        return;
      case "split":
        this.enterSplit();
        return;
      case "text": {
        const n = rn(t.text);
        n !== "" && this.enterTypedText(n);
        return;
      }
      case "compose":
        this.openLineForComposition();
    }
  }
  /**
   * A delete a key makes at a table. One that removes a selection, or a
   * table, is a history step of its own whose undo puts back
   * `selectionBefore`, the table selected when a table went, and a line it
   * leaves empty keeps the removed text's style for the next keystroke.
   */
  applyKeyEdit(t, n) {
    if (D(n)) {
      this.applyContentEdit(t, n.focus, t.caretAfter);
      return;
    }
    const [o] = V(
      n.anchor,
      n.focus
    ), r = this.format.carriedAt(o);
    this.seal("edit-boundary"), this.applyContentEdit(t, n, t.caretAfter), this.rememberIfEmptied(r, t.caretAfter.blockIndex), this.seal("edit-boundary");
  }
  /**
   * ArrowDown or ArrowUp from a line beside a table. From any painted line
   * of it but its edge one (its last going down, its first going up) the
   * browser moves the caret a line, or with Shift extends a line, as it
   * does anywhere. From the edge line the browser's own move would pass
   * over the table, or not move at all where the table ends the box, so the
   * caret goes to the table's near stop instead, or with Shift the focus
   * goes to its far stop and the table is covered. The edge line is the one
   * whose painted boundary is the line's own end, or start: the caret is
   * moved to its painted line's boundary to see, and put back.
   */
  moveByLineBeside(t) {
    const n = this.getModelSelection();
    if (n === null) return;
    const o = this.modifiableSelection();
    if (o !== null && o.focusNode !== null) {
      o.collapse(o.focusNode, o.focusOffset), o.modify("move", t.direction, "lineboundary");
      const r = this.getModelPosition();
      this.placeRangeAtPos(n.anchor, n.focus);
      const i = this.box.blocks[t.within];
      if (!(r !== null && r.blockIndex === t.within && (t.direction === "forward" ? r.offset >= A(i) : r.offset === 0))) {
        o.modify(t.extend ? "extend" : "move", t.direction, "line");
        return;
      }
    }
    t.extend ? this.placeRangeAtPos(n.anchor, t.stop) : this.placeCaretAtPos(t.stop);
  }
  /** The browser's selection, when it holds a range and can be moved by unit. */
  modifiableSelection() {
    var n;
    const t = (n = this.el.ownerDocument.defaultView) == null ? void 0 : n.getSelection();
    return !t || t.rangeCount === 0 || typeof t.modify != "function" ? null : t;
  }
  /**
   * A composition starting at a table's stop, or with a table selected: the
   * line its text belongs on opens first, on the stop's side and below the
   * table selected, with the caret in it, so the input method composes in
   * that line and never beside the table.
   */
  openLineForComposition() {
    const t = this.entryPoint();
    if (t === null) return;
    const n = ce(
      this.box,
      t.pos,
      this.format.carriedAt(t.pos)
    );
    this.applyContentEdit(n, t.pos, n.caretAfter), this.seal("split-block"), this.composeLineStep = this.stack.steps[this.stack.cursor - 1] ?? null;
  }
  /**
   * A cut of a selection that holds a table or ends at a table's stop.
   * Chromium fills the clipboard there but deletes nothing, so the host does
   * both: the selection's painted text goes on the clipboard as plain text,
   * and the selection is deleted through the model, the table with it.
   * Every other cut is the browser's.
   */
  handleCut(t) {
    if (this.composing || t.clipboardData === null) return;
    const n = this.getModelSelection();
    if (n === null || D(n)) return;
    const [o, r] = V(n.anchor, n.focus);
    if (!(Ui(this.box, n).length > 0 || Wt(this.box, o) !== null || Wt(this.box, r) !== null)) return;
    t.preventDefault(), t.clipboardData.setData("text/plain", this.selectedPlainText(n));
    const s = this.format.carriedAt(o), l = this.applyRangeDelete(n);
    this.rememberIfEmptied(s, l.blockIndex), this.seal("edit-boundary");
  }
  /**
   * The selection's text as the browser reads it off the paint, a table's
   * cells tab-separated row by row, less the ghost of an empty field; a
   * table selected alone reads as its rows, without the line breaks the
   * browser puts around a block.
   */
  selectedPlainText(t) {
    var o, r;
    const n = (((r = (o = this.el.ownerDocument.defaultView) == null ? void 0 : o.getSelection()) == null ? void 0 : r.toString()) ?? "").split(Ni).join("");
    return Yt(this.box, t) === null ? n : n.replace(/^\n+|\n+$/g, "");
  }
  performHistory(t) {
    var r, i;
    const n = t === "undo" ? Ja(this.stack, this.box) : Za(this.stack, this.box), o = { width: this.box.width, height: this.box.height };
    this.box = _a(n.box, this.box), this.frameFloorPx = Math.min(this.frameFloorPx, this.box.height), this.stack = n.stack, (this.box.width !== o.width || this.box.height !== o.height) && ((i = (r = this.hooks) == null ? void 0 : r.onFrameChange) == null || i.call(r, this.box.width, this.box.height)), this.render("hold"), this.restoreSelection(n.selection);
  }
  handlePaste(t) {
    t.preventDefault();
    const n = t.clipboardData;
    if (!n) return;
    const o = Xr({
      html: n.getData("text/html"),
      text: n.getData("text/plain")
    });
    o && (this.seal("paste"), this.withAuthorGesture(() => this.pasteClean(o)));
  }
  pasteClean(t) {
    const n = this.stack.cursor, o = this.entryPoint();
    if (o === null) return;
    this.insertBlockAwareTextAt(o.pos, t);
    const r = this.stack.cursor - n;
    for (let i = 1; i < r; i += 1)
      this.stack = ht(this.stack);
    this.stack = Qt(this.stack);
  }
  /**
   * Text of several lines at a position: each line after the first on a
   * line of its own. At a table's stop the first line opens a line beside
   * the table, and the rest follow it on that side.
   */
  insertBlockAwareTextAt(t, n) {
    const o = n.split(`
`);
    let r = t;
    const i = A(this.box.blocks[t.blockIndex]) === 0, s = this.format.takeForInsert({
      blockWasEmpty: i,
      replacing: !1,
      containerId: On(this.box, t.blockIndex)
    }), l = (c) => {
      if (!c) return;
      const a = w(
        this.box.blocks[r.blockIndex].kind
      ), d = $e(this.box, r, c), u = d.caretAfter;
      this.applyContentEdit(d, r, u), s && this.applyPendingTo(
        a ? { blockIndex: u.blockIndex, offset: 0 } : r,
        u,
        s
      ), r = u;
    };
    l(o[0]);
    for (const c of o.slice(1)) {
      const a = ce(this.box, r);
      this.applyContentEdit(a, r, a.caretAfter), r = a.caretAfter, l(c);
    }
    return r;
  }
  /**
   * A drag of the box's own text moves it on drop. A case field never
   * drags: the drop lands as plain text, which would turn the field into
   * its value. A drag that starts on a field span, or whose selection
   * covers a field run, is refused before the browser begins it.
   */
  handleDragStart(t) {
    const n = this.getModelSelection(), o = t.target instanceof Element ? t.target : null, r = this.dragOriginField !== null || (o == null ? void 0 : o.closest(`[${kt}="field"]`)) !== null, i = n !== null && !D(n) && this.coveredRuns(n.anchor, n.focus).some(
      ({ blockIndex: s, runIndex: l }) => {
        var c, a;
        return ((a = (c = this.box.blocks[s]) == null ? void 0 : c.runs[l]) == null ? void 0 : a.kind) === "field";
      }
    );
    if (r || i) {
      t.preventDefault(), this.dragSource = null;
      return;
    }
    this.dragSource = n !== null && !D(n) ? n : null;
  }
  handleDragOver(t) {
    t.cancelable && t.preventDefault(), t.dataTransfer && (t.dataTransfer.dropEffect = this.dragSource ? "move" : "copy");
  }
  handleDrop(t) {
    if (this.composing) return;
    t.cancelable && t.preventDefault();
    const n = t.dataTransfer, o = this.dragSource;
    if (this.dragSource = null, !n) return;
    const r = Xr({
      html: n.getData("text/html"),
      text: n.getData("text/plain")
    });
    if (!r) return;
    const i = this.caretMap.fromClientPoint(t.clientX, t.clientY);
    i && (this.seal("drag-drop"), this.withAuthorGesture(() => this.dropClean(r, i, o)));
  }
  dropClean(t, n, o) {
    const r = this.stack.cursor;
    let i = n;
    if (o) {
      const [l, c] = V(o.anchor, o.focus);
      if (P(n, l) >= 0 && P(n, c) <= 0)
        return;
      const a = this.box;
      this.applyRangeDelete(o, !0), i = ma(a, n, l, c);
    }
    this.insertBlockAwareTextAt(i, t);
    const s = this.stack.cursor - r;
    for (let l = 1; l < s; l += 1)
      this.stack = ht(this.stack);
    this.stack = Qt(this.stack);
  }
  /**
   * The composition's anchor is the entry point: a range it replaces is
   * deleted first, and a table selected is never replaced, the composed
   * text going on a new line below it; at a table's stop it goes on a new
   * line on that side. An input method's keydown opens that line before
   * the composition starts (`openLineForComposition`); one that starts
   * composing with no keydown reaches here with no line opened for it.
   */
  handleCompositionStart() {
    const t = this.entryPoint();
    t !== null && (this.composeAnchor = t.pos, this.composeReplaced = t.replacing, this.composing = !0);
  }
  handleCompositionEnd(t) {
    if (!this.composing) return;
    this.composing = !1;
    const n = this.composeReplaced;
    this.composeReplaced = !1;
    const o = this.composeLineStep !== null && this.stack.cursor === this.stack.steps.length && this.stack.steps[this.stack.cursor - 1] === this.composeLineStep;
    this.composeLineStep = null;
    const r = t.data ?? "", i = this.composeAnchor, s = r;
    if (s === "") {
      this.render("grow"), this.placeCaretAtPos(i), n && this.seal("composition-end");
      return;
    }
    const l = this.stack.cursor, c = $e(this.box, i, s);
    this.applyContentEdit(c, i, c.caretAfter);
    const a = this.stack.cursor > l;
    (n || o && a) && (this.stack = ht(this.stack, "latest-key")), this.seal("composition-end");
  }
};
x(sn, "PRINTABLE_EVIDENCE_TAIL_MS", 200);
let eo = sn;
const ni = "editor-text-box-stylesheet", mh = (e) => e ?? (typeof document < "u" ? document : null), bh = (e, t) => {
  const n = mh(t);
  if (!(n != null && n.head)) return;
  let o = n.getElementById(ni);
  o || (o = n.createElement("style"), o.id = ni, o.setAttribute(Jc, ""), n.head.appendChild(o)), o.textContent !== e && (o.textContent = e);
}, Dn = { fontWeight: "700" }, xh = { fontWeight: "400" }, Bn = { fontStyle: "italic" }, kh = { fontStyle: "normal" }, Mn = {
  textDecoration: "underline"
}, Nn = {
  textDecoration: "line-through"
}, oi = { textDecoration: "none" }, dp = (e, t, n = {}) => {
  const o = new eo(e, t, {
    onRefit: n.onRefit,
    onDragStateChange: n.onDragStateChange,
    onFrameChange: n.onFrameChange,
    isStylingChrome: n.isStylingChrome
  });
  n.fonts !== void 0 && bh(
    ta(n.fonts),
    e.ownerDocument
  ), n.frame !== void 0 && o.setInternalRect(n.frame.width, n.frame.height), o.mount();
  const r = () => je(o.sourceForSave());
  return {
    model: () => o.model,
    document: r,
    liveDocument: () => je(o.source()),
    toInput: () => Pc(r()),
    isEmpty: () => Hn(o.model),
    setRevision: (i) => o.setRevision(i),
    setCaseData: (i) => o.setCaseData(i),
    setContext: (i) => o.setContext(i),
    setLocale: (i) => o.setLocale(i),
    setTextSizing: (i, s) => o.setTextSizing(i, s),
    setInternalRect: (i, s) => o.setInternalRect(i, s),
    beginResize: (i) => o.beginResize(i),
    resizeTo: (i, s) => o.resizeTo(i, s),
    endResize: (i, s) => o.endResize(i, s),
    inkRect: () => o.inkRect,
    inkClusters: () => o.inkClusters,
    textHeightPx: () => o.textHeightPx,
    paintedHeightPx: () => o.paintedHeightPx,
    fontFitScale: () => o.fontFitScale(),
    overflowing: () => o.overflowing(),
    fitExplanation: () => o.fitExplanation(),
    describeBoxLayout: () => o.describeBoxLayout(),
    toggleBold: () => o.applyCharacterToggle(Dn, xh),
    toggleItalic: () => o.applyCharacterToggle(Bn, kh),
    toggleUnderline: () => o.applyCharacterToggle(Mn, oi),
    toggleStrikethrough: () => o.applyCharacterToggle(Nn, oi),
    toggleStates: () => ({
      bold: o.characterStyleActive(Dn),
      italic: o.characterStyleActive(Bn),
      underline: o.characterStyleActive(Mn),
      strikethrough: o.characterStyleActive(Nn)
    }),
    toggleTriStates: () => ({
      bold: o.characterStyleTriState(Dn),
      italic: o.characterStyleTriState(Bn),
      underline: o.characterStyleTriState(Mn),
      strikethrough: o.characterStyleTriState(Nn)
    }),
    applyStyle: (i) => o.applyStyle(i),
    stepFontSize: (i) => o.stepFontSize(i),
    setFontSize: (i, s) => o.setFontSize(i, (s == null ? void 0 : s.collapsed) ?? "arm"),
    stepLetterSpacing: (i) => o.stepLetterSpacing(i),
    fontSizePt: () => o.fontSizePt(),
    fontSizeReadout: () => o.fontSizeReadout(),
    colorReadout: () => o.colorReadout(),
    effectiveFontFamily: () => o.effectiveFontFamily(),
    effectiveLetterSpacing: () => o.effectiveLetterSpacing(),
    effectiveTextStrokeWidth: () => o.effectiveTextStrokeWidth(),
    effectiveLineHeight: () => o.effectiveLineHeight(),
    selectionRects: (i, s) => o.selectionRects(i, s),
    fieldOutlines: () => o.fieldOutlines(),
    getModelPosition: () => o.getModelPosition(),
    getModelSelection: () => o.getModelSelection(),
    placeCaretAtClientPoint: (i, s) => o.placeCaretAtClientPoint(i, s),
    placeCaretAtPos: (i) => o.placeCaretAtPos(i),
    placeRangeAtPos: (i, s) => o.placeRangeAtPos(i, s),
    undo: () => o.historyGesture("undo"),
    redo: () => o.historyGesture("redo"),
    selectAll: () => o.selectAllGesture(),
    insertField: (i, s, l) => o.insertField(i, s, l),
    insertFieldParagraphs: (i, s) => o.insertFieldParagraphs(i, s),
    insertRule: () => o.insertRule(),
    insertCaseDetailTable: (i, s, l) => o.insertCaseDetailTable(i, s, l),
    fieldRun: (i) => o.fieldRun(i),
    fieldRunAt: (i, s) => o.fieldRunAt(i, s),
    selectFieldRun: (i, s) => o.selectFieldRun(i, s),
    fieldRunSelection: () => o.fieldRunSelection,
    selectRule: (i) => o.selectRule(i),
    ruleSelection: () => o.ruleSelection,
    tableSelection: () => o.tableSelection,
    tableCaret: () => o.tableCaret,
    setFieldParams: (i, s, l = 0, c) => o.setFieldParams(i, s, l, c),
    resolvedStyleAtPos: (i) => o.resolvedStyleAtPos(i),
    resolvedRunStyle: (i, s) => o.resolvedRunStyle(i, s),
    setParagraphRole: (i) => o.setParagraphRole(i),
    paragraphRole: () => o.paragraphRole(),
    paragraphRange: () => o.paragraphRange(),
    convertFieldToText: (i, s) => o.convertFieldToText(i, s),
    convertAllFieldsToText: () => o.convertAllFieldsToText(),
    fieldRunCount: () => o.fieldRunCount(),
    destroy: () => o.destroy()
  };
}, yh = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i, Sh = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*[\d.]+\s*)?\)$/i, ne = (e) => {
  const t = e.trim(), n = yh.exec(t);
  if (n) {
    const r = n[1].length === 3 ? n[1].split("").map((i) => i + i).join("") : n[1];
    return {
      kind: "literal",
      colorSpace: "srgb",
      components: [0, 2, 4].map((i) => parseInt(r.slice(i, i + 2), 16)),
      alphaOnCmykStrategy: "flatten_on_white"
    };
  }
  const o = Sh.exec(t);
  return o ? {
    kind: "literal",
    colorSpace: "srgb",
    components: [o[1], o[2], o[3]].map((r) => Math.min(255, Number(r))),
    alphaOnCmykStrategy: "flatten_on_white"
  } : t === "transparent" ? { kind: "transparent" } : t.toLowerCase() === "currentcolor" ? { kind: "current_color" } : {
    kind: "literal",
    colorSpace: "named",
    components: [],
    verbatim: t,
    alphaOnCmykStrategy: "flatten_on_white"
  };
}, up = {
  x: 2,
  y: 2,
  blur: 4,
  color: "#000000",
  opacity: 0.5
}, fp = {
  bold: {
    kind: "set-character-style",
    delta: { fontWeight: "700" }
  },
  italic: {
    kind: "set-character-style",
    delta: { fontStyle: "italic" }
  },
  color: (e) => ({
    kind: "set-character-style",
    delta: { color: ne(e) }
  }),
  fontSize: (e) => ({
    kind: "set-character-style",
    delta: { fontSize: e }
  }),
  fontFamily: (e) => ({
    kind: "set-character-style",
    delta: { fontFamily: e }
  }),
  align: (e) => ({
    kind: "set-block-style",
    delta: { textAlign: e }
  }),
  /** The box's own, not a block's: where its text sits in its frame. */
  verticalAlign: (e) => ({
    kind: "set-box-style",
    delta: { verticalAlign: e }
  }),
  lineSpacing: (e) => ({
    kind: "set-block-style",
    delta: { lineHeight: e }
  }),
  underline: {
    kind: "set-character-style",
    delta: { textDecoration: "underline" }
  },
  strikethrough: {
    kind: "set-character-style",
    delta: { textDecoration: "line-through" }
  },
  letterSpacing: (e) => ({
    kind: "set-character-style",
    delta: { letterSpacing: e }
  }),
  textCase: (e) => ({
    kind: "set-character-style",
    delta: { textCase: e }
  }),
  textStrokeWidth: (e) => ({
    kind: "set-character-style",
    delta: { textStrokeWidth: e }
  }),
  textStrokeColor: (e) => ({
    kind: "set-character-style",
    delta: { textStrokeColor: ne(e) }
  }),
  textOutline: (e, t) => ({
    kind: "set-character-style",
    delta: t === void 0 ? { textStrokeWidth: e } : {
      textStrokeWidth: e,
      textStrokeColor: ne(t)
    }
  }),
  textDecorationColor: (e) => ({
    kind: "set-character-style",
    delta: { textDecorationColor: ne(e) }
  }),
  textFillColor: (e) => ({
    kind: "set-character-style",
    delta: { textFillColor: ne(e) }
  }),
  /** The box's one text shadow; null removes it. */
  textShadow: (e) => ({
    kind: "set-box-style",
    delta: { textShadow: e }
  })
}, xl = (e) => e.querySelector(fo) ?? e, hp = (e, t) => {
  const { resolvedClasses: n, sizing: o, growth: r = !1, ...i } = t;
  n && bl(n, e.ownerDocument);
  const s = xl(e);
  al(s);
  const c = new Vo(s).fit({ growth: r, sizing: o, overrides: i }), a = kl(s);
  return a && (a.style.overflow = c.overflowing ? "hidden" : "visible"), c;
}, pp = (e, t) => {
  const n = xl(e);
  new Vo(n).previewCornerScale(t), n.style.overflow = "visible";
  const o = kl(n);
  o && (o.style.overflow = "visible");
}, kl = (e) => {
  var n;
  const t = ((n = e.parentElement) == null ? void 0 : n.closest(Li)) ?? null;
  return t && t.querySelectorAll(fo).length === 1 ? t : null;
}, Eh = (e) => {
  if (e.length === 0) return null;
  let t = 1 / 0, n = 1 / 0, o = -1 / 0, r = -1 / 0;
  for (const i of e)
    i.x < t && (t = i.x), i.y < n && (n = i.y), i.x + i.width > o && (o = i.x + i.width), i.y + i.height > r && (r = i.y + i.height);
  return { x: t, y: n, width: o - t, height: r - n };
}, Ih = (e) => {
  const t = [], n = /* @__PURE__ */ new Map();
  for (const o of e) {
    const r = n.get(o.block);
    r ? r.push(o) : n.set(o.block, [o]);
  }
  for (const [o, r] of n)
    ve(
      r.map((s) => ({
        top: s.advance.y,
        bottom: s.advance.y + s.advance.height
      }))
    ).forEach((s, l) => {
      const c = s.map((d) => r[d]), a = Eh(c.map((d) => d.advance));
      a && t.push({
        block: o,
        index: l,
        rect: a,
        text: c.map((d) => d.text).join("")
      });
    });
  return t;
}, vh = 2166136261, wh = 16777619, gp = (e) => {
  let t = vh;
  for (let n = 0; n < e.length; n += 1)
    t ^= e.charCodeAt(n), t = Math.imul(t, wh) >>> 0;
  return t.toString(16).padStart(8, "0");
}, Rh = (e) => {
  const t = e.defaultView;
  if (!t || typeof t.CanvasRenderingContext2D != "function") return null;
  try {
    const n = e.createElement("canvas").getContext("2d");
    return n && typeof n.measureText == "function" ? n : null;
  } catch {
    return null;
  }
}, Th = (e) => {
  const t = e.fonts;
  if (!t || typeof t.has != "function") return null;
  try {
    return ou(t);
  } catch {
    return null;
  }
}, mp = (e, t) => {
  const n = e.ownerDocument, o = n == null ? void 0 : n.defaultView;
  if (!o) return null;
  const r = Rh(n);
  if (!r) return null;
  let i;
  try {
    i = e.getBoundingClientRect();
  } catch {
    return null;
  }
  const s = e.offsetWidth;
  if (!(i.width > 0) || !(s > 0)) return null;
  const l = i.width / s;
  if (!(Number.isFinite(l) && l > 0)) return null;
  const c = Io, a = Th(n), d = /* @__PURE__ */ new Map(), u = [];
  let f = !0;
  for (const { block: g, node: b } of t) {
    const p = b.data;
    if (p === "") continue;
    const h = b.parentElement;
    if (!h) continue;
    const m = o.getComputedStyle(h), k = Number.parseFloat(m.fontSize);
    if (!(k > 0)) {
      f = !1;
      continue;
    }
    const E = `${m.fontStyle} ${m.fontWeight} ${m.fontSize} ${m.fontFamily}`;
    r.font = E;
    const S = r.measureText(p), y = S.fontBoundingBoxAscent, v = S.fontBoundingBoxDescent, T = Number.isFinite(y) && Number.isFinite(v) ? y - v : null, Y = {
      style: m.fontStyle,
      weight: m.fontWeight,
      family: m.fontFamily
    }, L = (j) => {
      if (a === null) return null;
      const ft = `${E}\0${j}`, q = d.get(ft);
      if (q !== void 0) return q;
      const F = au(
        n.fonts,
        a,
        m.fontFamily,
        j
      );
      return d.set(ft, F), F;
    }, R = [{ node: b, start: 0, end: p.length }];
    let z = 0;
    for (const j of $(p)) {
      const ft = z;
      z += j.length;
      const q = Xs(n, R, ft, z);
      if (!q) continue;
      const F = {
        x: (q.left - i.left) / l,
        y: (q.top - i.top) / l,
        width: (q.right - q.left) / l,
        height: (q.bottom - q.top) / l
      };
      let mt = null;
      if (j.trim() !== "") {
        const M = qs(n, Y, j);
        if (!M || T === null) f = !1;
        else if (M.at[0].ink || M.at[1].ink) {
          const st = Js(M, k, c), Ot = F.y + (F.height + T) / 2;
          mt = {
            x: F.x - st.left,
            y: Ot - st.up,
            width: st.left + st.right,
            height: st.up + st.down
          };
        }
      }
      u.push({
        block: g,
        text: j,
        family: m.fontFamily,
        weight: m.fontWeight,
        style: m.fontStyle,
        sizePx: k,
        loaded: L(j),
        advance: F,
        ink: mt
      });
    }
  }
  return { zoom: l, glyphs: u, lines: Ih(u), complete: f };
};
export {
  sr as EDITOR_AUTOSIZE_GRACE_PX,
  Ee as EDITOR_AUTOSIZE_MIN_PT,
  Se as EDITOR_BASE_PT_ATTR,
  Et as EDITOR_BLOCK_ORDINAL_DATASET_KEY,
  kp as EDITOR_BOX_SIZING_VALUES,
  zn as EDITOR_BOX_STYLING_KEYS,
  Ra as EDITOR_BOX_TEXT_SIZING_COLUMNS,
  yp as EDITOR_BYTE_ORDER_MARK,
  Mi as EDITOR_CASE_DETAIL_ATTR,
  Ve as EDITOR_CASE_DETAIL_TABLE_BLOCK_CLASS_NAME,
  Sp as EDITOR_CHARACTER_CLASS_ROWS,
  Ep as EDITOR_COLLAPSIBLE_PAIRS,
  Ip as EDITOR_CONTENT_ROLE_VALUES,
  vp as EDITOR_DEBRIS_PUNCTUATION,
  wp as EDITOR_DEFAULT_NAME_ORDER,
  ql as EDITOR_EMITTED_SURFACE_DISPOSITIONS,
  $i as EDITOR_EMOJI_CLUSTER_ATTR,
  Ke as EDITOR_EMPTY_BLOCK_STRUT_PT,
  un as EDITOR_EMPTY_FIELD_ATTR,
  Ni as EDITOR_EMPTY_FIELD_GHOST_CHAR,
  Ya as EDITOR_EMPTY_HISTORY,
  Rp as EDITOR_FIELD_CATALOG,
  Tp as EDITOR_FIELD_FINAL_RESTING,
  Ap as EDITOR_FIELD_KEYS,
  Cp as EDITOR_FIELD_NAME_OF_DECEASED,
  Sn as EDITOR_FIELD_RUN_SELECTED_ATTR,
  Fp as EDITOR_FIELD_SERVICE_COLUMN,
  at as EDITOR_FILLER_ATTR,
  Eo as EDITOR_FIT_HEIGHT_TOL_PX,
  Vc as EDITOR_FIT_SCALE_ATTR,
  bo as EDITOR_FIT_SCALE_DATASET_KEY,
  Aa as EDITOR_FIT_WRITE_THRESHOLD,
  Rl as EDITOR_FLOOR_BLOCK_SEED,
  Pp as EDITOR_FLOOR_BOX_SEED,
  xt as EDITOR_FLOOR_CHARACTER_SEED,
  Xl as EDITOR_FLOOR_CONSTANTS,
  xn as EDITOR_FONT_SETTLE_TIMEOUT_MS,
  _p as EDITOR_HAIR_SPACE,
  Yc as EDITOR_INK_ESCAPE_ATTR,
  tr as EDITOR_INK_ESCAPE_DATASET_KEY,
  Lp as EDITOR_LAYER_CAPABILITY,
  Gc as EDITOR_LEGACY_CHROME_ATTR,
  Ue as EDITOR_LITERAL_GRID_BLOCK_CLASS_NAME,
  ui as EDITOR_LOCALE_FLOOR,
  Op as EDITOR_MAX_BLOCKS_PER_BOX,
  Dp as EDITOR_MAX_RUNS_PER_BLOCK,
  Bp as EDITOR_MAX_RUN_CHARACTERS,
  Mp as EDITOR_NAME_ARRANGEMENT_HIDDEN_KEY,
  Np as EDITOR_NAME_ARRANGEMENT_ORDER_KEY,
  $p as EDITOR_NAME_PART_KEYS,
  zp as EDITOR_NO_BREAK_SPACE,
  Hp as EDITOR_OBJECT_REPLACEMENT_CHARACTER,
  $n as EDITOR_OUTLINED_ATTR,
  Uc as EDITOR_OVERFLOWING_ATTR,
  ho as EDITOR_OVERFLOW_WRAP_ATTR,
  vi as EDITOR_RESOLVED_LAYER_ORDER,
  de as EDITOR_RULE_BLOCK_CLASS_NAME,
  Ti as EDITOR_RULE_LINE_SELECTOR,
  oe as EDITOR_RULE_SELECTED_ATTR,
  kt as EDITOR_RUN_KIND_ATTR,
  go as EDITOR_RUN_ORDINAL_ATTR,
  ct as EDITOR_RUN_ORDINAL_DATASET_KEY,
  Wp as EDITOR_RUN_TEXT_PROPS,
  Kp as EDITOR_SCOPE_SPECIFICITY,
  En as EDITOR_SELECTION_HIGHLIGHT,
  jp as EDITOR_SERVICE_LINE_PARTS,
  Gp as EDITOR_SERVICE_TEMPLATE_CONTENT_KIND,
  Vp as EDITOR_SERVICE_TEMPLATE_CONTENT_VERSION,
  Up as EDITOR_SOFT_HYPHEN,
  Zh as EDITOR_SUPPORTED_INPUT_TYPES,
  St as EDITOR_TABLE_CARET_ATTR,
  Mt as EDITOR_TABLE_SELECTED_ATTR,
  Yp as EDITOR_TERMINAL_PUNCTUATION,
  H as EDITOR_TEXT_BLOCK_SELECTOR,
  fa as EDITOR_TEXT_BOX_SEED_TEXT,
  fo as EDITOR_TEXT_BOX_SELECTOR,
  B as EDITOR_TEXT_RUN_SELECTOR,
  Vh as EDITOR_TEXT_SCALING_ENABLED,
  up as EDITOR_TEXT_SHADOW_SEED,
  Uh as EDITOR_TEXT_SIZING_MODES,
  Fa as EDITOR_TEXT_SIZING_SHRINK,
  qp as EDITOR_WORD_JOINER,
  Xp as EDITOR_ZERO_WIDTH_SPACE,
  od as appendEditorCaretableParagraph,
  ee as applyEditorContentTracked,
  Ga as applyEditorLetterSpacingToTarget,
  ns as applyEditorPerRunStyleToTarget,
  ja as applyEditorSizeToTarget,
  vn as applyEditorStyle,
  fn as applyEditorStyleEdit,
  te as applyEditorStyleTracked,
  tc as bakeEditorTextCase,
  qi as buildEditorBoxProjectionIndex,
  hi as canonicalizeEditorBlockPieces,
  Rd as canonicalizeEditorBlockText,
  Bh as canonicalizeEditorText,
  Qh as canonicalizeEditorTextBoxText,
  Ha as clampEditorAuthoredPt,
  pr as clampEditorLetterSpacingPt,
  Yh as clampEditorStrokeWidthPt,
  Rn as classifyEditorInputType,
  rd as compactEditorCaretableParagraph,
  P as compareEditorPositions,
  rs as composeEditorSteps,
  ud as convertEditorFieldToText,
  he as deleteEditorBackward,
  Je as deleteEditorForward,
  Lo as deleteEditorRange,
  A as editorBlockCaretLength,
  ke as editorBlockCharacterLayers,
  Jl as editorBlockFloorCss,
  fc as editorBlockLayerFromStylingInput,
  _l as editorBlockLayerFromStylingRecord,
  dc as editorBlockStylingInputFromRecord,
  oo as editorBlockStylingInputFromSpec,
  lo as editorBoxClass,
  hc as editorBoxLayerFromInput,
  tp as editorBoxStateOf,
  Jp as editorCaseDataWithoutNameArrangement,
  Zp as editorCaseNameArrangement,
  Qp as editorCaseServices,
  zl as editorCharClassOf,
  Hl as editorCharMapsTo,
  tg as editorCharacterClassPattern,
  be as editorCharacterLayerFromStylingInput,
  Ll as editorCharacterLayerFromStylingRecord,
  ac as editorCharacterStylingInputFromRecord,
  wt as editorCharacterStylingInputFromSpec,
  eg as editorCharactersOfClass,
  Cl as editorColorRecordToCss,
  ne as editorColorSpecFromCss,
  sc as editorColorSpecToCss,
  Ua as editorContentStep,
  Lh as editorDispositionOf,
  Si as editorDocumentContextFromBundle,
  vd as editorEndsAtWordBreak,
  Ds as editorFaceFailed,
  zo as editorFaceInFlight,
  Os as editorFaceLoading,
  Sa as editorFieldCaretSpans,
  ng as editorFieldCatalogEntry,
  cp as editorFieldOutlinePaths,
  og as editorFieldParamSpec,
  lr as editorFitCeiling,
  cr as editorFitWritesSizes,
  Cd as editorFrameCanGrow,
  ep as editorFrameHeightPx,
  kf as editorHeldFrameHeight,
  rg as editorLayerMayCarry,
  Ji as editorMaxSizeScale,
  ig as editorNameArrangementCaseData,
  gt as editorPaintedColor,
  Ge as editorPaintedFontStack,
  le as editorPaintedSizePt,
  Vt as editorParagraphPieces,
  vt as editorPxToPt,
  Yi as editorRunAtOffset,
  U as editorRunCaretWidth,
  Zl as editorRunFloorCss,
  io as editorRunFromPiece,
  yt as editorRunStartOffset,
  ka as editorRunsCoveredByRange,
  Nl as editorScanSuppressesBlock,
  Gh as editorSelectionSplitsField,
  sg as editorServiceColumnKey,
  lg as editorServiceIndexKey,
  cg as editorServiceTemplateContentFromBlocks,
  qh as editorStyleStep,
  gi as editorStylingInputSetsAnything,
  ag as editorTableCellCountKey,
  dg as editorTableCellKey,
  ug as editorTableRowTypeIndexKey,
  fg as editorTableRowTypes,
  Nh as editorTextBoxDocumentFromRecord,
  Pc as editorTextBoxDocumentToInput,
  $h as editorTextBoxDocumentsFromBundle,
  cl as editorTextBoxFacesFailed,
  hf as editorTextBoxFacesLoaded,
  $r as editorTextBoxFacesWriteSizes,
  pf as editorTextBoxFailedFamilies,
  Ln as editorTextBoxFrameFollowsText,
  zh as editorTextBoxLineHeightPx,
  sp as editorTextBoxLoadsSettled,
  fp as editorTextBoxStyleActions,
  ta as editorTextBoxStylesheet,
  $ as editorTextClusters,
  gp as editorTextGeometryHash,
  wa as editorTextSizingModeOf,
  Pa as editorTextSizingOf,
  kr as editorWordBoundsInBlock,
  Wh as editorWriteTarget,
  Xh as emptyEditorHistory,
  ri as enforceEditorLayerCapability,
  bl as ensureEditorTextBoxResolvedStyles,
  bh as ensureEditorTextBoxStylesheet,
  hp as fitRenderedEditorTextBox,
  hg as formatEditorMiddleInitial,
  Tl as gateEditorPieces,
  Ih as groupEditorGlyphLines,
  ms as insertEditorCaseDetailTable,
  gs as insertEditorField,
  bs as insertEditorFieldParagraphs,
  ps as insertEditorRule,
  $e as insertEditorText,
  rp as inspectEditorTextBoxElement,
  lp as installEditorBoxFaceRefit,
  op as installEditorFaceCoverage,
  df as installEditorFontRefitTrigger,
  ip as installEditorFontRetry,
  C as isAtomicEditorBlockKind,
  pg as isDefaultEditorNameParams,
  D as isEditorCaret,
  ap as isEditorCornerHandle,
  gg as isEditorFieldKey,
  mg as isEditorNamePart,
  Kh as isEditorTextBoxPlaceholderOnly,
  Hn as isEmptyEditorTextBox,
  rr as isLegalEditorPosition,
  jh as isWellFormedEditorSelection,
  bg as joinEditorNameParts,
  Ca as largestPositive,
  mp as measureEditorGlyphGeometry,
  ji as mergeEditorBlockStyling,
  ua as mergeEditorBoxStyling,
  Z as mergeEditorCharacterStyling,
  ht as mergeTopEditorSteps,
  dp as mountEditorTextBox,
  Mh as normalizeAndProjectEditorFieldLines,
  cn as normalizeEditorFieldLines,
  Td as normalizeEditorTextBoxFieldLines,
  V as orderEditorPositions,
  no as orderedEditorLayers,
  xg as parseEditorServiceTemplateContent,
  pp as previewRenderedEditorTextBoxCornerScale,
  li as projectEditorBlockPieces,
  za as quantizeEditorAuthoredPt,
  Wa as quantizeEditorLetterSpacingPt,
  Ka as quantizeEditorStrokeWidthPt,
  Nu as readEditorPaintedBlock,
  $u as readEditorPaintedBox,
  Jn as readEditorPaintedRun,
  zu as readEditorPaintedTextBox,
  Ad as rebaseEditorOffsetAcrossFieldSettle,
  ma as rebaseEditorPositionAfterRangeDelete,
  qa as recordEditorStep,
  Ct as recordEditorStepCoalescing,
  Za as redoNextEditorStep,
  Hh as renderEditorTextBox,
  Fe as resolveEditorApplyTarget,
  kg as resolveEditorBlockCascade,
  Ia as resolveEditorBlockCharacterStyle,
  ii as resolveEditorBlockStyle,
  yg as resolveEditorBoxCascade,
  Pl as resolveEditorBoxStyle,
  Sg as resolveEditorCharacterCascade,
  Pt as resolveEditorCharacterStyle,
  Eg as resolveEditorCompositeName,
  Fl as resolveEditorField,
  Jh as resolveEditorFieldModalTarget,
  Ig as resolveEditorFinalResting,
  vg as resolveEditorServiceBlock,
  wg as resolveEditorServiceColumn,
  Rg as resolveEditorStyling,
  ci as resolveEditorTableCells,
  je as resolveEditorTextBoxDocument,
  va as resolveProjectedEditorTextBoxDocument,
  ki as resolveProjectedEditorTextBoxDocumentWith,
  sl as retryEditorFaces,
  _s as scaleEditorTextBoxAuthoredSizes,
  np as scaleEditorTextBoxDocumentSizes,
  ai as scanEditorBlockProjection,
  Qt as sealEditorHistory,
  ys as setEditorFieldParameters,
  nd as setEditorParagraphRole,
  bf as settleEditorTextBoxFonts,
  ce as splitEditorBlock,
  Dh as traceEditorBlockCascade,
  rc as traceEditorCharacterCascade,
  Oh as traceEditorCharacterProperty,
  Ja as undoLastEditorStep,
  Eh as unionEditorGeometryRects,
  Tg as validateEditorFieldParams,
  Ag as visibleEditorNameParts
};
